window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */



theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



/*================ AL - common ================*/

/* == jquery mousewheel plugin == Version: 3.1.13, License: MIT License (MIT) */

!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?module.exports=a:a(jQuery)}(function(a){function b(b){var g=b||window.event,h=i.call(arguments,1),j=0,l=0,m=0,n=0,o=0,p=0;if(b=a.event.fix(g),b.type="mousewheel","detail"in g&&(m=-1*g.detail),"wheelDelta"in g&&(m=g.wheelDelta),"wheelDeltaY"in g&&(m=g.wheelDeltaY),"wheelDeltaX"in g&&(l=-1*g.wheelDeltaX),"axis"in g&&g.axis===g.HORIZONTAL_AXIS&&(l=-1*m,m=0),j=0===m?l:m,"deltaY"in g&&(m=-1*g.deltaY,j=m),"deltaX"in g&&(l=g.deltaX,0===m&&(j=-1*l)),0!==m||0!==l){if(1===g.deltaMode){var q=a.data(this,"mousewheel-line-height");j*=q,m*=q,l*=q}else if(2===g.deltaMode){var r=a.data(this,"mousewheel-page-height");j*=r,m*=r,l*=r}if(n=Math.max(Math.abs(m),Math.abs(l)),(!f||f>n)&&(f=n,d(g,n)&&(f/=40)),d(g,n)&&(j/=40,l/=40,m/=40),j=Math[j>=1?"floor":"ceil"](j/f),l=Math[l>=1?"floor":"ceil"](l/f),m=Math[m>=1?"floor":"ceil"](m/f),k.settings.normalizeOffset&&this.getBoundingClientRect){var s=this.getBoundingClientRect();o=b.clientX-s.left,p=b.clientY-s.top}return b.deltaX=l,b.deltaY=m,b.deltaFactor=f,b.offsetX=o,b.offsetY=p,b.deltaMode=0,h.unshift(b,j,l,m),e&&clearTimeout(e),e=setTimeout(c,200),(a.event.dispatch||a.event.handle).apply(this,h)}}function c(){f=null}function d(a,b){return k.settings.adjustOldDeltas&&"mousewheel"===a.type&&b%120===0}var e,f,g=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"],h="onwheel"in document||document.documentMode>=9?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"],i=Array.prototype.slice;if(a.event.fixHooks)for(var j=g.length;j;)a.event.fixHooks[g[--j]]=a.event.mouseHooks;var k=a.event.special.mousewheel={version:"3.1.12",setup:function(){if(this.addEventListener)for(var c=h.length;c;)this.addEventListener(h[--c],b,!1);else this.onmousewheel=b;a.data(this,"mousewheel-line-height",k.getLineHeight(this)),a.data(this,"mousewheel-page-height",k.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var c=h.length;c;)this.removeEventListener(h[--c],b,!1);else this.onmousewheel=null;a.removeData(this,"mousewheel-line-height"),a.removeData(this,"mousewheel-page-height")},getLineHeight:function(b){var c=a(b),d=c["offsetParent"in a.fn?"offsetParent":"parent"]();return d.length||(d=a("body")),parseInt(d.css("fontSize"),10)||parseInt(c.css("fontSize"),10)||16},getPageHeight:function(b){return a(b).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};a.fn.extend({mousewheel:function(a){return a?this.bind("mousewheel",a):this.trigger("mousewheel")},unmousewheel:function(a){return this.unbind("mousewheel",a)}})});!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?module.exports=a:a(jQuery)}(function(a){function b(b){var g=b||window.event,h=i.call(arguments,1),j=0,l=0,m=0,n=0,o=0,p=0;if(b=a.event.fix(g),b.type="mousewheel","detail"in g&&(m=-1*g.detail),"wheelDelta"in g&&(m=g.wheelDelta),"wheelDeltaY"in g&&(m=g.wheelDeltaY),"wheelDeltaX"in g&&(l=-1*g.wheelDeltaX),"axis"in g&&g.axis===g.HORIZONTAL_AXIS&&(l=-1*m,m=0),j=0===m?l:m,"deltaY"in g&&(m=-1*g.deltaY,j=m),"deltaX"in g&&(l=g.deltaX,0===m&&(j=-1*l)),0!==m||0!==l){if(1===g.deltaMode){var q=a.data(this,"mousewheel-line-height");j*=q,m*=q,l*=q}else if(2===g.deltaMode){var r=a.data(this,"mousewheel-page-height");j*=r,m*=r,l*=r}if(n=Math.max(Math.abs(m),Math.abs(l)),(!f||f>n)&&(f=n,d(g,n)&&(f/=40)),d(g,n)&&(j/=40,l/=40,m/=40),j=Math[j>=1?"floor":"ceil"](j/f),l=Math[l>=1?"floor":"ceil"](l/f),m=Math[m>=1?"floor":"ceil"](m/f),k.settings.normalizeOffset&&this.getBoundingClientRect){var s=this.getBoundingClientRect();o=b.clientX-s.left,p=b.clientY-s.top}return b.deltaX=l,b.deltaY=m,b.deltaFactor=f,b.offsetX=o,b.offsetY=p,b.deltaMode=0,h.unshift(b,j,l,m),e&&clearTimeout(e),e=setTimeout(c,200),(a.event.dispatch||a.event.handle).apply(this,h)}}function c(){f=null}function d(a,b){return k.settings.adjustOldDeltas&&"mousewheel"===a.type&&b%120===0}var e,f,g=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"],h="onwheel"in document||document.documentMode>=9?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"],i=Array.prototype.slice;if(a.event.fixHooks)for(var j=g.length;j;)a.event.fixHooks[g[--j]]=a.event.mouseHooks;var k=a.event.special.mousewheel={version:"3.1.12",setup:function(){if(this.addEventListener)for(var c=h.length;c;)this.addEventListener(h[--c],b,!1);else this.onmousewheel=b;a.data(this,"mousewheel-line-height",k.getLineHeight(this)),a.data(this,"mousewheel-page-height",k.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var c=h.length;c;)this.removeEventListener(h[--c],b,!1);else this.onmousewheel=null;a.removeData(this,"mousewheel-line-height"),a.removeData(this,"mousewheel-page-height")},getLineHeight:function(b){var c=a(b),d=c["offsetParent"in a.fn?"offsetParent":"parent"]();return d.length||(d=a("body")),parseInt(d.css("fontSize"),10)||parseInt(c.css("fontSize"),10)||16},getPageHeight:function(b){return a(b).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};a.fn.extend({mousewheel:function(a){return a?this.bind("mousewheel",a):this.trigger("mousewheel")},unmousewheel:function(a){return this.unbind("mousewheel",a)}})});

/* == malihu jquery custom scrollbar plugin == Version: 3.1.5, License: MIT License (MIT) */

!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"undefined"!=typeof module&&module.exports?module.exports=e:e(jQuery,window,document)}(function(e){!function(t){var o="function"==typeof define&&define.amd,a="undefined"!=typeof module&&module.exports,n="https:"==document.location.protocol?"https:":"http:",i="cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js";o||(a?require("jquery-mousewheel")(e):e.event.special.mousewheel||e("head").append(decodeURI("%3Cscript src="+n+"//"+i+"%3E%3C/script%3E"))),t()}(function(){var t,o="mCustomScrollbar",a="mCS",n=".mCustomScrollbar",i={setTop:0,setLeft:0,axis:"y",scrollbarPosition:"inside",scrollInertia:950,autoDraggerLength:!0,alwaysShowScrollbar:0,snapOffset:0,mouseWheel:{enable:!0,scrollAmount:"auto",axis:"y",deltaFactor:"auto",disableOver:["select","option","keygen","datalist","textarea"]},scrollButtons:{scrollType:"stepless",scrollAmount:"auto"},keyboard:{enable:!0,scrollType:"stepless",scrollAmount:"auto"},contentTouchScroll:25,documentTouchScroll:!0,advanced:{autoScrollOnFocus:"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",updateOnContentResize:!0,updateOnImageLoad:"auto",autoUpdateTimeout:60},theme:"light",callbacks:{onTotalScrollOffset:0,onTotalScrollBackOffset:0,alwaysTriggerOffsets:!0}},r=0,l={},s=window.attachEvent&&!window.addEventListener?1:0,c=!1,d=["mCSB_dragger_onDrag","mCSB_scrollTools_onDrag","mCS_img_loaded","mCS_disabled","mCS_destroyed","mCS_no_scrollbar","mCS-autoHide","mCS-dir-rtl","mCS_no_scrollbar_y","mCS_no_scrollbar_x","mCS_y_hidden","mCS_x_hidden","mCSB_draggerContainer","mCSB_buttonUp","mCSB_buttonDown","mCSB_buttonLeft","mCSB_buttonRight"],u={init:function(t){var t=e.extend(!0,{},i,t),o=f.call(this);if(t.live){var s=t.liveSelector||this.selector||n,c=e(s);if("off"===t.live)return void m(s);l[s]=setTimeout(function(){c.mCustomScrollbar(t),"once"===t.live&&c.length&&m(s)},500)}else m(s);return t.setWidth=t.set_width?t.set_width:t.setWidth,t.setHeight=t.set_height?t.set_height:t.setHeight,t.axis=t.horizontalScroll?"x":p(t.axis),t.scrollInertia=t.scrollInertia>0&&t.scrollInertia<17?17:t.scrollInertia,"object"!=typeof t.mouseWheel&&1==t.mouseWheel&&(t.mouseWheel={enable:!0,scrollAmount:"auto",axis:"y",preventDefault:!1,deltaFactor:"auto",normalizeDelta:!1,invert:!1}),t.mouseWheel.scrollAmount=t.mouseWheelPixels?t.mouseWheelPixels:t.mouseWheel.scrollAmount,t.mouseWheel.normalizeDelta=t.advanced.normalizeMouseWheelDelta?t.advanced.normalizeMouseWheelDelta:t.mouseWheel.normalizeDelta,t.scrollButtons.scrollType=g(t.scrollButtons.scrollType),h(t),e(o).each(function(){var o=e(this);if(!o.data(a)){o.data(a,{idx:++r,opt:t,scrollRatio:{y:null,x:null},overflowed:null,contentReset:{y:null,x:null},bindEvents:!1,tweenRunning:!1,sequential:{},langDir:o.css("direction"),cbOffsets:null,trigger:null,poll:{size:{o:0,n:0},img:{o:0,n:0},change:{o:0,n:0}}});var n=o.data(a),i=n.opt,l=o.data("mcs-axis"),s=o.data("mcs-scrollbar-position"),c=o.data("mcs-theme");l&&(i.axis=l),s&&(i.scrollbarPosition=s),c&&(i.theme=c,h(i)),v.call(this),n&&i.callbacks.onCreate&&"function"==typeof i.callbacks.onCreate&&i.callbacks.onCreate.call(this),e("#mCSB_"+n.idx+"_container img:not(."+d[2]+")").addClass(d[2]),u.update.call(null,o)}})},update:function(t,o){var n=t||f.call(this);return e(n).each(function(){var t=e(this);if(t.data(a)){var n=t.data(a),i=n.opt,r=e("#mCSB_"+n.idx+"_container"),l=e("#mCSB_"+n.idx),s=[e("#mCSB_"+n.idx+"_dragger_vertical"),e("#mCSB_"+n.idx+"_dragger_horizontal")];if(!r.length)return;n.tweenRunning&&Q(t),o&&n&&i.callbacks.onBeforeUpdate&&"function"==typeof i.callbacks.onBeforeUpdate&&i.callbacks.onBeforeUpdate.call(this),t.hasClass(d[3])&&t.removeClass(d[3]),t.hasClass(d[4])&&t.removeClass(d[4]),l.css("max-height","none"),l.height()!==t.height()&&l.css("max-height",t.height()),_.call(this),"y"===i.axis||i.advanced.autoExpandHorizontalScroll||r.css("width",x(r)),n.overflowed=y.call(this),M.call(this),i.autoDraggerLength&&S.call(this),b.call(this),T.call(this);var c=[Math.abs(r[0].offsetTop),Math.abs(r[0].offsetLeft)];"x"!==i.axis&&(n.overflowed[0]?s[0].height()>s[0].parent().height()?B.call(this):(G(t,c[0].toString(),{dir:"y",dur:0,overwrite:"none"}),n.contentReset.y=null):(B.call(this),"y"===i.axis?k.call(this):"yx"===i.axis&&n.overflowed[1]&&G(t,c[1].toString(),{dir:"x",dur:0,overwrite:"none"}))),"y"!==i.axis&&(n.overflowed[1]?s[1].width()>s[1].parent().width()?B.call(this):(G(t,c[1].toString(),{dir:"x",dur:0,overwrite:"none"}),n.contentReset.x=null):(B.call(this),"x"===i.axis?k.call(this):"yx"===i.axis&&n.overflowed[0]&&G(t,c[0].toString(),{dir:"y",dur:0,overwrite:"none"}))),o&&n&&(2===o&&i.callbacks.onImageLoad&&"function"==typeof i.callbacks.onImageLoad?i.callbacks.onImageLoad.call(this):3===o&&i.callbacks.onSelectorChange&&"function"==typeof i.callbacks.onSelectorChange?i.callbacks.onSelectorChange.call(this):i.callbacks.onUpdate&&"function"==typeof i.callbacks.onUpdate&&i.callbacks.onUpdate.call(this)),N.call(this)}})},scrollTo:function(t,o){if("undefined"!=typeof t&&null!=t){var n=f.call(this);return e(n).each(function(){var n=e(this);if(n.data(a)){var i=n.data(a),r=i.opt,l={trigger:"external",scrollInertia:r.scrollInertia,scrollEasing:"mcsEaseInOut",moveDragger:!1,timeout:60,callbacks:!0,onStart:!0,onUpdate:!0,onComplete:!0},s=e.extend(!0,{},l,o),c=Y.call(this,t),d=s.scrollInertia>0&&s.scrollInertia<17?17:s.scrollInertia;c[0]=X.call(this,c[0],"y"),c[1]=X.call(this,c[1],"x"),s.moveDragger&&(c[0]*=i.scrollRatio.y,c[1]*=i.scrollRatio.x),s.dur=ne()?0:d,setTimeout(function(){null!==c[0]&&"undefined"!=typeof c[0]&&"x"!==r.axis&&i.overflowed[0]&&(s.dir="y",s.overwrite="all",G(n,c[0].toString(),s)),null!==c[1]&&"undefined"!=typeof c[1]&&"y"!==r.axis&&i.overflowed[1]&&(s.dir="x",s.overwrite="none",G(n,c[1].toString(),s))},s.timeout)}})}},stop:function(){var t=f.call(this);return e(t).each(function(){var t=e(this);t.data(a)&&Q(t)})},disable:function(t){var o=f.call(this);return e(o).each(function(){var o=e(this);if(o.data(a)){o.data(a);N.call(this,"remove"),k.call(this),t&&B.call(this),M.call(this,!0),o.addClass(d[3])}})},destroy:function(){var t=f.call(this);return e(t).each(function(){var n=e(this);if(n.data(a)){var i=n.data(a),r=i.opt,l=e("#mCSB_"+i.idx),s=e("#mCSB_"+i.idx+"_container"),c=e(".mCSB_"+i.idx+"_scrollbar");r.live&&m(r.liveSelector||e(t).selector),N.call(this,"remove"),k.call(this),B.call(this),n.removeData(a),$(this,"mcs"),c.remove(),s.find("img."+d[2]).removeClass(d[2]),l.replaceWith(s.contents()),n.removeClass(o+" _"+a+"_"+i.idx+" "+d[6]+" "+d[7]+" "+d[5]+" "+d[3]).addClass(d[4])}})}},f=function(){return"object"!=typeof e(this)||e(this).length<1?n:this},h=function(t){var o=["rounded","rounded-dark","rounded-dots","rounded-dots-dark"],a=["rounded-dots","rounded-dots-dark","3d","3d-dark","3d-thick","3d-thick-dark","inset","inset-dark","inset-2","inset-2-dark","inset-3","inset-3-dark"],n=["minimal","minimal-dark"],i=["minimal","minimal-dark"],r=["minimal","minimal-dark"];t.autoDraggerLength=e.inArray(t.theme,o)>-1?!1:t.autoDraggerLength,t.autoExpandScrollbar=e.inArray(t.theme,a)>-1?!1:t.autoExpandScrollbar,t.scrollButtons.enable=e.inArray(t.theme,n)>-1?!1:t.scrollButtons.enable,t.autoHideScrollbar=e.inArray(t.theme,i)>-1?!0:t.autoHideScrollbar,t.scrollbarPosition=e.inArray(t.theme,r)>-1?"outside":t.scrollbarPosition},m=function(e){l[e]&&(clearTimeout(l[e]),$(l,e))},p=function(e){return"yx"===e||"xy"===e||"auto"===e?"yx":"x"===e||"horizontal"===e?"x":"y"},g=function(e){return"stepped"===e||"pixels"===e||"step"===e||"click"===e?"stepped":"stepless"},v=function(){var t=e(this),n=t.data(a),i=n.opt,r=i.autoExpandScrollbar?" "+d[1]+"_expand":"",l=["<div id='mCSB_"+n.idx+"_scrollbar_vertical' class='mCSB_scrollTools mCSB_"+n.idx+"_scrollbar mCS-"+i.theme+" mCSB_scrollTools_vertical"+r+"'><div class='"+d[12]+"'><div id='mCSB_"+n.idx+"_dragger_vertical' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>","<div id='mCSB_"+n.idx+"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_"+n.idx+"_scrollbar mCS-"+i.theme+" mCSB_scrollTools_horizontal"+r+"'><div class='"+d[12]+"'><div id='mCSB_"+n.idx+"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>"],s="yx"===i.axis?"mCSB_vertical_horizontal":"x"===i.axis?"mCSB_horizontal":"mCSB_vertical",c="yx"===i.axis?l[0]+l[1]:"x"===i.axis?l[1]:l[0],u="yx"===i.axis?"<div id='mCSB_"+n.idx+"_container_wrapper' class='mCSB_container_wrapper' />":"",f=i.autoHideScrollbar?" "+d[6]:"",h="x"!==i.axis&&"rtl"===n.langDir?" "+d[7]:"";i.setWidth&&t.css("width",i.setWidth),i.setHeight&&t.css("height",i.setHeight),i.setLeft="y"!==i.axis&&"rtl"===n.langDir?"989999px":i.setLeft,t.addClass(o+" _"+a+"_"+n.idx+f+h).wrapInner("<div id='mCSB_"+n.idx+"' class='mCustomScrollBox mCS-"+i.theme+" "+s+"'><div id='mCSB_"+n.idx+"_container' class='mCSB_container' style='position:relative; top:"+i.setTop+"; left:"+i.setLeft+";' dir='"+n.langDir+"' /></div>");var m=e("#mCSB_"+n.idx),p=e("#mCSB_"+n.idx+"_container");"y"===i.axis||i.advanced.autoExpandHorizontalScroll||p.css("width",x(p)),"outside"===i.scrollbarPosition?("static"===t.css("position")&&t.css("position","relative"),t.css("overflow","visible"),m.addClass("mCSB_outside").after(c)):(m.addClass("mCSB_inside").append(c),p.wrap(u)),w.call(this);var g=[e("#mCSB_"+n.idx+"_dragger_vertical"),e("#mCSB_"+n.idx+"_dragger_horizontal")];g[0].css("min-height",g[0].height()),g[1].css("min-width",g[1].width())},x=function(t){var o=[t[0].scrollWidth,Math.max.apply(Math,t.children().map(function(){return e(this).outerWidth(!0)}).get())],a=t.parent().width();return o[0]>a?o[0]:o[1]>a?o[1]:"100%"},_=function(){var t=e(this),o=t.data(a),n=o.opt,i=e("#mCSB_"+o.idx+"_container");if(n.advanced.autoExpandHorizontalScroll&&"y"!==n.axis){i.css({width:"auto","min-width":0,"overflow-x":"scroll"});var r=Math.ceil(i[0].scrollWidth);3===n.advanced.autoExpandHorizontalScroll||2!==n.advanced.autoExpandHorizontalScroll&&r>i.parent().width()?i.css({width:r,"min-width":"100%","overflow-x":"inherit"}):i.css({"overflow-x":"inherit",position:"absolute"}).wrap("<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />").css({width:Math.ceil(i[0].getBoundingClientRect().right+.4)-Math.floor(i[0].getBoundingClientRect().left),"min-width":"100%",position:"relative"}).unwrap()}},w=function(){var t=e(this),o=t.data(a),n=o.opt,i=e(".mCSB_"+o.idx+"_scrollbar:first"),r=oe(n.scrollButtons.tabindex)?"tabindex='"+n.scrollButtons.tabindex+"'":"",l=["<a href='#' class='"+d[13]+"' "+r+" />","<a href='#' class='"+d[14]+"' "+r+" />","<a href='#' class='"+d[15]+"' "+r+" />","<a href='#' class='"+d[16]+"' "+r+" />"],s=["x"===n.axis?l[2]:l[0],"x"===n.axis?l[3]:l[1],l[2],l[3]];n.scrollButtons.enable&&i.prepend(s[0]).append(s[1]).next(".mCSB_scrollTools").prepend(s[2]).append(s[3])},S=function(){var t=e(this),o=t.data(a),n=e("#mCSB_"+o.idx),i=e("#mCSB_"+o.idx+"_container"),r=[e("#mCSB_"+o.idx+"_dragger_vertical"),e("#mCSB_"+o.idx+"_dragger_horizontal")],l=[n.height()/i.outerHeight(!1),n.width()/i.outerWidth(!1)],c=[parseInt(r[0].css("min-height")),Math.round(l[0]*r[0].parent().height()),parseInt(r[1].css("min-width")),Math.round(l[1]*r[1].parent().width())],d=s&&c[1]<c[0]?c[0]:c[1],u=s&&c[3]<c[2]?c[2]:c[3];r[0].css({height:d,"max-height":r[0].parent().height()-10}).find(".mCSB_dragger_bar").css({"line-height":c[0]+"px"}),r[1].css({width:u,"max-width":r[1].parent().width()-10})},b=function(){var t=e(this),o=t.data(a),n=e("#mCSB_"+o.idx),i=e("#mCSB_"+o.idx+"_container"),r=[e("#mCSB_"+o.idx+"_dragger_vertical"),e("#mCSB_"+o.idx+"_dragger_horizontal")],l=[i.outerHeight(!1)-n.height(),i.outerWidth(!1)-n.width()],s=[l[0]/(r[0].parent().height()-r[0].height()),l[1]/(r[1].parent().width()-r[1].width())];o.scrollRatio={y:s[0],x:s[1]}},C=function(e,t,o){var a=o?d[0]+"_expanded":"",n=e.closest(".mCSB_scrollTools");"active"===t?(e.toggleClass(d[0]+" "+a),n.toggleClass(d[1]),e[0]._draggable=e[0]._draggable?0:1):e[0]._draggable||("hide"===t?(e.removeClass(d[0]),n.removeClass(d[1])):(e.addClass(d[0]),n.addClass(d[1])))},y=function(){var t=e(this),o=t.data(a),n=e("#mCSB_"+o.idx),i=e("#mCSB_"+o.idx+"_container"),r=null==o.overflowed?i.height():i.outerHeight(!1),l=null==o.overflowed?i.width():i.outerWidth(!1),s=i[0].scrollHeight,c=i[0].scrollWidth;return s>r&&(r=s),c>l&&(l=c),[r>n.height(),l>n.width()]},B=function(){var t=e(this),o=t.data(a),n=o.opt,i=e("#mCSB_"+o.idx),r=e("#mCSB_"+o.idx+"_container"),l=[e("#mCSB_"+o.idx+"_dragger_vertical"),e("#mCSB_"+o.idx+"_dragger_horizontal")];if(Q(t),("x"!==n.axis&&!o.overflowed[0]||"y"===n.axis&&o.overflowed[0])&&(l[0].add(r).css("top",0),G(t,"_resetY")),"y"!==n.axis&&!o.overflowed[1]||"x"===n.axis&&o.overflowed[1]){var s=dx=0;"rtl"===o.langDir&&(s=i.width()-r.outerWidth(!1),dx=Math.abs(s/o.scrollRatio.x)),r.css("left",s),l[1].css("left",dx),G(t,"_resetX")}},T=function(){function t(){r=setTimeout(function(){e.event.special.mousewheel?(clearTimeout(r),W.call(o[0])):t()},100)}var o=e(this),n=o.data(a),i=n.opt;if(!n.bindEvents){if(I.call(this),i.contentTouchScroll&&D.call(this),E.call(this),i.mouseWheel.enable){var r;t()}P.call(this),U.call(this),i.advanced.autoScrollOnFocus&&H.call(this),i.scrollButtons.enable&&F.call(this),i.keyboard.enable&&q.call(this),n.bindEvents=!0}},k=function(){var t=e(this),o=t.data(a),n=o.opt,i=a+"_"+o.idx,r=".mCSB_"+o.idx+"_scrollbar",l=e("#mCSB_"+o.idx+",#mCSB_"+o.idx+"_container,#mCSB_"+o.idx+"_container_wrapper,"+r+" ."+d[12]+",#mCSB_"+o.idx+"_dragger_vertical,#mCSB_"+o.idx+"_dragger_horizontal,"+r+">a"),s=e("#mCSB_"+o.idx+"_container");n.advanced.releaseDraggableSelectors&&l.add(e(n.advanced.releaseDraggableSelectors)),n.advanced.extraDraggableSelectors&&l.add(e(n.advanced.extraDraggableSelectors)),o.bindEvents&&(e(document).add(e(!A()||top.document)).unbind("."+i),l.each(function(){e(this).unbind("."+i)}),clearTimeout(t[0]._focusTimeout),$(t[0],"_focusTimeout"),clearTimeout(o.sequential.step),$(o.sequential,"step"),clearTimeout(s[0].onCompleteTimeout),$(s[0],"onCompleteTimeout"),o.bindEvents=!1)},M=function(t){var o=e(this),n=o.data(a),i=n.opt,r=e("#mCSB_"+n.idx+"_container_wrapper"),l=r.length?r:e("#mCSB_"+n.idx+"_container"),s=[e("#mCSB_"+n.idx+"_scrollbar_vertical"),e("#mCSB_"+n.idx+"_scrollbar_horizontal")],c=[s[0].find(".mCSB_dragger"),s[1].find(".mCSB_dragger")];"x"!==i.axis&&(n.overflowed[0]&&!t?(s[0].add(c[0]).add(s[0].children("a")).css("display","block"),l.removeClass(d[8]+" "+d[10])):(i.alwaysShowScrollbar?(2!==i.alwaysShowScrollbar&&c[0].css("display","none"),l.removeClass(d[10])):(s[0].css("display","none"),l.addClass(d[10])),l.addClass(d[8]))),"y"!==i.axis&&(n.overflowed[1]&&!t?(s[1].add(c[1]).add(s[1].children("a")).css("display","block"),l.removeClass(d[9]+" "+d[11])):(i.alwaysShowScrollbar?(2!==i.alwaysShowScrollbar&&c[1].css("display","none"),l.removeClass(d[11])):(s[1].css("display","none"),l.addClass(d[11])),l.addClass(d[9]))),n.overflowed[0]||n.overflowed[1]?o.removeClass(d[5]):o.addClass(d[5])},O=function(t){var o=t.type,a=t.target.ownerDocument!==document&&null!==frameElement?[e(frameElement).offset().top,e(frameElement).offset().left]:null,n=A()&&t.target.ownerDocument!==top.document&&null!==frameElement?[e(t.view.frameElement).offset().top,e(t.view.frameElement).offset().left]:[0,0];switch(o){case"pointerdown":case"MSPointerDown":case"pointermove":case"MSPointerMove":case"pointerup":case"MSPointerUp":return a?[t.originalEvent.pageY-a[0]+n[0],t.originalEvent.pageX-a[1]+n[1],!1]:[t.originalEvent.pageY,t.originalEvent.pageX,!1];case"touchstart":case"touchmove":case"touchend":var i=t.originalEvent.touches[0]||t.originalEvent.changedTouches[0],r=t.originalEvent.touches.length||t.originalEvent.changedTouches.length;return t.target.ownerDocument!==document?[i.screenY,i.screenX,r>1]:[i.pageY,i.pageX,r>1];default:return a?[t.pageY-a[0]+n[0],t.pageX-a[1]+n[1],!1]:[t.pageY,t.pageX,!1]}},I=function(){function t(e,t,a,n){if(h[0].idleTimer=d.scrollInertia<233?250:0,o.attr("id")===f[1])var i="x",s=(o[0].offsetLeft-t+n)*l.scrollRatio.x;else var i="y",s=(o[0].offsetTop-e+a)*l.scrollRatio.y;G(r,s.toString(),{dir:i,drag:!0})}var o,n,i,r=e(this),l=r.data(a),d=l.opt,u=a+"_"+l.idx,f=["mCSB_"+l.idx+"_dragger_vertical","mCSB_"+l.idx+"_dragger_horizontal"],h=e("#mCSB_"+l.idx+"_container"),m=e("#"+f[0]+",#"+f[1]),p=d.advanced.releaseDraggableSelectors?m.add(e(d.advanced.releaseDraggableSelectors)):m,g=d.advanced.extraDraggableSelectors?e(!A()||top.document).add(e(d.advanced.extraDraggableSelectors)):e(!A()||top.document);m.bind("contextmenu."+u,function(e){e.preventDefault()}).bind("mousedown."+u+" touchstart."+u+" pointerdown."+u+" MSPointerDown."+u,function(t){if(t.stopImmediatePropagation(),t.preventDefault(),ee(t)){c=!0,s&&(document.onselectstart=function(){return!1}),L.call(h,!1),Q(r),o=e(this);var a=o.offset(),l=O(t)[0]-a.top,u=O(t)[1]-a.left,f=o.height()+a.top,m=o.width()+a.left;f>l&&l>0&&m>u&&u>0&&(n=l,i=u),C(o,"active",d.autoExpandScrollbar)}}).bind("touchmove."+u,function(e){e.stopImmediatePropagation(),e.preventDefault();var a=o.offset(),r=O(e)[0]-a.top,l=O(e)[1]-a.left;t(n,i,r,l)}),e(document).add(g).bind("mousemove."+u+" pointermove."+u+" MSPointerMove."+u,function(e){if(o){var a=o.offset(),r=O(e)[0]-a.top,l=O(e)[1]-a.left;if(n===r&&i===l)return;t(n,i,r,l)}}).add(p).bind("mouseup."+u+" touchend."+u+" pointerup."+u+" MSPointerUp."+u,function(){o&&(C(o,"active",d.autoExpandScrollbar),o=null),c=!1,s&&(document.onselectstart=null),L.call(h,!0)})},D=function(){function o(e){if(!te(e)||c||O(e)[2])return void(t=0);t=1,b=0,C=0,d=1,y.removeClass("mCS_touch_action");var o=I.offset();u=O(e)[0]-o.top,f=O(e)[1]-o.left,z=[O(e)[0],O(e)[1]]}function n(e){if(te(e)&&!c&&!O(e)[2]&&(T.documentTouchScroll||e.preventDefault(),e.stopImmediatePropagation(),(!C||b)&&d)){g=K();var t=M.offset(),o=O(e)[0]-t.top,a=O(e)[1]-t.left,n="mcsLinearOut";if(E.push(o),W.push(a),z[2]=Math.abs(O(e)[0]-z[0]),z[3]=Math.abs(O(e)[1]-z[1]),B.overflowed[0])var i=D[0].parent().height()-D[0].height(),r=u-o>0&&o-u>-(i*B.scrollRatio.y)&&(2*z[3]<z[2]||"yx"===T.axis);if(B.overflowed[1])var l=D[1].parent().width()-D[1].width(),h=f-a>0&&a-f>-(l*B.scrollRatio.x)&&(2*z[2]<z[3]||"yx"===T.axis);r||h?(U||e.preventDefault(),b=1):(C=1,y.addClass("mCS_touch_action")),U&&e.preventDefault(),w="yx"===T.axis?[u-o,f-a]:"x"===T.axis?[null,f-a]:[u-o,null],I[0].idleTimer=250,B.overflowed[0]&&s(w[0],R,n,"y","all",!0),B.overflowed[1]&&s(w[1],R,n,"x",L,!0)}}function i(e){if(!te(e)||c||O(e)[2])return void(t=0);t=1,e.stopImmediatePropagation(),Q(y),p=K();var o=M.offset();h=O(e)[0]-o.top,m=O(e)[1]-o.left,E=[],W=[]}function r(e){if(te(e)&&!c&&!O(e)[2]){d=0,e.stopImmediatePropagation(),b=0,C=0,v=K();var t=M.offset(),o=O(e)[0]-t.top,a=O(e)[1]-t.left;if(!(v-g>30)){_=1e3/(v-p);var n="mcsEaseOut",i=2.5>_,r=i?[E[E.length-2],W[W.length-2]]:[0,0];x=i?[o-r[0],a-r[1]]:[o-h,a-m];var u=[Math.abs(x[0]),Math.abs(x[1])];_=i?[Math.abs(x[0]/4),Math.abs(x[1]/4)]:[_,_];var f=[Math.abs(I[0].offsetTop)-x[0]*l(u[0]/_[0],_[0]),Math.abs(I[0].offsetLeft)-x[1]*l(u[1]/_[1],_[1])];w="yx"===T.axis?[f[0],f[1]]:"x"===T.axis?[null,f[1]]:[f[0],null],S=[4*u[0]+T.scrollInertia,4*u[1]+T.scrollInertia];var y=parseInt(T.contentTouchScroll)||0;w[0]=u[0]>y?w[0]:0,w[1]=u[1]>y?w[1]:0,B.overflowed[0]&&s(w[0],S[0],n,"y",L,!1),B.overflowed[1]&&s(w[1],S[1],n,"x",L,!1)}}}function l(e,t){var o=[1.5*t,2*t,t/1.5,t/2];return e>90?t>4?o[0]:o[3]:e>60?t>3?o[3]:o[2]:e>30?t>8?o[1]:t>6?o[0]:t>4?t:o[2]:t>8?t:o[3]}function s(e,t,o,a,n,i){e&&G(y,e.toString(),{dur:t,scrollEasing:o,dir:a,overwrite:n,drag:i})}var d,u,f,h,m,p,g,v,x,_,w,S,b,C,y=e(this),B=y.data(a),T=B.opt,k=a+"_"+B.idx,M=e("#mCSB_"+B.idx),I=e("#mCSB_"+B.idx+"_container"),D=[e("#mCSB_"+B.idx+"_dragger_vertical"),e("#mCSB_"+B.idx+"_dragger_horizontal")],E=[],W=[],R=0,L="yx"===T.axis?"none":"all",z=[],P=I.find("iframe"),H=["touchstart."+k+" pointerdown."+k+" MSPointerDown."+k,"touchmove."+k+" pointermove."+k+" MSPointerMove."+k,"touchend."+k+" pointerup."+k+" MSPointerUp."+k],U=void 0!==document.body.style.touchAction&&""!==document.body.style.touchAction;I.bind(H[0],function(e){o(e)}).bind(H[1],function(e){n(e)}),M.bind(H[0],function(e){i(e)}).bind(H[2],function(e){r(e)}),P.length&&P.each(function(){e(this).bind("load",function(){A(this)&&e(this.contentDocument||this.contentWindow.document).bind(H[0],function(e){o(e),i(e)}).bind(H[1],function(e){n(e)}).bind(H[2],function(e){r(e)})})})},E=function(){function o(){return window.getSelection?window.getSelection().toString():document.selection&&"Control"!=document.selection.type?document.selection.createRange().text:0}function n(e,t,o){d.type=o&&i?"stepped":"stepless",d.scrollAmount=10,j(r,e,t,"mcsLinearOut",o?60:null)}var i,r=e(this),l=r.data(a),s=l.opt,d=l.sequential,u=a+"_"+l.idx,f=e("#mCSB_"+l.idx+"_container"),h=f.parent();f.bind("mousedown."+u,function(){t||i||(i=1,c=!0)}).add(document).bind("mousemove."+u,function(e){if(!t&&i&&o()){var a=f.offset(),r=O(e)[0]-a.top+f[0].offsetTop,c=O(e)[1]-a.left+f[0].offsetLeft;r>0&&r<h.height()&&c>0&&c<h.width()?d.step&&n("off",null,"stepped"):("x"!==s.axis&&l.overflowed[0]&&(0>r?n("on",38):r>h.height()&&n("on",40)),"y"!==s.axis&&l.overflowed[1]&&(0>c?n("on",37):c>h.width()&&n("on",39)))}}).bind("mouseup."+u+" dragend."+u,function(){t||(i&&(i=0,n("off",null)),c=!1)})},W=function(){function t(t,a){if(Q(o),!z(o,t.target)){var r="auto"!==i.mouseWheel.deltaFactor?parseInt(i.mouseWheel.deltaFactor):s&&t.deltaFactor<100?100:t.deltaFactor||100,d=i.scrollInertia;if("x"===i.axis||"x"===i.mouseWheel.axis)var u="x",f=[Math.round(r*n.scrollRatio.x),parseInt(i.mouseWheel.scrollAmount)],h="auto"!==i.mouseWheel.scrollAmount?f[1]:f[0]>=l.width()?.9*l.width():f[0],m=Math.abs(e("#mCSB_"+n.idx+"_container")[0].offsetLeft),p=c[1][0].offsetLeft,g=c[1].parent().width()-c[1].width(),v="y"===i.mouseWheel.axis?t.deltaY||a:t.deltaX;else var u="y",f=[Math.round(r*n.scrollRatio.y),parseInt(i.mouseWheel.scrollAmount)],h="auto"!==i.mouseWheel.scrollAmount?f[1]:f[0]>=l.height()?.9*l.height():f[0],m=Math.abs(e("#mCSB_"+n.idx+"_container")[0].offsetTop),p=c[0][0].offsetTop,g=c[0].parent().height()-c[0].height(),v=t.deltaY||a;"y"===u&&!n.overflowed[0]||"x"===u&&!n.overflowed[1]||((i.mouseWheel.invert||t.webkitDirectionInvertedFromDevice)&&(v=-v),i.mouseWheel.normalizeDelta&&(v=0>v?-1:1),(v>0&&0!==p||0>v&&p!==g||i.mouseWheel.preventDefault)&&(t.stopImmediatePropagation(),t.preventDefault()),t.deltaFactor<5&&!i.mouseWheel.normalizeDelta&&(h=t.deltaFactor,d=17),G(o,(m-v*h).toString(),{dir:u,dur:d}))}}if(e(this).data(a)){var o=e(this),n=o.data(a),i=n.opt,r=a+"_"+n.idx,l=e("#mCSB_"+n.idx),c=[e("#mCSB_"+n.idx+"_dragger_vertical"),e("#mCSB_"+n.idx+"_dragger_horizontal")],d=e("#mCSB_"+n.idx+"_container").find("iframe");d.length&&d.each(function(){e(this).bind("load",function(){A(this)&&e(this.contentDocument||this.contentWindow.document).bind("mousewheel."+r,function(e,o){t(e,o)})})}),l.bind("mousewheel."+r,function(e,o){t(e,o)})}},R=new Object,A=function(t){var o=!1,a=!1,n=null;if(void 0===t?a="#empty":void 0!==e(t).attr("id")&&(a=e(t).attr("id")),a!==!1&&void 0!==R[a])return R[a];if(t){try{var i=t.contentDocument||t.contentWindow.document;n=i.body.innerHTML}catch(r){}o=null!==n}else{try{var i=top.document;n=i.body.innerHTML}catch(r){}o=null!==n}return a!==!1&&(R[a]=o),o},L=function(e){var t=this.find("iframe");if(t.length){var o=e?"auto":"none";t.css("pointer-events",o)}},z=function(t,o){var n=o.nodeName.toLowerCase(),i=t.data(a).opt.mouseWheel.disableOver,r=["select","textarea"];return e.inArray(n,i)>-1&&!(e.inArray(n,r)>-1&&!e(o).is(":focus"))},P=function(){var t,o=e(this),n=o.data(a),i=a+"_"+n.idx,r=e("#mCSB_"+n.idx+"_container"),l=r.parent(),s=e(".mCSB_"+n.idx+"_scrollbar ."+d[12]);s.bind("mousedown."+i+" touchstart."+i+" pointerdown."+i+" MSPointerDown."+i,function(o){c=!0,e(o.target).hasClass("mCSB_dragger")||(t=1)}).bind("touchend."+i+" pointerup."+i+" MSPointerUp."+i,function(){c=!1}).bind("click."+i,function(a){if(t&&(t=0,e(a.target).hasClass(d[12])||e(a.target).hasClass("mCSB_draggerRail"))){Q(o);var i=e(this),s=i.find(".mCSB_dragger");if(i.parent(".mCSB_scrollTools_horizontal").length>0){if(!n.overflowed[1])return;var c="x",u=a.pageX>s.offset().left?-1:1,f=Math.abs(r[0].offsetLeft)-u*(.9*l.width())}else{if(!n.overflowed[0])return;var c="y",u=a.pageY>s.offset().top?-1:1,f=Math.abs(r[0].offsetTop)-u*(.9*l.height())}G(o,f.toString(),{dir:c,scrollEasing:"mcsEaseInOut"})}})},H=function(){var t=e(this),o=t.data(a),n=o.opt,i=a+"_"+o.idx,r=e("#mCSB_"+o.idx+"_container"),l=r.parent();r.bind("focusin."+i,function(){var o=e(document.activeElement),a=r.find(".mCustomScrollBox").length,i=0;o.is(n.advanced.autoScrollOnFocus)&&(Q(t),clearTimeout(t[0]._focusTimeout),t[0]._focusTimer=a?(i+17)*a:0,t[0]._focusTimeout=setTimeout(function(){var e=[ae(o)[0],ae(o)[1]],a=[r[0].offsetTop,r[0].offsetLeft],s=[a[0]+e[0]>=0&&a[0]+e[0]<l.height()-o.outerHeight(!1),a[1]+e[1]>=0&&a[0]+e[1]<l.width()-o.outerWidth(!1)],c="yx"!==n.axis||s[0]||s[1]?"all":"none";"x"===n.axis||s[0]||G(t,e[0].toString(),{dir:"y",scrollEasing:"mcsEaseInOut",overwrite:c,dur:i}),"y"===n.axis||s[1]||G(t,e[1].toString(),{dir:"x",scrollEasing:"mcsEaseInOut",overwrite:c,dur:i})},t[0]._focusTimer))})},U=function(){var t=e(this),o=t.data(a),n=a+"_"+o.idx,i=e("#mCSB_"+o.idx+"_container").parent();i.bind("scroll."+n,function(){0===i.scrollTop()&&0===i.scrollLeft()||e(".mCSB_"+o.idx+"_scrollbar").css("visibility","hidden")})},F=function(){var t=e(this),o=t.data(a),n=o.opt,i=o.sequential,r=a+"_"+o.idx,l=".mCSB_"+o.idx+"_scrollbar",s=e(l+">a");s.bind("contextmenu."+r,function(e){e.preventDefault()}).bind("mousedown."+r+" touchstart."+r+" pointerdown."+r+" MSPointerDown."+r+" mouseup."+r+" touchend."+r+" pointerup."+r+" MSPointerUp."+r+" mouseout."+r+" pointerout."+r+" MSPointerOut."+r+" click."+r,function(a){function r(e,o){i.scrollAmount=n.scrollButtons.scrollAmount,j(t,e,o)}if(a.preventDefault(),ee(a)){var l=e(this).attr("class");switch(i.type=n.scrollButtons.scrollType,a.type){case"mousedown":case"touchstart":case"pointerdown":case"MSPointerDown":if("stepped"===i.type)return;c=!0,o.tweenRunning=!1,r("on",l);break;case"mouseup":case"touchend":case"pointerup":case"MSPointerUp":case"mouseout":case"pointerout":case"MSPointerOut":if("stepped"===i.type)return;c=!1,i.dir&&r("off",l);break;case"click":if("stepped"!==i.type||o.tweenRunning)return;r("on",l)}}})},q=function(){function t(t){function a(e,t){r.type=i.keyboard.scrollType,r.scrollAmount=i.keyboard.scrollAmount,"stepped"===r.type&&n.tweenRunning||j(o,e,t)}switch(t.type){case"blur":n.tweenRunning&&r.dir&&a("off",null);break;case"keydown":case"keyup":var l=t.keyCode?t.keyCode:t.which,s="on";if("x"!==i.axis&&(38===l||40===l)||"y"!==i.axis&&(37===l||39===l)){if((38===l||40===l)&&!n.overflowed[0]||(37===l||39===l)&&!n.overflowed[1])return;"keyup"===t.type&&(s="off"),e(document.activeElement).is(u)||(t.preventDefault(),t.stopImmediatePropagation(),a(s,l))}else if(33===l||34===l){if((n.overflowed[0]||n.overflowed[1])&&(t.preventDefault(),t.stopImmediatePropagation()),"keyup"===t.type){Q(o);var f=34===l?-1:1;if("x"===i.axis||"yx"===i.axis&&n.overflowed[1]&&!n.overflowed[0])var h="x",m=Math.abs(c[0].offsetLeft)-f*(.9*d.width());else var h="y",m=Math.abs(c[0].offsetTop)-f*(.9*d.height());G(o,m.toString(),{dir:h,scrollEasing:"mcsEaseInOut"})}}else if((35===l||36===l)&&!e(document.activeElement).is(u)&&((n.overflowed[0]||n.overflowed[1])&&(t.preventDefault(),t.stopImmediatePropagation()),"keyup"===t.type)){if("x"===i.axis||"yx"===i.axis&&n.overflowed[1]&&!n.overflowed[0])var h="x",m=35===l?Math.abs(d.width()-c.outerWidth(!1)):0;else var h="y",m=35===l?Math.abs(d.height()-c.outerHeight(!1)):0;G(o,m.toString(),{dir:h,scrollEasing:"mcsEaseInOut"})}}}var o=e(this),n=o.data(a),i=n.opt,r=n.sequential,l=a+"_"+n.idx,s=e("#mCSB_"+n.idx),c=e("#mCSB_"+n.idx+"_container"),d=c.parent(),u="input,textarea,select,datalist,keygen,[contenteditable='true']",f=c.find("iframe"),h=["blur."+l+" keydown."+l+" keyup."+l];f.length&&f.each(function(){e(this).bind("load",function(){A(this)&&e(this.contentDocument||this.contentWindow.document).bind(h[0],function(e){t(e)})})}),s.attr("tabindex","0").bind(h[0],function(e){t(e)})},j=function(t,o,n,i,r){function l(e){u.snapAmount&&(f.scrollAmount=u.snapAmount instanceof Array?"x"===f.dir[0]?u.snapAmount[1]:u.snapAmount[0]:u.snapAmount);var o="stepped"!==f.type,a=r?r:e?o?p/1.5:g:1e3/60,n=e?o?7.5:40:2.5,s=[Math.abs(h[0].offsetTop),Math.abs(h[0].offsetLeft)],d=[c.scrollRatio.y>10?10:c.scrollRatio.y,c.scrollRatio.x>10?10:c.scrollRatio.x],m="x"===f.dir[0]?s[1]+f.dir[1]*(d[1]*n):s[0]+f.dir[1]*(d[0]*n),v="x"===f.dir[0]?s[1]+f.dir[1]*parseInt(f.scrollAmount):s[0]+f.dir[1]*parseInt(f.scrollAmount),x="auto"!==f.scrollAmount?v:m,_=i?i:e?o?"mcsLinearOut":"mcsEaseInOut":"mcsLinear",w=!!e;return e&&17>a&&(x="x"===f.dir[0]?s[1]:s[0]),G(t,x.toString(),{dir:f.dir[0],scrollEasing:_,dur:a,onComplete:w}),e?void(f.dir=!1):(clearTimeout(f.step),void(f.step=setTimeout(function(){l()},a)))}function s(){clearTimeout(f.step),$(f,"step"),Q(t)}var c=t.data(a),u=c.opt,f=c.sequential,h=e("#mCSB_"+c.idx+"_container"),m="stepped"===f.type,p=u.scrollInertia<26?26:u.scrollInertia,g=u.scrollInertia<1?17:u.scrollInertia;switch(o){case"on":if(f.dir=[n===d[16]||n===d[15]||39===n||37===n?"x":"y",n===d[13]||n===d[15]||38===n||37===n?-1:1],Q(t),oe(n)&&"stepped"===f.type)return;l(m);break;case"off":s(),(m||c.tweenRunning&&f.dir)&&l(!0)}},Y=function(t){var o=e(this).data(a).opt,n=[];return"function"==typeof t&&(t=t()),t instanceof Array?n=t.length>1?[t[0],t[1]]:"x"===o.axis?[null,t[0]]:[t[0],null]:(n[0]=t.y?t.y:t.x||"x"===o.axis?null:t,n[1]=t.x?t.x:t.y||"y"===o.axis?null:t),"function"==typeof n[0]&&(n[0]=n[0]()),"function"==typeof n[1]&&(n[1]=n[1]()),n},X=function(t,o){if(null!=t&&"undefined"!=typeof t){var n=e(this),i=n.data(a),r=i.opt,l=e("#mCSB_"+i.idx+"_container"),s=l.parent(),c=typeof t;o||(o="x"===r.axis?"x":"y");var d="x"===o?l.outerWidth(!1)-s.width():l.outerHeight(!1)-s.height(),f="x"===o?l[0].offsetLeft:l[0].offsetTop,h="x"===o?"left":"top";switch(c){case"function":return t();case"object":var m=t.jquery?t:e(t);if(!m.length)return;return"x"===o?ae(m)[1]:ae(m)[0];case"string":case"number":if(oe(t))return Math.abs(t);if(-1!==t.indexOf("%"))return Math.abs(d*parseInt(t)/100);if(-1!==t.indexOf("-="))return Math.abs(f-parseInt(t.split("-=")[1]));if(-1!==t.indexOf("+=")){var p=f+parseInt(t.split("+=")[1]);return p>=0?0:Math.abs(p)}if(-1!==t.indexOf("px")&&oe(t.split("px")[0]))return Math.abs(t.split("px")[0]);if("top"===t||"left"===t)return 0;if("bottom"===t)return Math.abs(s.height()-l.outerHeight(!1));if("right"===t)return Math.abs(s.width()-l.outerWidth(!1));if("first"===t||"last"===t){var m=l.find(":"+t);return"x"===o?ae(m)[1]:ae(m)[0]}return e(t).length?"x"===o?ae(e(t))[1]:ae(e(t))[0]:(l.css(h,t),void u.update.call(null,n[0]))}}},N=function(t){function o(){return clearTimeout(f[0].autoUpdate),0===l.parents("html").length?void(l=null):void(f[0].autoUpdate=setTimeout(function(){return c.advanced.updateOnSelectorChange&&(s.poll.change.n=i(),s.poll.change.n!==s.poll.change.o)?(s.poll.change.o=s.poll.change.n,void r(3)):c.advanced.updateOnContentResize&&(s.poll.size.n=l[0].scrollHeight+l[0].scrollWidth+f[0].offsetHeight+l[0].offsetHeight+l[0].offsetWidth,s.poll.size.n!==s.poll.size.o)?(s.poll.size.o=s.poll.size.n,void r(1)):!c.advanced.updateOnImageLoad||"auto"===c.advanced.updateOnImageLoad&&"y"===c.axis||(s.poll.img.n=f.find("img").length,s.poll.img.n===s.poll.img.o)?void((c.advanced.updateOnSelectorChange||c.advanced.updateOnContentResize||c.advanced.updateOnImageLoad)&&o()):(s.poll.img.o=s.poll.img.n,void f.find("img").each(function(){n(this)}))},c.advanced.autoUpdateTimeout))}function n(t){function o(e,t){return function(){

return t.apply(e,arguments)}}function a(){this.onload=null,e(t).addClass(d[2]),r(2)}if(e(t).hasClass(d[2]))return void r();var n=new Image;n.onload=o(n,a),n.src=t.src}function i(){c.advanced.updateOnSelectorChange===!0&&(c.advanced.updateOnSelectorChange="*");var e=0,t=f.find(c.advanced.updateOnSelectorChange);return c.advanced.updateOnSelectorChange&&t.length>0&&t.each(function(){e+=this.offsetHeight+this.offsetWidth}),e}function r(e){clearTimeout(f[0].autoUpdate),u.update.call(null,l[0],e)}var l=e(this),s=l.data(a),c=s.opt,f=e("#mCSB_"+s.idx+"_container");return t?(clearTimeout(f[0].autoUpdate),void $(f[0],"autoUpdate")):void o()},V=function(e,t,o){return Math.round(e/t)*t-o},Q=function(t){var o=t.data(a),n=e("#mCSB_"+o.idx+"_container,#mCSB_"+o.idx+"_container_wrapper,#mCSB_"+o.idx+"_dragger_vertical,#mCSB_"+o.idx+"_dragger_horizontal");n.each(function(){Z.call(this)})},G=function(t,o,n){function i(e){return s&&c.callbacks[e]&&"function"==typeof c.callbacks[e]}function r(){return[c.callbacks.alwaysTriggerOffsets||w>=S[0]+y,c.callbacks.alwaysTriggerOffsets||-B>=w]}function l(){var e=[h[0].offsetTop,h[0].offsetLeft],o=[x[0].offsetTop,x[0].offsetLeft],a=[h.outerHeight(!1),h.outerWidth(!1)],i=[f.height(),f.width()];t[0].mcs={content:h,top:e[0],left:e[1],draggerTop:o[0],draggerLeft:o[1],topPct:Math.round(100*Math.abs(e[0])/(Math.abs(a[0])-i[0])),leftPct:Math.round(100*Math.abs(e[1])/(Math.abs(a[1])-i[1])),direction:n.dir}}var s=t.data(a),c=s.opt,d={trigger:"internal",dir:"y",scrollEasing:"mcsEaseOut",drag:!1,dur:c.scrollInertia,overwrite:"all",callbacks:!0,onStart:!0,onUpdate:!0,onComplete:!0},n=e.extend(d,n),u=[n.dur,n.drag?0:n.dur],f=e("#mCSB_"+s.idx),h=e("#mCSB_"+s.idx+"_container"),m=h.parent(),p=c.callbacks.onTotalScrollOffset?Y.call(t,c.callbacks.onTotalScrollOffset):[0,0],g=c.callbacks.onTotalScrollBackOffset?Y.call(t,c.callbacks.onTotalScrollBackOffset):[0,0];if(s.trigger=n.trigger,0===m.scrollTop()&&0===m.scrollLeft()||(e(".mCSB_"+s.idx+"_scrollbar").css("visibility","visible"),m.scrollTop(0).scrollLeft(0)),"_resetY"!==o||s.contentReset.y||(i("onOverflowYNone")&&c.callbacks.onOverflowYNone.call(t[0]),s.contentReset.y=1),"_resetX"!==o||s.contentReset.x||(i("onOverflowXNone")&&c.callbacks.onOverflowXNone.call(t[0]),s.contentReset.x=1),"_resetY"!==o&&"_resetX"!==o){if(!s.contentReset.y&&t[0].mcs||!s.overflowed[0]||(i("onOverflowY")&&c.callbacks.onOverflowY.call(t[0]),s.contentReset.x=null),!s.contentReset.x&&t[0].mcs||!s.overflowed[1]||(i("onOverflowX")&&c.callbacks.onOverflowX.call(t[0]),s.contentReset.x=null),c.snapAmount){var v=c.snapAmount instanceof Array?"x"===n.dir?c.snapAmount[1]:c.snapAmount[0]:c.snapAmount;o=V(o,v,c.snapOffset)}switch(n.dir){case"x":var x=e("#mCSB_"+s.idx+"_dragger_horizontal"),_="left",w=h[0].offsetLeft,S=[f.width()-h.outerWidth(!1),x.parent().width()-x.width()],b=[o,0===o?0:o/s.scrollRatio.x],y=p[1],B=g[1],T=y>0?y/s.scrollRatio.x:0,k=B>0?B/s.scrollRatio.x:0;break;case"y":var x=e("#mCSB_"+s.idx+"_dragger_vertical"),_="top",w=h[0].offsetTop,S=[f.height()-h.outerHeight(!1),x.parent().height()-x.height()],b=[o,0===o?0:o/s.scrollRatio.y],y=p[0],B=g[0],T=y>0?y/s.scrollRatio.y:0,k=B>0?B/s.scrollRatio.y:0}b[1]<0||0===b[0]&&0===b[1]?b=[0,0]:b[1]>=S[1]?b=[S[0],S[1]]:b[0]=-b[0],t[0].mcs||(l(),i("onInit")&&c.callbacks.onInit.call(t[0])),clearTimeout(h[0].onCompleteTimeout),J(x[0],_,Math.round(b[1]),u[1],n.scrollEasing),!s.tweenRunning&&(0===w&&b[0]>=0||w===S[0]&&b[0]<=S[0])||J(h[0],_,Math.round(b[0]),u[0],n.scrollEasing,n.overwrite,{onStart:function(){n.callbacks&&n.onStart&&!s.tweenRunning&&(i("onScrollStart")&&(l(),c.callbacks.onScrollStart.call(t[0])),s.tweenRunning=!0,C(x),s.cbOffsets=r())},onUpdate:function(){n.callbacks&&n.onUpdate&&i("whileScrolling")&&(l(),c.callbacks.whileScrolling.call(t[0]))},onComplete:function(){if(n.callbacks&&n.onComplete){"yx"===c.axis&&clearTimeout(h[0].onCompleteTimeout);var e=h[0].idleTimer||0;h[0].onCompleteTimeout=setTimeout(function(){i("onScroll")&&(l(),c.callbacks.onScroll.call(t[0])),i("onTotalScroll")&&b[1]>=S[1]-T&&s.cbOffsets[0]&&(l(),c.callbacks.onTotalScroll.call(t[0])),i("onTotalScrollBack")&&b[1]<=k&&s.cbOffsets[1]&&(l(),c.callbacks.onTotalScrollBack.call(t[0])),s.tweenRunning=!1,h[0].idleTimer=0,C(x,"hide")},e)}}})}},J=function(e,t,o,a,n,i,r){function l(){S.stop||(x||m.call(),x=K()-v,s(),x>=S.time&&(S.time=x>S.time?x+f-(x-S.time):x+f-1,S.time<x+1&&(S.time=x+1)),S.time<a?S.id=h(l):g.call())}function s(){a>0?(S.currVal=u(S.time,_,b,a,n),w[t]=Math.round(S.currVal)+"px"):w[t]=o+"px",p.call()}function c(){f=1e3/60,S.time=x+f,h=window.requestAnimationFrame?window.requestAnimationFrame:function(e){return s(),setTimeout(e,.01)},S.id=h(l)}function d(){null!=S.id&&(window.requestAnimationFrame?window.cancelAnimationFrame(S.id):clearTimeout(S.id),S.id=null)}function u(e,t,o,a,n){switch(n){case"linear":case"mcsLinear":return o*e/a+t;case"mcsLinearOut":return e/=a,e--,o*Math.sqrt(1-e*e)+t;case"easeInOutSmooth":return e/=a/2,1>e?o/2*e*e+t:(e--,-o/2*(e*(e-2)-1)+t);case"easeInOutStrong":return e/=a/2,1>e?o/2*Math.pow(2,10*(e-1))+t:(e--,o/2*(-Math.pow(2,-10*e)+2)+t);case"easeInOut":case"mcsEaseInOut":return e/=a/2,1>e?o/2*e*e*e+t:(e-=2,o/2*(e*e*e+2)+t);case"easeOutSmooth":return e/=a,e--,-o*(e*e*e*e-1)+t;case"easeOutStrong":return o*(-Math.pow(2,-10*e/a)+1)+t;case"easeOut":case"mcsEaseOut":default:var i=(e/=a)*e,r=i*e;return t+o*(.499999999999997*r*i+-2.5*i*i+5.5*r+-6.5*i+4*e)}}e._mTween||(e._mTween={top:{},left:{}});var f,h,r=r||{},m=r.onStart||function(){},p=r.onUpdate||function(){},g=r.onComplete||function(){},v=K(),x=0,_=e.offsetTop,w=e.style,S=e._mTween[t];"left"===t&&(_=e.offsetLeft);var b=o-_;S.stop=0,"none"!==i&&d(),c()},K=function(){return window.performance&&window.performance.now?window.performance.now():window.performance&&window.performance.webkitNow?window.performance.webkitNow():Date.now?Date.now():(new Date).getTime()},Z=function(){var e=this;e._mTween||(e._mTween={top:{},left:{}});for(var t=["top","left"],o=0;o<t.length;o++){var a=t[o];e._mTween[a].id&&(window.requestAnimationFrame?window.cancelAnimationFrame(e._mTween[a].id):clearTimeout(e._mTween[a].id),e._mTween[a].id=null,e._mTween[a].stop=1)}},$=function(e,t){try{delete e[t]}catch(o){e[t]=null}},ee=function(e){return!(e.which&&1!==e.which)},te=function(e){var t=e.originalEvent.pointerType;return!(t&&"touch"!==t&&2!==t)},oe=function(e){return!isNaN(parseFloat(e))&&isFinite(e)},ae=function(e){var t=e.parents(".mCSB_container");return[e.offset().top-t.offset().top,e.offset().left-t.offset().left]},ne=function(){function e(){var e=["webkit","moz","ms","o"];if("hidden"in document)return"hidden";for(var t=0;t<e.length;t++)if(e[t]+"Hidden"in document)return e[t]+"Hidden";return null}var t=e();return t?document[t]:!1};e.fn[o]=function(t){return u[t]?u[t].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof t&&t?void e.error("Method "+t+" does not exist"):u.init.apply(this,arguments)},e[o]=function(t){return u[t]?u[t].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof t&&t?void e.error("Method "+t+" does not exist"):u.init.apply(this,arguments)},e[o].defaults=i,window[o]=!0,e(window).bind("load",function(){e(n)[o](),e.extend(e.expr[":"],{mcsInView:e.expr[":"].mcsInView||function(t){var o,a,n=e(t),i=n.parents(".mCSB_container");if(i.length)return o=i.parent(),a=[i[0].offsetTop,i[0].offsetLeft],a[0]+ae(n)[0]>=0&&a[0]+ae(n)[0]<o.height()-n.outerHeight(!1)&&a[1]+ae(n)[1]>=0&&a[1]+ae(n)[1]<o.width()-n.outerWidth(!1)},mcsInSight:e.expr[":"].mcsInSight||function(t,o,a){var n,i,r,l,s=e(t),c=s.parents(".mCSB_container"),d="exact"===a[3]?[[1,0],[1,0]]:[[.9,.1],[.6,.4]];if(c.length)return n=[s.outerHeight(!1),s.outerWidth(!1)],r=[c[0].offsetTop+ae(s)[0],c[0].offsetLeft+ae(s)[1]],i=[c.parent()[0].offsetHeight,c.parent()[0].offsetWidth],l=[n[0]<i[0]?d[0]:d[1],n[1]<i[1]?d[0]:d[1]],r[0]-i[0]*l[0][0]<0&&r[0]+n[0]-i[0]*l[0][1]>=0&&r[1]-i[1]*l[1][0]<0&&r[1]+n[1]-i[1]*l[1][1]>=0},mcsOverflow:e.expr[":"].mcsOverflow||function(t){var o=e(t).data(a);if(o)return o.overflowed[0]||o.overflowed[1]}})})})});
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
(function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)})(function(i){"use strict";var e=window.Slick||{};e=function(){function e(e,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(e),appendDots:i(e),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(e),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(e).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,"undefined"!=typeof document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=t++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}var t=0;return e}(),e.prototype.activateADA=function(){var i=this;i.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):o===!0?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&i.options.adaptiveHeight===!0&&i.options.vertical===!1){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),s.options.rtl===!0&&s.options.vertical===!1&&(e=-e),s.transformsEnabled===!1?s.options.vertical===!1?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):s.cssTransitions===!1?(s.options.rtl===!0&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),s.options.vertical===!1?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),s.options.vertical===!1?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this,o=t.getNavTarget();null!==o&&"object"==typeof o&&o.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};e.options.fade===!1?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,e.options.fade===!1?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(i.options.infinite===!1&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1===0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;e.options.arrows===!0&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),e.options.infinite!==!0&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(o.options.dots===!0&&o.slideCount>o.options.slidesToShow){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),e.options.centerMode!==!0&&e.options.swipeToSlide!==!0||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.options.draggable===!0&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>0){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(r.originalSettings.mobileFirst===!1?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||l===!1||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!==0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t,o=this;if(e=o.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var s in e){if(i<e[s]){i=t;break}t=e[s]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),e.options.accessibility===!0&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),e.options.arrows===!0&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),e.options.accessibility===!0&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),e.options.accessibility===!0&&e.$list.off("keydown.slick",e.keyHandler),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>0&&(i=e.$slides.children().children(),i.removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){var e=this;e.shouldClick===!1&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",e.options.fade===!1?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;t.cssTransitions===!1?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;e.cssTransitions===!1?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick","*",function(t){var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&o.is(":focus")&&(e.focussed=!0,e.autoPlay())},0)}).on("blur.slick","*",function(t){i(this);e.options.pauseOnFocus&&(e.focussed=!1,e.autoPlay())})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){var i=this;return i.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(i.options.infinite===!0)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(i.options.centerMode===!0)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),n.options.infinite===!0?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,n.options.vertical===!0&&n.options.centerMode===!0&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!==0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),n.options.centerMode===!0&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:n.options.centerMode===!0&&n.options.infinite===!0?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:n.options.centerMode===!0&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=n.options.vertical===!1?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,n.options.variableWidth===!0&&(o=n.slideCount<=n.options.slidesToShow||n.options.infinite===!1?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=n.options.rtl===!0?o[0]?(n.$slideTrack.width()-o[0].offsetLeft-o.width())*-1:0:o[0]?o[0].offsetLeft*-1:0,n.options.centerMode===!0&&(o=n.slideCount<=n.options.slidesToShow||n.options.infinite===!1?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=n.options.rtl===!0?o[0]?(n.$slideTrack.width()-o[0].offsetLeft-o.width())*-1:0:o[0]?o[0].offsetLeft*-1:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){var e=this;return e.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(e.options.infinite===!1?i=e.slideCount:(t=e.options.slidesToScroll*-1,o=e.options.slidesToScroll*-1,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o,s,n=this;return s=n.options.centerMode===!0?Math.floor(n.$list.width()/2):0,o=n.swipeLeft*-1+s,n.options.swipeToSlide===!0?(n.$slideTrack.find(".slick-slide").each(function(e,s){var r,l,d;if(r=i(s).outerWidth(),l=s.offsetLeft,n.options.centerMode!==!0&&(l+=r/2),d=l+r,o<d)return t=s,!1}),e=Math.abs(i(t).attr("data-slick-index")-n.currentSlide)||1):n.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){var t=this;t.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),t.options.accessibility===!0&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);if(i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),s!==-1){var n="slick-slide-control"+e.instanceUid+s;i("#"+n).length&&i(this).attr({"aria-describedby":n})}}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.options.focusOnChange?e.$slides.eq(s).attr({tabindex:"0"}):e.$slides.eq(s).removeAttr("tabindex");e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),i.options.accessibility===!0&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;e.options.dots===!0&&e.slideCount>e.options.slidesToShow&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),e.options.accessibility===!0&&e.$dots.on("keydown.slick",e.keyHandler)),e.options.dots===!0&&e.options.pauseOnDotsHover===!0&&e.slideCount>e.options.slidesToShow&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),e.options.accessibility===!0&&e.$list.on("keydown.slick",e.keyHandler),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),i.options.dots===!0&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&e.options.accessibility===!0?e.changeSlide({data:{message:e.options.rtl===!0?"next":"previous"}}):39===i.keyCode&&e.options.accessibility===!0&&e.changeSlide({data:{message:e.options.rtl===!0?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||r.$slider.attr("data-sizes"),n=document.createElement("img");n.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),r.$slider.trigger("lazyLoaded",[r,e,t])})},n.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),r.$slider.trigger("lazyLoadError",[r,e,t])},n.src=t})}var t,o,s,n,r=this;if(r.options.centerMode===!0?r.options.infinite===!0?(s=r.currentSlide+(r.options.slidesToShow/2+1),n=s+r.options.slidesToShow+2):(s=Math.max(0,r.currentSlide-(r.options.slidesToShow/2+1)),n=2+(r.options.slidesToShow/2+1)+r.currentSlide):(s=r.options.infinite?r.options.slidesToShow+r.currentSlide:r.currentSlide,n=Math.ceil(s+r.options.slidesToShow),r.options.fade===!0&&(s>0&&s--,n<=r.slideCount&&n++)),t=r.$slider.find(".slick-slide").slice(s,n),"anticipated"===r.options.lazyLoad)for(var l=s-1,d=n,a=r.$slider.find(".slick-slide"),c=0;c<r.options.slidesToScroll;c++)l<0&&(l=r.slideCount-1),t=t.add(a.eq(l)),t=t.add(a.eq(d)),l--,d++;e(t),r.slideCount<=r.options.slidesToShow?(o=r.$slider.find(".slick-slide"),e(o)):r.currentSlide>=r.slideCount-r.options.slidesToShow?(o=r.$slider.find(".slick-cloned").slice(0,r.options.slidesToShow),e(o)):0===r.currentSlide&&(o=r.$slider.find(".slick-cloned").slice(r.options.slidesToShow*-1),e(o))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){var i=this;i.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;if(!t.unslicked&&(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),t.options.accessibility===!0&&(t.initADA(),t.options.focusOnChange))){var o=i(t.$slides.get(t.currentSlide));o.attr("tabindex",0).focus()}},e.prototype.prev=e.prototype.slickPrev=function(){var i=this;i.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),r=document.createElement("img"),r.onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),l.options.adaptiveHeight===!0&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;return"boolean"==typeof i?(e=i,i=e===!0?0:o.slideCount-1):i=e===!0?--i:i,!(o.slideCount<1||i<0||i>o.slideCount-1)&&(o.unload(),t===!0?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,void o.reinit())},e.prototype.setCSS=function(i){var e,t,o=this,s={};o.options.rtl===!0&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,o.transformsEnabled===!1?o.$slideTrack.css(s):(s={},o.cssTransitions===!1?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;i.options.vertical===!1?i.options.centerMode===!0&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),i.options.centerMode===!0&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),i.options.vertical===!1&&i.options.variableWidth===!1?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):i.options.variableWidth===!0?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();i.options.variableWidth===!1&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,t.options.rtl===!0?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&i.options.adaptiveHeight===!0&&i.options.vertical===!1){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":"undefined"!=typeof arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),i.options.fade===!1?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=i.options.vertical===!0?"top":"left",
"top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||i.options.useCSS===!0&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&i.animType!==!1&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&i.animType!==!1},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),n.options.centerMode===!0){var r=n.options.slidesToShow%2===0?1:0;e=Math.floor(n.options.slidesToShow/2),n.options.infinite===!0&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=n.options.infinite===!0?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(s.options.fade===!0&&(s.options.centerMode=!1),s.options.infinite===!0&&s.options.fade===!1&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=s.options.centerMode===!0?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));return s||(s=0),t.slideCount<=t.options.slidesToShow?void t.slideHandler(s,!1,!0):void t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(a.animating===!0&&a.options.waitForAnimate===!0||a.options.fade===!0&&a.currentSlide===i))return e===!1&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,a.options.infinite===!1&&a.options.centerMode===!1&&(i<0||i>a.getDotCount()*a.options.slidesToScroll)?void(a.options.fade===!1&&(o=a.currentSlide,t!==!0&&a.slideCount>a.options.slidesToShow?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o))):a.options.infinite===!1&&a.options.centerMode===!0&&(i<0||i>a.slideCount-a.options.slidesToScroll)?void(a.options.fade===!1&&(o=a.currentSlide,t!==!0&&a.slideCount>a.options.slidesToShow?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o))):(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!==0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!==0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=a.getNavTarget(),l=l.slick("getSlick"),l.slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide)),a.updateDots(),a.updateArrows(),a.options.fade===!0?(t!==!0?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight()):void(t!==!0&&a.slideCount>a.options.slidesToShow?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)))},e.prototype.startLoad=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),i.options.dots===!0&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),o=Math.round(180*t/Math.PI),o<0&&(o=360-Math.abs(o)),o<=45&&o>=0?s.options.rtl===!1?"left":"right":o<=360&&o>=315?s.options.rtl===!1?"left":"right":o>=135&&o<=225?s.options.rtl===!1?"right":"left":s.options.verticalSwiping===!0?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(o.touchObject.edgeHit===!0&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(e.options.swipe===!1||"ontouchend"in document&&e.options.swipe===!1||e.options.draggable===!1&&i.type.indexOf("mouse")!==-1))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,e.options.verticalSwiping===!0&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(l.options.verticalSwiping===!0&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(l.options.rtl===!1?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),l.options.verticalSwiping===!0&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,l.options.infinite===!1&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),l.options.vertical===!1?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,l.options.verticalSwiping===!0&&(l.swipeLeft=e+o*s),l.options.fade!==!0&&l.options.touchMove!==!1&&(l.animating===!0?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;return t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow?(t.touchObject={},!1):(void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,void(t.dragging=!0))},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i,e=this;i=Math.floor(e.options.slidesToShow/2),e.options.arrows===!0&&e.slideCount>e.options.slidesToShow&&!e.options.infinite&&(e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===e.currentSlide?(e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):e.currentSlide>=e.slideCount-e.options.slidesToShow&&e.options.centerMode===!1?(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):e.currentSlide>=e.slideCount-1&&e.options.centerMode===!0&&(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||"undefined"==typeof s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),"undefined"!=typeof t)return t;return o}});
/*!
 * @name        easyzoom
 * @author      Matt Hinchliffe <>
 * @modified    Tuesday, February 14th, 2017
 * @version     2.5.0
 */!function(a,b){"use strict";"function"==typeof define&&define.amd?define(["jquery"],function(a){b(a)}):"object"==typeof module&&module.exports?module.exports=a.EasyZoom=b(require("jquery")):a.EasyZoom=b(a.jQuery)}(this,function(a){"use strict";function b(b,c){this.$target=a(b),this.opts=a.extend({},i,c,this.$target.data()),void 0===this.isOpen&&this._init()}var c,d,e,f,g,h,i={loadingNotice:"Loading image",errorNotice:"The image could not be loaded",errorDuration:2500,linkAttribute:"href",preventClicks:!0,beforeShow:a.noop,beforeHide:a.noop,onShow:a.noop,onHide:a.noop,onMove:a.noop};b.prototype._init=function(){this.$link=this.$target.find("a"),this.$image=this.$target.find("img"),this.$flyout=a('<div class="easyzoom-flyout" />'),this.$notice=a('<div class="easyzoom-notice" />'),this.$target.on({"mousemove.easyzoom touchmove.easyzoom":a.proxy(this._onMove,this),"mouseleave.easyzoom touchend.easyzoom":a.proxy(this._onLeave,this),"mouseenter.easyzoom touchstart.easyzoom":a.proxy(this._onEnter,this)}),this.opts.preventClicks&&this.$target.on("click.easyzoom",function(a){a.preventDefault()})},b.prototype.show=function(a,b){var g,h,i,j,k=this;if(this.opts.beforeShow.call(this)!==!1){if(!this.isReady)return this._loadImage(this.$link.attr(this.opts.linkAttribute),function(){!k.isMouseOver&&b||k.show(a)});this.$target.append(this.$flyout),g=this.$target.width(),h=this.$target.height(),i=this.$flyout.width(),j=this.$flyout.height(),c=this.$zoom.width()-i,d=this.$zoom.height()-j,c<0&&(c=0),d<0&&(d=0),e=c/g,f=d/h,this.isOpen=!0,this.opts.onShow.call(this),a&&this._move(a)}},b.prototype._onEnter=function(a){var b=a.originalEvent.touches;this.isMouseOver=!0,b&&1!=b.length||(a.preventDefault(),this.show(a,!0))},b.prototype._onMove=function(a){this.isOpen&&(a.preventDefault(),this._move(a))},b.prototype._onLeave=function(){this.isMouseOver=!1,this.isOpen&&this.hide()},b.prototype._onLoad=function(a){a.currentTarget.width&&(this.isReady=!0,this.$notice.detach(),this.$flyout.html(this.$zoom),this.$target.removeClass("is-loading").addClass("is-ready"),a.data.call&&a.data())},b.prototype._onError=function(){var a=this;this.$notice.text(this.opts.errorNotice),this.$target.removeClass("is-loading").addClass("is-error"),this.detachNotice=setTimeout(function(){a.$notice.detach(),a.detachNotice=null},this.opts.errorDuration)},b.prototype._loadImage=function(b,c){var d=new Image;this.$target.addClass("is-loading").append(this.$notice.text(this.opts.loadingNotice)),this.$zoom=a(d).on("error",a.proxy(this._onError,this)).on("load",c,a.proxy(this._onLoad,this)),d.style.position="absolute",d.src=b},b.prototype._move=function(a){if(0===a.type.indexOf("touch")){var b=a.touches||a.originalEvent.touches;g=b[0].pageX,h=b[0].pageY}else g=a.pageX||g,h=a.pageY||h;var i=this.$target.offset(),j=h-i.top,k=g-i.left,l=Math.ceil(j*f),m=Math.ceil(k*e);if(m<0||l<0||m>c||l>d)this.hide();else{var n=l*-1,o=m*-1;this.$zoom.css({top:n,left:o}),this.opts.onMove.call(this,n,o)}},b.prototype.hide=function(){this.isOpen&&this.opts.beforeHide.call(this)!==!1&&(this.$flyout.detach(),this.isOpen=!1,this.opts.onHide.call(this))},b.prototype.swap=function(b,c,d){this.hide(),this.isReady=!1,this.detachNotice&&clearTimeout(this.detachNotice),this.$notice.parent().length&&this.$notice.detach(),this.$target.removeClass("is-loading is-ready is-error"),this.$image.attr({src:b,srcset:a.isArray(d)?d.join():d}),this.$link.attr(this.opts.linkAttribute,c)},b.prototype.teardown=function(){this.hide(),this.$target.off(".easyzoom").removeClass("is-loading is-ready is-error"),this.detachNotice&&clearTimeout(this.detachNotice),delete this.$link,delete this.$zoom,delete this.$image,delete this.$notice,delete this.$flyout,delete this.isOpen,delete this.isReady},a.fn.easyZoom=function(c){return this.each(function(){var d=a.data(this,"easyZoom");d?void 0===d.isOpen&&d._init():a.data(this,"easyZoom",new b(this,c))})}});
/**
 * Minified by jsDelivr using UglifyJS v3.4.0.
 * Original file: /npm/js-cookie@2.2.0/src/js.cookie.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function g(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}return function e(l){function C(e,n,o){var t;if("undefined"!=typeof document){if(1<arguments.length){if("number"==typeof(o=g({path:"/"},C.defaults,o)).expires){var r=new Date;r.setMilliseconds(r.getMilliseconds()+864e5*o.expires),o.expires=r}o.expires=o.expires?o.expires.toUTCString():"";try{t=JSON.stringify(n),/^[\{\[]/.test(t)&&(n=t)}catch(e){}n=l.write?l.write(n,e):encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),e=(e=(e=encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var i="";for(var c in o)o[c]&&(i+="; "+c,!0!==o[c]&&(i+="="+o[c]));return document.cookie=e+"="+n+i}e||(t={});for(var a=document.cookie?document.cookie.split("; "):[],s=/(%[0-9A-Z]{2})+/g,f=0;f<a.length;f++){var p=a[f].split("="),d=p.slice(1).join("=");this.json||'"'!==d.charAt(0)||(d=d.slice(1,-1));try{var u=p[0].replace(s,decodeURIComponent);if(d=l.read?l.read(d,u):l(d,u)||d.replace(s,decodeURIComponent),this.json)try{d=JSON.parse(d)}catch(e){}if(e===u){t=d;break}e||(t[u]=d)}catch(e){}}return t}}return(C.set=C).get=function(e){return C.call(C,e)},C.getJSON=function(){return C.apply({json:!0},[].slice.call(arguments))},C.defaults={},C.remove=function(e,n){C(e,"",g(n,{expires:-1}))},C.withConverter=e,C}(function(){})});
//# sourceMappingURL=/sm/31d5cd1b58ce5e6231e4ea03a69b2801a53e76e98152bc29dc82a494ed0a1ee6.map
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

"use strict"

var AL = (typeof AL === 'object') ? AL : {};
AL.isdesktop = true;

AL.common = {
    VAR: {
        navClosed: false,
        windowwidth: 0,
        windowheight: 0,
        $MainContent: $('#MainContent'),
        lastDeviceDesktop: true
    },
    init: function () {
        var _this = this;
        //_this.navChange(_this.VAR.navClosed);

        if(getUrlParameter("link"))
        {
            $('#'+getUrlParameter("link")).show();
            $('#'+getUrlParameter("link")).parents().show();
            setTimeout(function(){
                AL.common.scrollTo($('#'+getUrlParameter("link")),250,500);
            },3000);
        }


        //when the close button is clicked
        $('.nav__icon').click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.VAR.navClosed = _this.VAR.navClosed ? false : true;
            _this.navChange(_this.VAR.navClosed);
        });


        $('.nav__cart_search').click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('body').addClass('search-open');
            $('.nav__search input').focus();
        });

        $('.nav__search input').blur(function (e) {
            $('body').removeClass('search-open');
        });

        //country selector
        $('.nav__cart_country').click(function (e) {

            $(this).find('.country_select').toggleClass('open');
            e.stopPropagation();
        });

        $('.usalink').attr('href', "https://alphabetlegends.myshopify.com" + window.location.pathname);
        $('.uklink').attr('href', "https://alphabet-legends-uk.myshopify.com" + window.location.pathname);


        //load randome images with the data attr
        $('[data-img-random-urls]').each(function () {
            var img = $(this).data('img-random-urls').split(',');
            if (img.length) {
                $(this).attr('src', img[Math.floor(img.length * Math.random())]);
            }
        });

        if (jQuery('.featured-slider').length) {
            _this.callSliders();
        }

        $(window).resize(function () {
            //use nav menu text to detect mobile and desktop
            if ((jQuery(window).width() > 749) && !AL.isdesktop) {
                AL.isdesktop = true;
                $(window).trigger('al-device-changed');
            }
            else if ((jQuery(window).width() < 750) && AL.isdesktop) {
                AL.isdesktop = false;
                $(window).trigger('al-device-changed');
            }
            // console.log(AL.isdesktop);

            _this.checkResize();
        });


        setTimeout(function () {
            $(window).trigger('al-device-changed');
            $(window).trigger('al-width-changed');

        }, 100);

        //common function to change all the image with the dievice change
        $(window).on('al-device-changed', function () {
            //change top images
            // console.log(AL.isdesktop + " -- img change");
            if (AL.isdesktop) {
                $('[data-deskimage]').each(function () {
                    $(this).attr('src', $(this).attr('data-deskimage'));
                });
            }
            else {
                $('[data-mobimage]').each(function () {
                    $(this).attr('src', $(this).attr('data-mobimage'));
                });
            }


        });

        // commin + / - buttons
        $('body').on('click', '.al-product-counts .plus', function (e) {

            e.preventDefault();
            var inputs = $(this).parent().find('input');
            var vals = $(this).parent().find('input').val();
            if (vals < parseInt(inputs.attr("max"))) {
                vals++;
            }
            inputs.val(vals);
        });
        $('body').on('click', '.al-product-counts .mins', function (e) {

            e.preventDefault();
            var inputs = $(this).parent().find('input');
            var vals = $(this).parent().find('input').val();
            var minval = 1;
            if ($(this).hasClass('zero')) {
                minval = 0;
            }
            if (vals > minval) {
                vals--;
            }
            inputs.val(vals);
        });


        //scroll throtle
        var scrollpos = 0;
        var scrollTimeout;
        var throttle = 200;

        $(window).on('scroll', function () {
            if (!scrollTimeout) {
                scrollTimeout = setTimeout(function () {
                    var goindown = window.pageYOffset > scrollpos ? true : false;
                    scrollpos = window.pageYOffset;
                    $(window).trigger('alscroll', [window.pageYOffset, goindown]);
                    scrollTimeout = null;

                    if (scrollpos > 0) $('body').addClass('scrolled');
                    else $('body').removeClass('scrolled');
                }, throttle);
            }
            var goindown = window.pageYOffset > scrollpos ? true : false;
            scrollpos = window.pageYOffset;
            $(window).trigger('alscroll', [window.pageYOffset, goindown]);


        });


    },

    navChange: function (val) {
        var _this = this;

        if (val) {
            $('.nav__icon').addClass('open');
            $('body').addClass('nav-open');

        }
        else {
            $('.nav__icon').removeClass('open');
            $('body').removeClass('nav-open');
        }

        var x = 0;
        var intervalID = setInterval(function () {
            _this.checkResize();
            if (++x === 50) {
                window.clearInterval(intervalID);
            }
        }, 10);
    },

    checkResize: function () {
        var _this = this;
        if (_this.VAR.$MainContent.width() !== _this.VAR.windowwidth || $(window).height() !== _this.VAR.windowheight) {
            _this.VAR.windowwidth = _this.VAR.$MainContent.width();
            _this.VAR.windowheight = $(window).height();
            $(window).trigger('al-width-changed');
        }
        _this.VAR.windowwidth = _this.VAR.$MainContent.width();
        _this.VAR.windowheight = $(window).height();
    },

    callSliders: function () {
        var _this = this;
        jQuery('.featured-slider').slick({
            infinite: true,

            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\\n\' +\n' +
                '                \'\\t viewBox="0 0 25.7 26" style="enable-background:new 0 0 25.7 26;" xml:space="preserve">\\n\' +\n' +
                '                \'<path id="iconfinder_icon-ios7-arrow-forward_211688" d="M8.5,5.8L10.3,4l9,9l0,0l-9,9l-1.8-1.8l7.2-7.2L8.5,5.8z"/>\\n\' +\n' +
                '                \'</svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\\n\' +\n' +
                '                \'\\t viewBox="0 0 25.7 26" style="enable-background:new 0 0 25.7 26;" xml:space="preserve">\\n\' +\n' +
                '                \'<path id="iconfinder_icon-ios7-arrow-forward_211688" d="M11.1,13l7.2,7.2L16.4,22l-9-9l0,0l9-9l1.8,1.8L11.1,13z"/></div>',

            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2.25,
                        slidesToScroll: 2,
                        infinite: false,arrows:false
                    }
                }
            ]
        });

        //to change side arrows
        // $(window).on('al-width-changed', function () {

            // var vv = _this.VAR.windowwidth > 1641 ? jQuery('.featured-slider').addClass("big") : jQuery('.featured-slider').removeClass("big");

        // });

    },




    // scroll to function
    scrollTo: function (targetElement, offset, duration) {
        var scrollAmount = 0;
        if (!isNaN(targetElement)) {
            scrollAmount = targetElement;
        } else {
            targetElement = targetElement instanceof jQuery ? targetElement : $(targetElement);
            offset = offset || 0;
            duration = duration || 200;
            scrollAmount = targetElement.offset().top - offset;
        }

        $('html, body').animate({
            scrollTop: scrollAmount
        }, duration);
    }



};

$(function () {

    if ((jQuery(window).width() > 749) && !AL.isdesktop) {
        AL.isdesktop = true;
        $(window).trigger('al-device-changed');
    }
    else if ((jQuery(window).width() < 750) && AL.isdesktop) {
        AL.isdesktop = false;
        $(window).trigger('al-device-changed');
    }
    AL.common.init();
});



"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.nav = {
    VAR: {
        navClosed: true
    },
    init: function () {
        var _this = this;

        if(typeof headerback !== 'undefined')
        {
            var urls = "url('"+headerback+"')"
            $('#shopify-section-header').css("backgroundImage",urls);
        }

        $('.site-nav--has-submenu>a').click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).parent().toggleClass("open");
            //_this.navChange();
            if($(this).parent().hasClass('open'))
            {
                $(this).parent().find('.site-nav__submenu').slideDown();
            }
            else
            {
                $(this).parent().find('.site-nav__submenu').slideUp();
            }
        });

        //call custom scroll
        $('.nav-wrapper').mCustomScrollbar();

        //open first menu item default
        $('.site-nav > .level1').eq(0).find('>a').trigger('click');



    },

    navChange: function () {

        $('.site-nav--has-submenu').each(function(){
            if($(this).hasClass('open'))
            {
                $(this).find('.site-nav__submenu').slideDown();
            }
            else
            {
                $(this).find('.site-nav__submenu').slideUp();
            }

        });


        // $('.site-nav--has-submenu > .site-nav__submenu').slideDown();
        // $('.site-nav--has-submenu.open > .site-nav__submenu').stop().slideUp();
    }
};

$(function () {
    AL.nav.init();
});
"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.foot = {
    VAR: {},
    init: function () {
        var _this = this;
        $('.mobmenu>a').click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!AL.isdesktop) {

                $(this).parent().toggleClass("mobhide");
                //_this.navChange();
                if ($(this).parent().hasClass('mobhide')) {
                    $(this).parent().find('ul').slideUp();
                }
                else {
                    $(this).parent().find('ul').slideDown();
                }
            }
        });


    },

    navChange: function () {

    }
};

$(function () {
    AL.foot.init();
});
/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.hero = {
    VAR: {
        $MainContent: $('#MainContent'),
        winwidth: 0,
        heroWidth: 1500,
        heroHeight: 700,
        maxWidth: 1500
    },
    init: function () {
        var _this = this;

        $('.hero-desktop .al-hero-slick').slick({
            // appendArrows: $('.hero-arrows')
            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve"><g id="arrows_overlay" transform="translate(-50 -393)"><path style="fill:#FFFFFF" id="if_basics-08_296826" class="st0" d="M71.5,473.8l37.7-38.8l-37.7-39l1.2-2l39.8,41l-39.8,41L71.5,473.8z"/></g></svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve"><g id="arrows_overlay" transform="translate(-50 -393)"><path  style="fill:#FFFFFF" id="if_basics-08_296826" class="st0" d="M112.5,396.2L74.8,435l37.7,39l-1.2,2l-39.8-41l39.8-41L112.5,396.2z"/></g></svg></div>',
            pauseOnHover: true,
            autoplay: true,
            autoplaySpeed: 6000,infinite:true

        });
        $(window).on('al-width-changed', function () {
            if (AL.isdesktop) {
                $('.hero-desktop .al-hero-slick').slick('setPosition');
                _this.VAR.winwidth = _this.VAR.$MainContent.width();
                _this.changeHeroWidth(_this.VAR.winwidth);
            }
        });
        _this.changeHeroWidth(_this.VAR.winwidth);

        $('.al-text.js-hide').removeClass('js-hide');
        $('.al-slides-wrap.js-hide').removeClass('js-hide');

    },

    changeHeroWidth: function (wid) {
        var _this = this;
        var bannerWidth = $('#MainContent').width();
        if (bannerWidth > _this.VAR.maxWidth) {
            bannerWidth = _this.VAR.maxWidth;
        }
        var bannerHeight = bannerWidth * (_this.VAR.heroHeight / _this.VAR.heroWidth);

        $('.hero-desktop .al-banner').height(bannerHeight);
        // add width and height for text layer in home slider
        $('.hero-desktop .al-text').width(bannerWidth);
        $('.hero-desktop .al-text').height(bannerHeight);
        $('.hero-desktop .hero-btn').css('top', ((bannerHeight - 82) / 2) + "px");

        var scale = bannerWidth / 1500;

        // $('.al-slides-wrap').css({
        //transform:  "scale(" + ($('#MainContent').width()/1500) + ")"
        //});

        // $('.al-text h4').css('font-size',(70*scale)+"px");
        $('.hero-desktop [data-font-size]').each(function () {
            var fs = $(this).attr('data-font-size');
            $(this).css('font-size', Math.round(fs * scale) + "px");
        });
    }
};



/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.heromobile = {
    VAR: {
        $MainContent: $('#MainContent'),
        winwidth: 0,
        heroWidth: 375,
        heroHeight: 625,
        maxWidth: 1500
    },
    init: function () {
        var _this = this;

        $('.hero-mobile .al-hero-slick').slick({

            pauseOnHover: true,
            autoplay: true,
            autoplaySpeed: 6000,
            arrows:false,dots: true

        });
        $(window).on('al-width-changed', function () {
            if (!AL.isdesktop) {
                _this.VAR.winwidth = _this.VAR.$MainContent.width();
                _this.changeHeroWidth(_this.VAR.winwidth);
            }
        });
        _this.changeHeroWidth(_this.VAR.winwidth);


    },

    changeHeroWidth: function (wid) {
        var _this = this;
        var bannerWidth = $(window).width();

        var bannerHeight = bannerWidth * (_this.VAR.heroHeight / _this.VAR.heroWidth);
        bannerHeight -= 40;

        $('.hero-mobile .al-slide').height(bannerHeight);
        $('.hero-mobile .al-banner').height(bannerWidth);

        // add width and height for text layer in home slider

        $('.hero-mobile .al-text').width(bannerWidth);
        $('.hero-mobile h3').width(bannerWidth);

        $('.hero-mobile .al-text').width(bannerWidth);

        $('.hero-mobile .al-text').height(bannerHeight);
        $('.hero-mobile .hero-btn').css('top', ((bannerHeight - 82) / 2) + "px");

        var scale = bannerWidth / 375;

        // $('.al-slides-wrap').css({
        //transform:  "scale(" + ($('#MainContent').width()/1500) + ")"
        //});

        // $('.al-text h4').css('font-size',(70*scale)+"px");
        $('.hero-mobile [data-font-size]').each(function () {
            var fs = $(this).attr('data-font-size');
            $(this).css('font-size', Math.round(fs * scale) + "px");
        });
    }
};

// alert("1aaa");


var camsSuccess = false;

document.addEventListener('om.Optin.success', function (event) {
    $('.al-opt.Campaign__canvas .Row').addClass("sucs");
    $('.al-opt.Campaign__canvas .Row .Element').addClass("sucs");
    camsSuccess = true;
});

document.addEventListener('om.Campaign.load', function (event) {
    cams = (event);

    setTimeout(function () {
        if(camsSuccess)
        {

                $('.al-opt.Campaign__canvas .Row').addClass("sucs");
                $('.al-opt.Campaign__canvas .Row .Element').addClass("sucs");
            setTimeout(function () {

                    $('.al-opt-CloseButton').trigger('click');

            }, 12000);

        }
    }, 200);


// check succsess

    if ($('.al-opt.Campaign__canvas').attr("id").split("-success").length > 1) {
        camsSuccess = true;
        $('.al-opt.Campaign__canvas .Row').addClass("sucs");
        $('.al-opt.Campaign__canvas .Row .Element').addClass("sucs");
    }


    setTimeout(function () {
        $('.al-opt.Campaign__canvas').addClass(("af"));
        if(!camsSuccess)
        {
            setTimeout(function () {
                var celicont = jQuery('.Campaign__content >  .Row').eq(1);
                for (var i = 0; i < 149; i++) {
                    celicont.append('<div class="confetti-' + i + '"></div>');
                }
            }, 500);
        }

    }, 500);

    // clse after 5 sec




});
/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.herohomevideo = {
    VAR: {
        $MainContent: $('#MainContent'),
        winwidth: 0,
        heroWidth: 1900,
        heroHeight: 930,
        maxWidth: 1500,
        sliderInterval: 'int',
        sliderCurrent: 0,
        sliderLength: 0
    },
    init: function () {
        var _this = this;




        $(window).on('al-device-changed', function () {

            var newmp4 = $('.hero-sou').attr('data-m');
            if (AL.isdesktop) {
                newmp4 = $('.hero-sou').attr('data-d');
            }

            var videocontainer = $('.hero-vid');
            var videosource = $('.hero-sou');

            videocontainer.get(0).pause();
            videosource.get(0).setAttribute('src', newmp4);
            videocontainer.get(0).load();
            videocontainer.get(0).play();
        });

        $(window).on('al-width-changed', function () {

            if (AL.isdesktop) {
                _this.changeHeroWidthDesk();
            }
            else {
                _this.changeHeroWidthMob();
            }
        });
        var hcall = AL.isdesktop ? _this.changeHeroWidthDesk() : _this.changeHeroWidthMob();

        var featuredText = $('.page-al-product-landing .feature-quote .f-text h5').text();



        // _this.simpleAnimation(true);
        //


        $('body').on('click','.hero-btn .tobundle','.product-landing.friday .bundle-hero-wrap',function(e){

            e.preventDefault();
            if(AL.isdesktop)
            {
                AL.common.scrollTo($(".bundle-offer-section"), 100, 300);
            }
            else
            {
                AL.common.scrollTo($(".bundle-offer-section"), 40, 300);
            }
        });

        $('.al-circle-btn').click(function () {
            if(AL.isdesktop)
            {
                AL.common.scrollTo($(".bundle-offer-section"), 100, 300);
            }
            else
            {
                AL.common.scrollTo($(".bundle-offer-section"), 40, 300);
            }

        });
        //_this.simpleAnimation(true);
        _this.callevents();



    },

    changeHeroWidthDesk: function () {

        var _this = this;
        var hei = $(window).height() - 80 - 40;
        var wid = $('#MainContent').width();

        if (hei / wid > 700 / 1920) {
            hei = wid * (700 / 1920);
        }


        // setting up banner height

        $('.bundle-hero-wrap').height(hei);
        $('.al-pl-hero').height(hei);
        $('.al-pl-slide').height(hei);
        $('.bg-anim-wrap').height(hei);

        $('.sale-icon').css('top','');

        var imagewid = hei * (_this.VAR.heroWidth / _this.VAR.heroHeight);

        // set width for image
        $('.al-pl-slide').eq(_this.VAR.sliderCurrent).addClass('show');
        $('.al-pl-slide img').width(imagewid);

        var scales = hei / 780;
        scales = scales > 1 ? 1 : scales;

        $('.al-pl-inside').css('transform', 'scale(' + scales + ')');
    },

    changeHeroWidthMob: function () {


        var _this = this;
        var hei = $(window).height() - 42;
        var wid = $(window).width();


        $('.bundle-hero-wrap').css('height',"auto");
        $('.al-pl-hero').height(wid);



        $('.al-pl-cart').css('min-height', (hei - wid) + "px");

        if (wid < 375) {
            $('.al-pl-inside').css('transform', 'scale(' + wid / 375 + ')');
        }
        else {
            $('.al-pl-inside').css('transform', 'none');
        }

        $('.bundle-hero-wrap').css('minHeight', "");
        $('.al-pl-hero').height(wid *(564/450));


        if( hei < ($('.bundle-hero-wrap').height()+ $('.al-pl-cart').height()) )
        {
            $('.al-pl-hero').height(hei - $('.al-pl-cart').height());
        }

    },


    simpleAnimation: function (start) {

        var _this = this;
        var _thisv = this.VAR;
        _this.VAR.sliderLength = $('.al-pl-slide').length;

        if (_this.VAR.sliderInterval !== "int") {
            clearInterval(_this.VAR.sliderInterval);
        }

        _this.VAR.sliderInterval = setInterval(function () {
            _this.VAR.sliderCurrent++;
            if (_this.VAR.sliderCurrent >= _this.VAR.sliderLength) {
                _this.VAR.sliderCurrent = 0;
            }
            $('.al-pl-slide').removeClass('show');
            $('.al-pl-slide').eq(_this.VAR.sliderCurrent).addClass('show');

        }, 5000);


    },

    callevents: function () {

    }


};



"use strict"

var UTI = (typeof UTI === 'object') ? UTI : {};
UTI.isdesktop = true;

UTI.insta = {
    VAR: {},
    init: function (id) {
        var _this = this;
        var instablock = '#instagram-feed';
        var instid = $(instablock).attr('data-insta-id');
        var instcount= $(instablock).attr('data-insta-count');


        $.instagramFeed({
            'username': instid,
            'container': instablock,
            'display_profile': false,
            'display_biography': false,
            'display_igtv': false,
            'items': instcount,
            'styling':false,
            'get_data':false,
            'callback':function(data){
                console.log(data);
            }
        });

        var tim = setInterval(function(){
            UTI.insta.callSliders();
            if(jQuery('.instagram_gallery').length){
                clearInterval(tim);
            }

        },500);






    },


    callSliders: function () {
        var _this = this;

        jQuery('.instagram_gallery').slick({
            touchThreshold: 20,
            // centerMode: true,
            // variableWidth: false,
            //nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
           // prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',

            speed: 300,arrows:false,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow:2
                    }
                }
            ]
        });



    },


};



"use strict"





var AL = (typeof AL === 'object') ? AL : {};





AL.popups = {


    VAR: {


        scrolls:0


    },


    init: function () {


        $('body').on('click','.close-btn.desk',function(e){


            e.preventDefault();


            AL.popups.hideall();


        });





        // $('body').on('touchmove',function(e){


        //     e.preventDefault();


        // });





        $(window).on('al-width-changed', function () {


           // $('.all-al-pops').height($(window).height());


        });


    },





    loadpop: function (clas) {


        AL.popups.VAR.scrolls = $(window).scrollTop();


       $('.all-al-pops').addClass('active');


        setTimeout(function(){


           $('.all-al-pops').find(clas).addClass('active');


           $('body').addClass('allpop');


       },100);


        setTimeout(function(){


            $('body').addClass('allpop-bn');


        },500);


    },


    hideall: function (clas) {





        $('.all-al-pops .se-popup.active').removeClass('active');


        $('body').removeClass('allpop');


        $('body').removeClass('allpop-bn');


        $(window).scrollTop(AL.popups.VAR.scrolls);


        setTimeout(function(){


            $('.all-al-pops').removeClass('active');


            $('body').removeClass('product-view');


        },500);


    }


};








/*


*     loadpop: function (clas) {


        AL.popups.VAR.scrolls = $(window).scrollTop();





        $('body').addClass('allpop');


        $('.all-al-pops').find(clas).addClass('active');


        setTimeout(function(){


            $('.all-al-pops').addClass('active');


        },100);


        setTimeout(function(){


           $('body').addClass('allpop-bn');


       },500);


    },


    hideall: function (clas) {








        $('.all-al-pops .se-popup.active').removeClass('active');


        $('body').removeClass('allpop');


        $('body').removeClass('allpop-bn');


        $(window).scrollTop( AL.popups.VAR.scrolls);


        setTimeout(function(){


            $('.all-al-pops').removeClass('active');


            $('body').removeClass('product-view');





        },500);


    }


*


*


* */



/*================ AL - product catalog ================*/

/**

 *created By Nalinda - Home page hero banners

 */



"use strict"



var AL = (typeof AL === 'object') ? AL : {};



AL.pcheader = {

    VAR: {

        $MainContent: $('#MainContent'),

        winwidth: 0,

        heroWidth: 1900,

        heroHeight: 930,

        maxWidth: 1500,

        sliderInterval: 'int',

        sliderCurrent: 0,

        sliderLength: 0

    },

    init: function () {

        var _this = this;



        // get me a copy



        $('#getacopy').click(function (e) {

            e.preventDefault();

            $('.al-product-counts .count').val(1);

            $('.al-pl-cart .add-cart').trigger('click');

        });



        $(window).on('al-width-changed', function () {



            if (AL.isdesktop) {

                _this.changeHeroWidthDesk();

            }

            else {

                _this.changeHeroWidthMob();

            }

        });

        var hcall = AL.isdesktop ? _this.changeHeroWidthDesk() : _this.changeHeroWidthMob();



        var featuredText = $('.page-al-product-landing .feature-quote .f-text h5').text();

        $(window).on('al-device-changed', function () {



            // cahnge the fetured text in mobile

            if (AL.isdesktop) {

                $('.page-al-product-landing .feature-quote .f-text h5').text(featuredText);



            }

            else {

                $('.page-al-product-landing .feature-quote .f-text h5').text($('.al-pl-inside p').text());



            }

        });





        // _this.simpleAnimation(true);

        //





        $('.al-pl-hero-wrap .al-circle-btn').click(function () {

            AL.common.scrollTo($(".shopify-section.feature-quote"), 100, 300);

        });

        //_this.simpleAnimation(true);

        _this.callevents();



        //setTimeout(function(){_this.slickSlider(); alert("S")},6000);

        _this.slickSlider();



    },



    changeHeroWidthDesk: function () {



        var _this = this;

        var hei = $(window).height() - 80 - 40;

        var wid = $('#MainContent').width();



        if (hei / wid > 640 / 1020) {

            hei = wid * (640 / 1020);

        }

        // setting up banner height



        $('.al-pl-hero-wrap').height(hei);

        $('.al-pl-hero').height(hei);

        $('.al-pl-slide').height(hei);



        var imagewid = hei * (_this.VAR.heroWidth / _this.VAR.heroHeight);



        // set width for image

        $('.al-pl-slide').eq(_this.VAR.sliderCurrent).addClass('show');

        $('.al-pl-slide img').width(imagewid);



        var scales = hei / 780;

        scales = scales > 1 ? 1 : scales;



        $('.al-pl-inside').css('transform', 'scale(' + scales + ')');

    },



    changeHeroWidthMob: function () {





        var _this = this;

        var hei = $(window).height() - 42;

        var wid = $(window).width();



        $('.al-pl-hero-wrap').css('minHeight',hei + "px");

        $('.al-pl-hero-wrap').css('height',"auto");

        $('.al-pl-hero').height(wid);

        $('.al-pl-slide').height(wid);



        $('.al-pl-slide').eq(_this.VAR.sliderCurrent).addClass('show');



        $('.al-pl-slide img').width(wid);



        $('.al-pl-cart').css('min-height', (hei - wid) + "px");



        if (wid < 375) {

            $('.al-pl-inside').css('transform', 'scale(' + wid / 375 + ')');

        }

        else {

            $('.al-pl-inside').css('transform', 'none');



        }





    },





    simpleAnimation: function (start) {



        var _this = this;

        var _thisv = this.VAR;

        _this.VAR.sliderLength = $('.al-pl-slide').length;



        if (_this.VAR.sliderInterval !== "int") {

            clearInterval(_this.VAR.sliderInterval);

        }



        _this.VAR.sliderInterval = setInterval(function () {

            _this.VAR.sliderCurrent++;

            if (_this.VAR.sliderCurrent >= _this.VAR.sliderLength) {

                _this.VAR.sliderCurrent = 0;

            }

            $('.al-pl-slide').removeClass('show');

            $('.al-pl-slide').eq(_this.VAR.sliderCurrent).addClass('show');



        }, 5000);





    },



    callevents: function () {



    },



    slickSlider: function () {



        jQuery('.al-pl-hero').slick({

            infinite: true,

            speed: 300,

            arrows:false,

            slidesToShow: 1,

            slidesToScroll: 1,

            pauseOnHover:false,

            fade: true,

            // cssEase: 'linear',

            autoplay:true,autoplaySpeed: 5000,

            responsive: [

                {

                    breakpoint: 750,

                    settings: {

                        fade: false,dots: true





                    }

                }

            ]

        });







    }





};






/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.albunles = {
    VAR: {
        called:false
    },
    init: function () {
        var _this = this;

        if(window.bundleType == "ajax")
        {
            $('.al-bundle-wrap .al-getacopy').click(function(e){

                e.preventDefault();

                var ids = bundle_ajp;
                jQuery.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data:  ids ,
                    dataType: 'json',
                    success: function() { location.href = '/cart'; }
                });

            });
        }
        else
        {
            $('.al-bundle-wrap .al-getacopy').click(function(e){

                e.preventDefault();
                if(bundleapp)
                {
                    $('.bold-bundles-widget__button').trigger('click');
                }
                else
                {
                    $('.add-cart-bun').trigger('click');
                }

            });
        }



    }, restBundles:function(){



    }


};



/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.albunlespick = {
    VAR: {
        called:false
    },
    init: function () {
        var _this = this;
        var addbuttondiv = $('.al-bundle-wrap .al-getacopy');
        var addbutton = $('.al-bundle-wrap .al-getacopy button');
        var countselected = 0;

        var thisjax;


        if(window.bundleType == "multiselect")
        {

            addbuttondiv.attr("data-text",addbutton.text());
            addbutton.addClass("disable");
            $('.al-b-product').attr("data-cover",10);
            $('.al-bundle-wrap .al-getacopy').click(function(e){

                e.preventDefault();

                if($('.multi-select-wrap .multi-item.selected').length >=3)
                {
                    var ids = thisjax;
                    jQuery.ajax({
                        type: 'POST',
                        url: '/cart/update.js',
                        data:  ids ,
                        dataType: 'json',
                        success: function() { location.href = '/cart'; }
                    });

                }



            });

            //add buttons
            $('.multi-select-wrap .multi-item').click(function(){

                var scount =  $('.multi-select-wrap .multi-item.selected').length;
                var ind = $(this).index();

                if($(this).hasClass("selected"))
                {
                    $(this).removeClass("selected");
                    var imgr = $('[data-cover="'+ind+'"]').find('img');
                    imgr.attr('src',imgr.attr('data-pimage'));
                    $('[data-cover="'+ind+'"]').attr("data-cover",10);
                }
                else
                {
                    if(scount < 3)
                    {

                    }
                    else
                    {
                        var olditem = $('.multi-select-wrap .multi-item.selected').eq(2);
                        olditem.removeClass('selected');
                        var imgrs = $('[data-cover="'+ olditem.index()+'"]').find('img');
                        imgrs.attr('src',imgrs.attr('data-pimage'));
                        $('[data-cover="'+olditem.index()+'"]').attr("data-cover",10);

                        //animate


                    }
                    $(this).addClass("selected");
                    $('[data-cover="10"]').eq(0).find('img').attr('src',$(this).find('.image img').attr('src'));
                    $('[data-cover="10"]').eq(0).attr("data-cover",ind);


                }
                scount =  $('.multi-select-wrap .multi-item.selected').length;
                if(scount < 3)
                {
                    addbutton.addClass("disable");
                }
                else
                {
                    addbutton.removeClass("disable");
                }

                var strid = bundle_ajp.split('&');
                thisjax = "";
                $('.multi-select-wrap .multi-item.selected').each(function(){

                    thisjax += strid[$(this).index()] + "&";
                });









            });


        }




    }, restBundles:function(){



    }


};



/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.videoimage = {
    VAR: {
        wwid:1500,
        hhei:844
    },
    init: function () {

        var _this = this;

        $(window).on('al-width-changed', function () {
            AL.videoimage.setSizes();
        });


        $('.video-image-slider .al-viwrap').slick({
            autoplay: false ,fade: true,asNavFor: '.al-thwrap',
            cssEase: 'linear',arrows: false
        });

        $('.al-thwrap').slick({

            slidesToShow: 4, slidesToScroll: 1, infinite: true, dots: false,
            asNavFor: '.video-image-slider .al-viwrap', arrows: true,
            focusOnSelect: true,nextArrow: '<div class="hero-next hero-btn" style="opacity: 0.8"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve"> <polygon id="XMLID_4_" style="fill:#000000;" points="27.5,3.5 18.1,12.9 47.1,42 18.1,71.1 27.5,80.5 65.9,42 "/> </svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"  style="opacity: 0.8"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
                '\t viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve">\n' +
                '<polygon id="XMLID_4_" style="fill:#000000;" points="56.5,80.5 65.9,71.1 36.9,42 65.9,12.9 56.5,3.5 18.1,42 "/>\n' +
                '</svg></div>'
        });

        AL.videoimage.setSizes();
    },
    setSizes: function()
    {
        var _this = this;
        var wid = $('.al-viwrap').width();
        var scale = _this.VAR.hhei / _this.VAR.wwid;

        $('.al-video-image .vi-slide').height(wid*scale);
        $('.al-video-image .vid .al-banner').height(wid*scale);

        if (AL.isdesktop) {
            $('.video-image-slider .al-viwrap').slick('setPosition');
        }

        $('.al-video-image .cover').height(wid*scale);
        $('.al-video-image .cover').height(wid);
    }


};

/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.iblock = {
    VAR: {
        wwid: 1500,
        hhei: 844
    },
    init: function () {

        var _this = this;

        $(window).on('al-width-changed', function () {
            widchange();

        });
        widchange()

        function widchange() {
            var wid = $('.al-ib-wrap').width();
            var widquarter = wid / 4;

            if (AL.isdesktop) {
                $('.al-ib-wrap').height(widquarter * 3);
            }
            else {
                $('.al-ib-wrap').height('');
            }

            $('.al-ib-wrap .block').each(function () {
                $(this).height($(this).width());
            });
        }

        setTimeout(function () {
            widchange();
        }, 100);

        var osec = 400;
        var odelay = 300;

        $(window).on('alscroll', function (a, b, c) {

            $('.scrollclass').each(function () {
                if ($(this).offset().top < (b + ($(window).height() / 2))) {
                    $(this).addClass('run');
                }
                else {
                    $(this).removeClass('run');
                }

            });


            if ($('.al-im .block6 .front').length) {


                if (AL.isdesktop) {


                    var mid = $('.al-im .block1').offset().top + ($('.al-im .block1').height() / 2) - ($(window).height() / 2);

                    if ((mid < b) && c && !$('.al-im').hasClass('first')) {
                        $('.al-im').addClass('first');
                        $('.al-im .block1 .front').stop().delay(odelay * 0).animate({opacity: 0}, osec);
                        $('.al-im .block2 .front').stop().delay(odelay * 1).animate({opacity: 0}, osec);
                        $('.al-im .block3 .front').stop().delay(odelay * 2).animate({opacity: 0}, osec);
                    }
                    else if ((mid > b) && !c && $('.al-im').hasClass('first')) {
                        $('.al-im').removeClass('first');
                        $('.al-im .block3 .front').stop().delay(odelay * 0).animate({opacity: 1}, osec);
                        $('.al-im .block2 .front').stop().delay(odelay * 1).animate({opacity: 1}, osec);
                        $('.al-im .block1 .front').stop().delay(odelay * 2).animate({opacity: 1}, osec);
                    }

                    var mid2 = $('.al-im .block6').offset().top + ($('.al-im .block6').height() / 2) - ($(window).height() / 2);

                    if ((mid2 < b) && c && !$('.al-im').hasClass('sec')) {
                        $('.al-im').addClass('sec');
                        $('.al-im .block6 .front').stop().delay(odelay * 0).animate({opacity: 0}, osec);
                        $('.al-im .block5 .front').stop().delay(odelay * 1).animate({opacity: 0}, osec);
                        $('.al-im .block4 .front').stop().delay(odelay * 2).animate({opacity: 0}, osec);
                    }
                    else if ((mid2 > b) && !c && $('.al-im').hasClass('sec')) {
                        $('.al-im').removeClass('sec');
                        $('.al-im .block4 .front').stop().delay(odelay * 0).animate({opacity: 1}, osec);
                        $('.al-im .block5 .front').stop().delay(odelay * 1).animate({opacity: 1}, osec);
                        $('.al-im .block6 .front').stop().delay(odelay * 2).animate({opacity: 1}, osec);
                    }
                }

                else {
                    $('.al-im .block').each(function () {
                        var mid = $(this).offset().top + ($(this).height() / 2) - ($(window).height() / 2);

                        if ((mid < b) && c && !$(this).hasClass('turn')) {
                            $(this).addClass('turn');
                            $(this).find('.front').stop().animate({opacity: 0}, osec);

                        }
                        else if ((mid > b) && !c && $(this).hasClass('turn')) {
                            $(this).removeClass('turn');
                            $(this).find('.front').stop().animate({opacity: 1}, osec);
                        }


                    });


                }
            }


            /*
             var mid = $('.al-im').offset().top + ($('.al-im').height() / 2) - ($(window).height() / 2);
             if ((mid < b) && c && !$('.al-im').hasClass('sec')) {
             $('.al-im').addClass('sec');
             $('.al-im .block1 .front').stop().delay(odelay*0).animate({opacity:0},osec);
             $('.al-im .block2 .front').stop().delay(odelay*1).animate({opacity:0},osec);
             $('.al-im .block3 .front').stop().delay(odelay*2).animate({opacity:0},osec);
             $('.al-im .block6 .front').stop().delay(odelay*3).animate({opacity:0},osec);
             $('.al-im .block5 .front').stop().delay(odelay*4).animate({opacity:0},osec);
             $('.al-im .block4 .front').stop().delay(odelay*5).animate({opacity:0},osec);
             }
             else if ((mid > b) && !c && $('.al-im').hasClass('sec')) {
             $('.al-im').removeClass('sec');
             $('.al-im .block4 .front').stop().delay(odelay*0).animate({opacity:1},osec);
             $('.al-im .block5 .front').stop().delay(odelay*1).animate({opacity:1},osec);
             $('.al-im .block6 .front').stop().delay(odelay*2).animate({opacity:1},osec);
             $('.al-im .block3 .front').stop().delay(odelay*3).animate({opacity:1},osec);
             $('.al-im .block2 .front').stop().delay(odelay*4).animate({opacity:1},osec);
             $('.al-im .block1 .front').stop().delay(odelay*5).animate({opacity:1},osec);

             }
             */


        });


    }


};

/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.review = {
    VAR: {
        loads:true,ptag:''
    },
    init: function () {
        var _this = this;




        setTimeout(function(){
           // $('.stamped-questions').append($('.stamped-questions .stamped-review').clone());
            //$('.stamped-questions').append($('.stamped-questions .stamped-review').clone());

            $('.stamped-form-contact-name input').attr('placeholder','YOUR NAME *');
            $('.stamped-form-contact-email input').attr('placeholder','EMAIL *');
            $('.stamped-form-input-text input').attr('placeholder','GIVE YOUR REVIEW A TITLE');
            $('.stamped-form-review-body textarea').attr('placeholder','HOW WAS YOUR OVERALL EXPERIENCE WITH THIS PRODUCT?');
            $('#new-question-form .stamped-form-review-body textarea').attr('placeholder','WHAT IS YOUR QUESTION?');

        },1000);

        AL.review.VAR.ptag = $('.rev.des');




        $('body').on('click','.qus',function(e){

            e.preventDefault();
            AL.common.scrollTo($('#tab-questions'), 100, 300);
            $('#tab-questions').trigger('click');

        });

        $('body').on('click','.re-badge .badge',function(e){
            e.preventDefault();
            AL.common.scrollTo($('.featured-wrap.reviews'), 100, 300);
            $('#tab-reviews').trigger('click');
        });

        $('body').on('click','.stamped-summary-actions a, .stamped-pagination a',function(e){

            AL.common.scrollTo($('.question-form-wrapper'), 50, 300);

        });


    },
    refresh: function () {

        if(this.VAR.loads)
        {
            AL.review.init();
            this.VAR.loads = false;
        }

        var _this = this;


        //$('.stamped-pagination.old').remove();
        //$('#stamped-main-widget').append($('.stamped-pagination'));
        //$('.stamped-pagination').addClass('old');

        setTimeout(function(){
            $('.qus-count').text($('#tab-questions').attr('data-count'));

            AL.review.VAR.ptag.insertAfter($('.stamped-tabs'));

            $('.stamped-review').each(function(){
                $(this).find('.stamped-rating-holder').html( $(this).find('.stamped-thumbs-up'));
                $(this).find('.stamped-thumbs-up').append('<span class="cre">Thank '+$(this).find('.author').text()+'</span>');
            });





        },1000);

    }
};




/**

 *created By Nalinda - Home page hero banners

 */



"use strict"



var AL = (typeof AL === 'object') ? AL : {};



AL.pcheaderv2 = {

    VAR: {

        $MainContent: $('#MainContent'),

        winwidth: 0,

        heroWidth: 1900,

        heroHeight: 930,

        maxWidth: 1500,

        sliderInterval: 'int',

        sliderCurrent: 0,

        sliderLength: 0

    },

    init: function () {

        var _this = this;



        // get me a copy





        $(window).on('al-width-changed', function () {



            if (AL.isdesktop) {

                _this.changeHeroWidthDesk();

            }

            else {

                _this.changeHeroWidthMob();

            }

        });

        var hcall = AL.isdesktop ? _this.changeHeroWidthDesk() : _this.changeHeroWidthMob();



        var featuredText = $('.page-al-product-landing .feature-quote .f-text h5').text();

        $(window).on('al-device-changed', function () {



            // cahnge the fetured text in mobile

            if (AL.isdesktop) {

                $('.page-al-product-landing .feature-quote .f-text h5').text(featuredText);



            }

            else {

                $('.page-al-product-landing .feature-quote .f-text h5').text($('.al-pl-inside p').text());



            }

        });





        // _this.simpleAnimation(true);

        //





        $('.al-v2-hero-wrap .al-circle-btn').click(function () {

            AL.common.scrollTo($(".shopify-section .feature-quote"), 100, 300);

        });

        //_this.simpleAnimation(true);

        _this.callevents();



        //setTimeout(function(){_this.slickSlider(); alert("S")},6000);

        _this.slickSlider();



    },



    changeHeroWidthDesk: function () {



        var _this = this;

        var hei = $(window).height() - 80 - 40;

        var wid = $('#MainContent').width();



        if (hei / wid > 640 / 1020) {

            hei = wid * (640 / 1020);

        }

        // setting up banner height



        $('.al-v2-hero-wrap').height(hei);

        $('.al-pl-hero').height(hei);

        $('.al-pl-slide').height(hei);

        $('.bg-anim-wrap').height(hei);



        $('.sale-icon').css('top','');



        var imagewid = hei * (_this.VAR.heroWidth / _this.VAR.heroHeight);



        // set width for image

        $('.al-pl-slide').eq(_this.VAR.sliderCurrent).addClass('show');

        $('.al-pl-slide img').width(imagewid);



        var scales = hei / 780;

        scales = scales > 1 ? 1 : scales;



        $('.al-pl-inside').css('transform', 'scale(' + scales + ')');

    },



    changeHeroWidthMob: function () {





        var _this = this;

        var hei = $(window).height() - 42;

        var wid = $(window).width();



        $('.al-v2-hero-wrap').css('minHeight',hei + "px");

        $('.al-v2-hero-wrap').css('height',"auto");

        $('.al-pl-hero').height(wid);

        $('.al-pl-slide').height(wid);

        $('.bg-anim-wrap').height(wid);



        $('.sale-icon').css('top',wid+"px");





        $('.al-pl-slide').eq(_this.VAR.sliderCurrent).addClass('show');



        $('.al-pl-slide img').width(wid);



        $('.al-pl-cart').css('min-height', (hei - wid) + "px");



        if (wid < 375) {

            $('.al-pl-inside').css('transform', 'scale(' + wid / 375 + ')');

        }

        else {

            $('.al-pl-inside').css('transform', 'none');



        }



    },





    simpleAnimation: function (start) {



        var _this = this;

        var _thisv = this.VAR;

        _this.VAR.sliderLength = $('.al-pl-slide').length;



        if (_this.VAR.sliderInterval !== "int") {

            clearInterval(_this.VAR.sliderInterval);

        }



        _this.VAR.sliderInterval = setInterval(function () {

            _this.VAR.sliderCurrent++;

            if (_this.VAR.sliderCurrent >= _this.VAR.sliderLength) {

                _this.VAR.sliderCurrent = 0;

            }

            $('.al-pl-slide').removeClass('show');

            $('.al-pl-slide').eq(_this.VAR.sliderCurrent).addClass('show');



        }, 5000);





    },



    callevents: function () {



    },



    slickSlider: function () {





        $('.al-pl-hero').slick({

            infinite: true,

            speed: 300,

            arrows:false,

            slidesToShow: 1,

            slidesToScroll: 1,

            pauseOnHover:false,

            fade: true,

            // cssEase: 'linear',

            autoplay:true,autoplaySpeed: 5000,

            responsive: [

                {

                    breakpoint: 750,

                    settings: {

                        fade: false,dots: true



                    }

                }

            ]

        });









    }





};






/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.iblockv2 = {
    VAR: {
        wwid: 1500,
        hhei: 844
    },
    init: function () {

        var _this = this;

        $(window).on('al-width-changed', function () {
            widchange();

        });
        widchange()

        function widchange() {
            var wid = $('.al-ib-wrap').width();
            var widquarter = wid / 4;

            if (AL.isdesktop) {
                $('.al-ib-wrap').height(widquarter * 3);
            }
            else {
                $('.al-ib-wrap').height('');
            }

            $('.al-ib-wrap .block').each(function () {
                $(this).height($(this).width());
            });

            var albwid = $('.al-b-products').width();
            var albwidqu = $('.al-b-products').width() / 4;
            $('.al-b-products').height(albwid);
            $('.al-b-product').width(albwidqu);
            $('.al-b-product').height(albwidqu);


        }

        // al-b-products

        setTimeout(function () {
            widchange();
        }, 100);

        var osec = 400;
        var odelay = 300;

        var rotation = 0;

        jQuery.fn.rotate = function (degrees) {
            $(this).css({'transform': 'rotate(' + degrees + 'deg)'});
            return $(this);
        };

        // $(this).rotate(rotation);

        var placing = [ //iemm,left,top,rotation,delay %,time %
            [$('.pro-0 img'), -20, 20, 40, 0, 30],
            [$('.pro-1 img'), 30, -20, -30, 10, 30],
            [$('.pro-2 img'), -20, -20, 20, 20, 30],
            [$('.pro-3 img'), 15, -20, -55, 30, 30],
            [$('.pro-4 img'), 10, -20, 90, 40, 30],
            [$('.pro-5 img'), -20, -20, -75, 50, 30],
            [$('.pro-6 img'), -30, -20, 60, 60, 30]
        ];
        var placingstart;
        var placingend;

        $(window).on('alscroll', function (a, b, c) {

            if ($('.al-b-products').length) {


                // bookg gallery
                var boxwid = $('.al-b-products').width();
                var boxhei = $('.al-b-products').height();

                var spacescale = (1 - (boxhei / $(window).height())) / 4;

                placingstart = $('.al-b-products').offset().top - $(window).height() + ($(window).height() * 0.1);
                placingend = $('.al-b-products').offset().top + $('.al-b-products').height() - $(window).height() + ($(window).height() * spacescale);
                var gaps = placingend - placingstart;
                var pre = 1 + (((placingstart - b) / gaps));
                if (pre > 1) pre = 1;
                else if (pre < 0) pre = 0;

                for (var k = 0; k < placing.length; k++) {
                    var pres = pre;
                    var it = placing[k];
                    it[0].css('margin-left', ((it[1] / 100) * boxwid * pres) + "px");
                    it[0].css('margin-top', ((it[2] / 100) * boxhei * pres) + "px");
                    it[0].css({'transform': 'rotate(' + (it[3] * pres) + 'deg)'});
                }
                $('.bows .bow').css('margin-top', (1 * boxhei * pre) + "px");

                // icons

                $('.scrollclass').each(function () {
                    if ($(this).offset().top < (b + ($(window).height() / 2))) {
                        $(this).addClass('run');
                    }
                    else {
                        $(this).removeClass('run');
                    }

                });
            }


            //change faces
            if ($('.al-im .block6 .front').length) {


                if (AL.isdesktop) {


                    var mid = $('.al-im .block1').offset().top + ($('.al-im .block1').height() / 2) - ($(window).height() / 2);

                    if ((mid < b) && c && !$('.al-im').hasClass('first')) {
                        $('.al-im').addClass('first');
                        $('.al-im .block1 .front').stop().delay(odelay * 0).animate({opacity: 0}, osec);
                        $('.al-im .block2 .front').stop().delay(odelay * 1).animate({opacity: 0}, osec);
                        $('.al-im .block3 .front').stop().delay(odelay * 2).animate({opacity: 0}, osec);
                    }
                    else if ((mid > b) && !c && $('.al-im').hasClass('first')) {
                        $('.al-im').removeClass('first');
                        $('.al-im .block3 .front').stop().delay(odelay * 0).animate({opacity: 1}, osec);
                        $('.al-im .block2 .front').stop().delay(odelay * 1).animate({opacity: 1}, osec);
                        $('.al-im .block1 .front').stop().delay(odelay * 2).animate({opacity: 1}, osec);
                    }

                    var mid2 = $('.al-im .block6').offset().top + ($('.al-im .block6').height() / 2) - ($(window).height() / 2);

                    if ((mid2 < b) && c && !$('.al-im').hasClass('sec')) {
                        $('.al-im').addClass('sec');
                        $('.al-im .block6 .front').stop().delay(odelay * 0).animate({opacity: 0}, osec);
                        $('.al-im .block5 .front').stop().delay(odelay * 1).animate({opacity: 0}, osec);
                        $('.al-im .block4 .front').stop().delay(odelay * 2).animate({opacity: 0}, osec);
                    }
                    else if ((mid2 > b) && !c && $('.al-im').hasClass('sec')) {
                        $('.al-im').removeClass('sec');
                        $('.al-im .block4 .front').stop().delay(odelay * 0).animate({opacity: 1}, osec);
                        $('.al-im .block5 .front').stop().delay(odelay * 1).animate({opacity: 1}, osec);
                        $('.al-im .block6 .front').stop().delay(odelay * 2).animate({opacity: 1}, osec);
                    }
                }

                else {
                    $('.al-im .block').each(function () {
                        var mid = $(this).offset().top + ($(this).height() / 2) - ($(window).height() / 2);

                        if ((mid < b) && c && !$(this).hasClass('turn')) {
                            $(this).addClass('turn');
                            $(this).find('.front').stop().animate({opacity: 0}, osec);

                        }
                        else if ((mid > b) && !c && $(this).hasClass('turn')) {
                            $(this).removeClass('turn');
                            $(this).find('.front').stop().animate({opacity: 1}, osec);
                        }


                    });


                }
            }


            /*
             var mid = $('.al-im').offset().top + ($('.al-im').height() / 2) - ($(window).height() / 2);
             if ((mid < b) && c && !$('.al-im').hasClass('sec')) {
             $('.al-im').addClass('sec');
             $('.al-im .block1 .front').stop().delay(odelay*0).animate({opacity:0},osec);
             $('.al-im .block2 .front').stop().delay(odelay*1).animate({opacity:0},osec);
             $('.al-im .block3 .front').stop().delay(odelay*2).animate({opacity:0},osec);
             $('.al-im .block6 .front').stop().delay(odelay*3).animate({opacity:0},osec);
             $('.al-im .block5 .front').stop().delay(odelay*4).animate({opacity:0},osec);
             $('.al-im .block4 .front').stop().delay(odelay*5).animate({opacity:0},osec);
             }
             else if ((mid > b) && !c && $('.al-im').hasClass('sec')) {
             $('.al-im').removeClass('sec');
             $('.al-im .block4 .front').stop().delay(odelay*0).animate({opacity:1},osec);
             $('.al-im .block5 .front').stop().delay(odelay*1).animate({opacity:1},osec);
             $('.al-im .block6 .front').stop().delay(odelay*2).animate({opacity:1},osec);
             $('.al-im .block3 .front').stop().delay(odelay*3).animate({opacity:1},osec);
             $('.al-im .block2 .front').stop().delay(odelay*4).animate({opacity:1},osec);
             $('.al-im .block1 .front').stop().delay(odelay*5).animate({opacity:1},osec);

             }
             */


        });


    }


};


/**

 *created By Nalinda - Home page hero banners

 */



"use strict"



var AL = (typeof AL === 'object') ? AL : {};



AL.plcartv2 = {

    VAR: {

        counts: 0, giftwrap: false

    },



    init: function () {



        // jQuery.ajax({

        //     type: 'POST',

        //     url: '/cart/clear.js',

        //     dataType: 'json'

        // });



        var _this = this;



        if ($('[data-menu-back]').data('menu-back')) {

            $('#shopify-section-header').css("background-color", $('[data-menu-back]').data('menu-back'));

        }



        //check it is come from discount page

       //if(window.location.href.split("?"))



        var getUrlParameter = function getUrlParameter(sParam) {

            var sPageURL = window.location.search.substring(1),

                sURLVariables = sPageURL.split('&'),

                sParameterName,

                i;



            for (i = 0; i < sURLVariables.length; i++) {

                sParameterName = sURLVariables[i].split('=');



                if (sParameterName[0] === sParam) {

                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);

                }

            }

        };



        var customDiscount = getUrlParameter('di')

        if(customDiscount)

        {

            window.history.pushState("object or string", "Title", window.location.href.split("?")[0]);

        }



        $('.sale-text').hide();



        //load carts

        jQuery.getJSON('/cart.js', function (cart) {

            for (var m = 0; m < cart.items.length; m++) {

                $('[data-ids=' + cart.items[m].id + ']').val(cart.items[m].quantity);

            }

            _this.updatePrice();

        });



        $(window).on('al-width-changed', function () {

            _this.refreshPopScale();

        });



        $('.add-btn .chekout-wrap').click(function () {

            _this.VAR.giftwrap = true;

            $('.gotocheckout').trigger('click');

        });





        $('body').on('click', '.al-pl-cart .add-cart:not(.multivar),.al-bundle-wrap .al-getacopy, .open-bundle, .select-swatch-btn', function (e) {



            e.preventDefault();

            var _thisid = $(this).attr('data-id');



            $('.freekey').hide();



            var thisproduct = $("[data-ids=" + $('.al-pl-cart .add-cart').attr("data-id") + "]");

            thisproduct.val(parseInt(thisproduct.val()) + parseInt($('.al-price-count .al-product-counts .count').val()));



            var mainproduct = $('[data-ids="'+_thisid+'"]');



            fbq('track', 'AddToCart', {

                content_type: 'product_group',

                content_ids: [parseInt(mainproduct.attr("data-product"))],

                value: mainproduct.attr("data-price"),

                num_items: mainproduct.val(),

                content_name: mainproduct.attr("data-name"),

                currency: "USD",

                content_category: "Alphabet Book"

            });



            pintrk('track', 'addtocart');





            if(customDiscount)

            {

                var ids = "";

                var wrapp = $('.gotogift').attr('data-giftid');

                $('.product-list .count').each(function () {

                    ids += "updates[" + $(this).attr("data-ids") + "]=" + parseInt($(this).val()) + "&";

                });

                ids += "updates[" + wrapp + "]=" + 0 + "&attributes[gift-wrapping]=&attributes[gift-note]=";

                var endurl = '/discount/' + customDiscount + '?redirect=%2Fcheckout';



                jQuery.ajax({

                    type: 'POST',

                    url: '/cart/update.js',

                    data: ids,

                    dataType: 'json',

                    success: function () {

                        location.href = endurl;

                    }

                });

            }

            else if (thisproduct.val() > 1) {

                var ids = "";
                console.log("have items")

                var wrapp = $('.gotogift').attr('data-giftid');

                $('.product-list .count').each(function () {
                    if(parseInt($(this).val()) > 0)
                    {
                    ids += "updates[" + $(this).attr("data-ids") + "]=" + parseInt($(this).val()) + "&";
                    }

                });


                // ids += "updates[" + wrapp + "]=" + 0 + "&attributes[gift-wrapping]=&attributes[gift-note]=";

                var endurl = '/checkout/';

                console.log(ids);

                jQuery.ajax({

                    type: 'POST',

                    url: '/cart/update.js',

                    data: ids,

                    dataType: 'json',

                    success: function () {

                        location.href = endurl;

                    }

                });

            }

            else {

                var ids = "updates[" + parseInt(thisproduct.attr("data-ids")) + "]=" + 1 + "&";

                jQuery.ajax({

                    type: 'POST',

                    url: '/cart/update.js',

                    data: ids,

                    dataType: 'json',

                    success: function () {

                        AL.popups.loadpop('.products-all');

                        _this.updatePrice();

                        _this.refreshPopScale();

                        $('.al-price-count .al-product-counts .count').val(1);

                    }

                });



                // AL.popups.loadpop('.products-all');

                // $('.al-price-count .al-product-counts .count').val(1);

                // _this.updatePrice();

                // _this.refreshPopScale();

            }



        });





        $('body').on('click', '.products-all .close-btn.desk', function (e) {

            e.preventDefault();

            var ids = $('.al-pl-cart .add-cart').attr("data-id");

        });



        $('body').on('click', '.products-all .add-btn.checkout', function (e) {



            e.preventDefault();

            if ($('.se-pop-gift.active').length || no_note == "true") {

                $('.gotocheckout').trigger('click');



            }

            else if (AL.plcartv2.VAR.counts > 0) {

                $('.se-pop-gift').addClass('active');

                $('.products-all .close-btn').removeClass('desk').addClass('gift');



            }



        });



        $('body').on('click', '.products-all .close-btn.gift', function (e) {

            e.preventDefault();

            $('.se-pop-gift').removeClass('active');

            $('.products-all .close-btn').removeClass('gift').addClass('desk');

        });





        $('body').on('click', '.gift .close-btn.back, .gift .cancel-wrap', function (e) {

            e.preventDefault();

            $('.se-popup.gift').removeClass('active');

        });



        $('body').on('click', '.products-all .gotogift', function (e) {

            e.preventDefault();

            $('.se-popup.gift').addClass('active');

        });



        $('.cart-list .hideprice').slideToggle();

        $('body').on('click', '.cart-list h5', function (e) {

            e.preventDefault();

            $('.cart-list .list').slideToggle();

            $('.cart-list .total').slideToggle();

            $('.cart-list h6').slideToggle();

            $('.cart-list .hideprice').slideToggle();

            $('.cart-list h5 .up-down-arrow').toggleClass('active');

        });



        $('body').on('click', '.cart-list h6', function (e) {

            e.preventDefault();

            $('.se-pop-wrap .al-product-counts input.count').val(0);

            _this.updatePrice();



        });





        $('body').on('click', '.al-price-count .al-product-counts >  span', function (e) {

            e.preventDefault();

            setTimeout(function () {



                //var ids = $('.al-pl-cart .add-cart').attr("data-id");

                //$('[data-ids=' + ids + ']').val($('.al-price-count .count').val());

                _this.updatePrice();



            }, 100);



        });

        setTimeout(function () {



            //var ids = $('.al-pl-cart .add-cart').attr("data-id");

            //$('[data-ids=' + ids + ']').val($('.al-price-count .count').val());

            _this.updatePrice();



        }, 100);





        _this.fromold();

        _this.productDetaile();





    }, productDetaile: function () {



        var cpop;

        var _this = $(this);



        $('.product.stock-wrap img.main').click(function (e) {



            e.preventDefault();

            var _this = $(this).parent().find('.main').eq(0);

            $('.se-popup.detail').addClass('active');



            cpop = _this.parents('.product').index();

            var imgset = "";

            if (_this.attr('data-im1') != "") {

                imgset += '<div><img src="' + _this.attr('data-im1') + '" /></div>';

            }

            if (_this.attr('data-im2') != "") {

                imgset += '<div><img src="' + _this.attr('data-im2') + '" /></div>';

            }

            if (_this.attr('data-im3') != "") {

                imgset += '<div><img src="' + _this.attr('data-im3') + '" /></div>';

            }



            //  $('.se-popup.detail .inner-pop').html('<div class="se-pop-head"><span class="next"><img class="country_arrow" src="{{ 'icon - arrow.svg' | asset_url }}"></span></span><h4>' + _this.attr('data-name') + '</h4><span class="prev"></span></div>' + _this.attr('data-des') + '<div class="pop-gal">' + imgset + '</div>');



            $('.se-popup.detail .inner-pop h4').html(_this.attr('data-name'));

            $('.se-popup.detail .inner-pop .dis').html(_this.attr('data-des'));

            $('.se-popup.detail .pop-gal-wrap').html('<div class="pop-gal">' + imgset + '</div>');

            $('button.back').hide();



            $('.pop-gal').slick({

                nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve"><g id="arrows_overlay" transform="translate(-50 -393)"><path style="fill:#FFFFFF" id="if_basics-08_296826" class="st0" d="M71.5,473.8l37.7-38.8l-37.7-39l1.2-2l39.8,41l-39.8,41L71.5,473.8z"/></g></svg></div>',

                prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve"><g id="arrows_overlay" transform="translate(-50 -393)"><path  style="fill:#FFFFFF" id="if_basics-08_296826" class="st0" d="M112.5,396.2L74.8,435l37.7,39l-1.2,2l-39.8-41l39.8-41L112.5,396.2z"/></g></svg></div>',

                autoplay: true, cssEase: 'linear'

            });

            var cinput = _this.parent().find('.count');

            $('.count.selected').removeClass('selected');

            cinput.addClass('selected');

            $('.se-popup.detail .count-pop').val(cinput.val());

            $('.se-popup.detail .stock').text(_this.parent().find('.stokcs').text());





        });



        $(document).on('click', '.se-pop-head .next', function () {

            cpop++;

            if (cpop >= $('.product-list .product').length) {

                cpop = 0;

            }

            $('.product-list .product').eq(cpop).find('img.main').eq(0).trigger('click');

        });

        $(document).on('click', '.se-pop-head .prev', function () {

            cpop--;

            if (cpop < 0) {

                cpop = $('.product-list .product').length - 1;

            }

            $('.product-list .product').eq(cpop).find('img.main').eq(0).trigger('click');

        });



        $(document).on('click', '.close-btn.pclose ,.se-popup.detail .back', function () {

            $('.se-popup.detail').removeClass('active');

        });





    },

    refreshPopScale: function () {



        var btnhei = $('.products-all .add-btn.checkout').outerHeight();

        var listhei = $('.products-all .cart-list').outerHeight();

        $('.products-all .se-pop-wrap').css("padding-bottom", listhei + "px");

        $('.se-popup.detail .se-pop-wrap').mCustomScrollbar();





    },



    updatePrice: function () {





        var _this = this;

        var counts = 0;

        var prices = 0;



        var minbooks = 0;



        var totprice = 0;

        var disprice = 0;

        var inters;



        var bookprice = 19.95;

        var discountedprice = 15.96;



        var discountmargin = 2;





        $('.product-list .count').each(function () {

            counts += parseInt($(this).val());

        });



        AL.plcartv2.VAR.counts = counts;

        totprice = counts*bookprice;

        disprice = totprice;

        var freeshippingtext = "";



        if (counts == 0) {

            $('.products-all .inner-pop h6').html("Please choose your book below");

            $('.products-all .inner-pop h4').html("YOUR CART IS EMPTY");

           // $('.product .price-tag').attr('src', $('.product .price-tag').attr("data-first"));

        }



        else if (counts == 1) {

            $('.products-all .inner-pop h6').html("Simply add another <u>1</u> or <u>more</u> titles to your cart.");

            $('.products-all .inner-pop h4').html("FANCY <span class='yel'>20% OFF</span> YOUR ORDER?");



            // $('.product .price-tag').attr('src', $('.product .price-tag').attr("data-first"));

        }

        else if (counts == 2) {

            $('.products-all .inner-pop h6').html("You are now 1 book away from <span class='yel'>FREE SHIPPING.</span>");

            $('.products-all .inner-pop h4').html("YOUR 20% DISCOUNT HAS BEEN APPLIED");

            disprice = counts*discountedprice;

            // $('.product .price-tag').attr('src', $('.product .price-tag').attr("data-first"));

        }



        else  if (counts >= discountmargin){

            $('.products-all .inner-pop h6').html("has been applied to your order 👍");

            $('.products-all .inner-pop h4').html(" A 20% DISCOUNT & FREE SHIPPING");



            //$('.product .price-tag').attr('src', $('.product .price-tag').attr("data-second"));

            disprice = counts*discountedprice;

            freeshippingtext = "Free Shipping + ";

        }

        else{

          //  $('.products-all .inner-pop h6').text("YOU NEED "+(discountmargin-counts)+" TITLE TO GET 20% OFF & FREE SHIPPING");

            //$('.product .price-tag').attr('src', $('.product .price-tag').attr("data-second"));



        }



        var firstgone = false;



        $('.cart-list .list').html("");





        var itemcounts = 0;

        var thisvals = parseInt($('.al-price-count .count').val());





        if($('[data-main-price]').length)

        {

            bookprice = parseInt($('[data-main-price]').attr('data-main-price'))/100;



        }

        console.log(bookprice);



        var preorderitem = false;

        var totalprice = 0;



        $('.product-list .count').each(function () {

            $(this).removeClass('added');

            var img = $(this).parents('.product').find('.main');

            var val = parseInt($(this).val());

            itemcounts += val;

            var thisprice = $(this).attr("data-price");

            var thisdiscountprice = $(this).attr("data-price") * 0.8;







            if (val > 0) {

                var preorder = img.attr('data-pre')=="true"?true:false;

                var pohtml="";

                if(preorder)

                {

                    preorderitem = true;

                    pohtml = "<span class='po-tag'>Pre Order</span>";

                }



                if (counts >= discountmargin){

                    $('.cart-list .list').append('<div class="item"><div class="p-name">' + val + ' x ' + img.attr("data-name") +pohtml+ '</div><div class="n-price">$' + (thisprice * val).toFixed(2) + '</div><div class="s-price">$' + (thisdiscountprice* val).toFixed(2) + '</div></div>');

                    totalprice += (thisdiscountprice* val);





                }else

                {

                    $('.cart-list .list').append('<div class="item"><div class="p-name">' + val + ' x ' + img.attr("data-name") +pohtml+ '</div><div class="n-price"></div><div class="s-price">$' + (thisprice* val).toFixed(2) + '</div></div>');

                    totalprice += (thisprice* val);



                }



                $(this).addClass('added');





            }





        });



        if(preorderitem)

        {

            $('.msg-pre-order-cart').show();

        }

        else

        {

            $('.msg-pre-order-cart').hide();

        }







        // $('.al-price-count .compare span').eq(0).text('$' + (thisvals * 24.95).toFixed(2));

        // $('.al-price-count .price-area > span span').eq(0).text('$' + (thisvals * bookprice).toFixed(2));



        AL.plcartv2.refreshPopScale();



        $('.cart-list .final').text('$' + totalprice.toFixed(2));

        $('.total .total-price .saved').text('('+freeshippingtext+'You Saved $' + (totprice - totalprice).toFixed(2) + ')');







    }, fromold: function () {



        var _this = this;

        var minbooks = 1;

        var counts = 0;

        var cpop = 0;

        var wrapp = $('.gotogift').attr('data-giftid');

        var discodes = "20off-books";



        $('.product-list .count').each(function () {

            counts += parseInt($(this).val());

        });





        $('.se-info').html('<b>Please pick at least ' + minbooks + ' book</b>');



        $(document).on("click", ".se-popup.detail .al-product-counts span", function () {

            setTimeout(function () {

                $('.count.selected').val($('.se-popup.detail .al-product-counts .count-pop').val());

                _this.updatePrice();

            }, 100);

            $('button.back').show();



        });





        $(document).on("change, mouseup, keyup", ".count", _this.updatePrice);

        $(document).on("click", ".product .al-product-counts span", _this.updatePrice);





        $('.gotocheckout').click(function (e) {

            counts = 0;

            e.preventDefault();



            $('.product-list .count').each(function () {

                counts += parseInt($(this).val());

            });

            console.log(counts);



            var ids = "";



            $('.product-list .count').each(function () {

                ids += "updates[" + $(this).attr("data-ids") + "]=" + parseInt($(this).val()) + "&";

            });


            /*
            if (_this.VAR.giftwrap) {

                ids += "updates[" + wrapp + "]=" + 1 + "&attributes[gift-wrapping]=true&attributes[gift-note]=" + encodeURIComponent($('#gift-note').val());

            }

            else {

                ids += "updates[" + wrapp + "]=" + 0 + "&attributes[gift-wrapping]=&attributes[gift-note]=";

            }*/





            var codel;



            var endurl = '/checkout';



            if (counts >= 2) {

                endurl = '/discount/' + discodes + '?redirect=%2Fcheckout';

            }





            console.log(counts);

            console.log(ids);

            jQuery.ajax({

                type: 'POST',

                url: '/cart/update.js',

                data: ids,

                dataType: 'json',

                success: function () {

                    location.href = endurl;

                },

                error: function (xhr, ajaxOptions, thrownError) {

                    console.log(xhr.status);

                    console.log(thrownError);

                    console.log(ajaxOptions);

                }

            });





        });





        $('#gift-note').on('keyup', function (e) {

            var count = $(this).val().length;

            var max = $(this).attr('maxlength');

            $('.left-text').text((max - count) + " Characters Remaining");



            var str = $('textarea#gift-note').val();

            str = str.replace(/[^a-zA-Z 0-9 .,\/#@!$%\^&\*;:{}=\-_`~()]+/g, '');

            $('textarea#gift-note').val(str);



        });

        $('#gift-note').trigger('keyup');





    }



};







"use strict"



var AL = (typeof AL === 'object') ? AL : {};



AL.gorupoffer = {

    VAR: {

        $MainContent: $('#MainContent'),

        winwidth: 0,

        heroWidth: 1900,

        heroHeight: 930,

        maxWidth: 1500,

        sliderInterval: 'int',

        sliderCurrent: 0,

        sliderLength: 0

    },

    init: function () {

        var _this = this;



        var itemprice = offersaleprice.toFixed(2);

        var itemdiscountprice = (offersaleprice / 2).toFixed(2);



        var totalprice = 0;

        var totaldiscountprice = 0;

        var othercartitems = [];

        var getscrolpos = 0;







        jQuery.getJSON('/cart.js', function (cart) {

            //jQuery.getJSON('/cart/clear.js', function (cart) {

            for (var m = 0; m < cart.items.length; m++) {

                if ($('[data-ids=' + cart.items[m].id + ']').length) {

                    $('[data-ids=' + cart.items[m].id + ']').val(cart.items[m].quantity);

                } else {

                    othercartitems.push([cart.items[m].quantity, cart.items[m].title, cart.items[m].line_price, cart.items[m].id]);

                }

            }

            updateOffer();

        });



        var prdocuts = $('[data-ids]');

        var itembox = $('.se-popup.cart .cart-items');



        $('body').on('change', prdocuts, function () {

            setTimeout(function () {

                updateOffer();

            }, 100);

        });

        $('body').on('click', '.al-product-counts span', function () {

            setTimeout(function () {

                updateOffer();

            }, 100);

        });





        $('body').on('click', '.pl-groups .addtocart', function (e) {



            e.preventDefault();

            if (!$('.pl-groups').hasClass('offeron')) {

                $('.pl-groups').addClass('needmsg');

                setTimeout(function () {

                    $('.pl-groups').removeClass('needmsg');

                }, 2000);

            } else {

                $('body').addClass('allpop-bn');

                $('.se-popup.cart').addClass('show');

                updatecheckout();

            }

        });





        $('body.page-5for50').on('click', '.nav__cart_car a', function (e) {



            e.preventDefault();

            $('body').addClass('allpop-bn');

            $('.se-popup.cart').addClass('show');





        });



        $('body').on('click', '.close-btn, .inner-pop .msg', function (e) {



            e.preventDefault();

            $('body').removeClass('allpop-bn');

            $('.se-popup').removeClass('show');



            $(window).scrollTop(getscrolpos);





        });





        function updateOffer() {

            itembox.html("");

            var itemcount = 0;

            var preorderitem = false;

            for (var s = 0; s < prdocuts.length; s++) {

                var vals = parseInt(prdocuts.eq(s).val());

                itemcount += vals;



                if (vals > 0) {

                    var name = prdocuts.eq(s).parents('.product').find('img.main').attr('data-name');

                    var preorder = prdocuts.eq(s).parents('.product').find('img.pr-or').length?true:false;

                    var pohtml="";

                    if(preorder)

                    {

                        preorderitem = true;

                        pohtml = "<span class='po-tag'>Pre Order</span>";

                    }

                    var price = (itemprice * vals).toFixed(2);

                    var sale = Math.ceil((price * 100) * ((100 - offerdiscount) / 100)) / 100;



                    itembox.append('<div class="lin-item"><span class="name">' + vals + ' x ' + name +pohtml+'</span><span class="price">$' + price + '</span><span class="sale">$' + sale + '</span></div>');

                }

            }



            if(preorderitem)

            {

                $('.msg-pre-order-cart').show();

            }

            else

            {

                $('.msg-pre-order-cart').hide();

            }

/*

             for (var k = 0; k < othercartitems.length ; k++) {

                 itembox.append('<div class="lin-item"><span class="name">' + othercartitems[k][0] + ' x ' +  othercartitems[k][1] + '</span><span class="price"></span><span class="sale">$' + (othercartitems[k][2]/100).toFixed(2)  + '</span></div>');



             }*/







            totalprice = itemprice * itemcount;

            totaldiscountprice = Math.ceil((totalprice * 100) * ((100 - offerdiscount) / 100)) / 100;



            var icprice = "0/" + offerproductmax + " ITEMS -  ($0.00)";

            if (itemcount > 0) {

                icprice = itemcount + '/' + offerproductmax + ' ITEMS -  (<strike>$' + totalprice.toFixed(2) + '</strike> $' + totaldiscountprice.toFixed(2) + ')';

            }



            $('.addtocart .items-details').html(icprice);

            $('.addtocart .msg').html('YOU NEED <span>' + (offerproductmax - itemcount) + '</span> MORE ITEM TO QUALIFY');





            if (itemcount >= offerproductmax) {

                $('.pl-groups').addClass('offeron');

                $('.sub-total .price').text('$' + totaldiscountprice.toFixed(2));

                $('.cart-total .price').text('$' + totaldiscountprice.toFixed(2));

            } else {

                $('.pl-groups').removeClass('offeron');

                $('.sub-total .price').text('$' + totalprice.toFixed(2));



                var oneitems = "";

                if (itemcount > 1) oneitems = "s";

                var oneitemsleft = "";

                if ((offerproductmax - itemcount) > 1) oneitemsleft = "s";



                $('.pop-head p.hide-on-offer').html('You have <span>' + itemcount + ' </span> book' + oneitems + ' in your bag. You need to add another <span>' + (offerproductmax - itemcount) + '</span> item' + oneitemsleft + ' to get ' + offerdiscount + '% off and free shipping');



            }



        }



        function updatecheckout() {



            $('.se-popup.cart').removeClass('checkon');

            var ids = "";



            $('[data-ids]').each(function () {

                ids += "updates[" + $(this).attr("data-ids") + "]=" + parseInt($(this).val()) + "&";

            });



            for (var k = 0; k < othercartitems.length ; k++) {

                ids += "updates[" + (othercartitems[k][3] + "]=0&");



            }



            var codel = "aa";



            var endurl = '/discount/' + codel + '?redirect=%2Fcheckout';





            jQuery.ajax({

                type: 'POST',

                url: '/cart/update.js',

                data: ids,

                dataType: 'json',

                success: function () {

                    $('.se-popup.cart').addClass('checkon');

                }

            });



        }





        //image popup



        var ccitem;





        $('.gal-box .main-image').slick({

            slidesToShow: 1,

            slidesToScroll: 1,

            arrows: false,

            asNavFor: '.thumbs'

        });

        $('.gal-box .thumbs').slick({

            slidesToShow: 4,

            slidesToScroll: 1,

            asNavFor: '.main-image',

            dots: true,

            focusOnSelect: true

        });







        $('.product .main').click(function (e) {



            getscrolpos =  $(window).scrollTop();



            e.preventDefault();

            var thi = $(this);



            var img0 = thi.attr('data-im0');

            var img1 = thi.attr('data-im1');

            var img2 = thi.attr('data-im2');

            var img3 = thi.attr('data-im3');

            var hh = thi.attr('data-name');

            var pp = thi.attr('data-des');



            ccitem = thi.parents('.product').find('input');

            var icount = ccitem.val();





            $('.gal-box .galehead h2').html(hh);

            $('.gal-box .galehead p').html(pp);

            $('.gal-box  .img0').attr('src', img0);

            $('.gal-box .img1').attr('src', img1);

            $('.gal-box  .img2').attr('src', img2);

            $('.gal-box  .img3').attr('src', img3);



            $('.gal-bot input').val(icount);







            setTimeout(function(){

            $('.se-popup.imagegal').addClass('show');

            $('body').addClass('allpop-bn');

            },200);



        });



        // $('.gal-box').on('click', '.thumbs img', function (e) {

        //     e.preventDefault();

        //     $('.gal-box .main-image img').attr('src', $(this).attr('src'));

        //

        // });



        $('.gal-bot').on('click', '.add', function (e) {

            e.preventDefault();

            ccitem.val($('.gal-bot input').val());

            $('body').removeClass('allpop-bn');

            $('.se-popup').removeClass('show');

            $(window).scrollTop(getscrolpos);

            updateOffer();

        });



        $('body').on('click', '.pl-groups:not(.offeron) .checkout-btn', function (e) {



            e.preventDefault();

            $('body').removeClass('allpop-bn');

            $('.se-popup').removeClass('show');



        });





    }





};






"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.fixdiscount = {
    VAR: {
        counts: 0, giftwrap: false
    },
    init: function () {
        var _this = this;

        var itemprice = offersaleprice.toFixed(2);
        var itemdiscountprice = (offersaleprice / 2).toFixed(2);

        var totalprice = 0;
        var totaldiscountprice = 0;
        var othercartitems = [];
        var getscrolpos = 0;
        var freeshippingcount = 3;





        jQuery.getJSON('/cart.js', function (cart) {
            //jQuery.getJSON('/cart/clear.js', function (cart) {
            for (var m = 0; m < cart.items.length; m++) {
                if ($('[data-ids=' + cart.items[m].id + ']').length) {
                    $('[data-ids=' + cart.items[m].id + ']').val(cart.items[m].quantity);
                } else {
                    othercartitems.push([cart.items[m].quantity, cart.items[m].title, cart.items[m].line_price, cart.items[m].id]);
                }
            }
            updateOffer();
        });

        var prdocuts = $('[data-ids]');
        var itembox = $('.se-popup.cart .cart-items');

        if($('.se-pop-gift').length)
        {
            $('body').on('click', '.checkout-btn', function (e) {
               e.preventDefault();
               $('.se-pop-gift').addClass('active');
            });

            $('body').on('click', '.se-pop-gift .gotogift', function (e) {
               e.preventDefault();
               $('.se-popup.gift').addClass('active');
                _this.VAR.giftwrap = true;
            });
            $('body').on('click', '.close-btn-new.back-p1', function (e) {
                e.preventDefault();
                $('.se-pop-gift').removeClass('active');
            });
            $('body').on('click', '.close-btn-new.back-2, .gift .cancel-wrap', function (e) {
                e.preventDefault();
                $('.se-popup.gift').removeClass('active');
                _this.VAR.giftwrap = false;


            });
            $('#gift-note').on('keyup', function (e) {
                var count = $(this).val().length;
                var max = $(this).attr('maxlength');
                $('.left-text').text((max - count) + " Characters Remaining");

                var str = $('textarea#gift-note').val();
                str = str.replace(/[^a-zA-Z 0-9 .,\/#@!$%\^&\*;:{}=\-_`~()]+/g, '');
                $('textarea#gift-note').val(str);

            });
            $('#gift-note').trigger('keyup');
        }


        $('body').on('change', prdocuts, function () {
            setTimeout(function () {
                updateOffer();
            }, 100);
        });
        $('body').on('click', '.al-product-counts span', function () {
            setTimeout(function () {
                updateOffer();
            }, 100);
        });


        $('body').on('click', '.pl-groups .addtocart', function (e) {

            e.preventDefault();
            if (!$('.pl-groups').hasClass('offeron')) {
                $('.pl-groups').addClass('needmsg');
                setTimeout(function () {
                    $('.pl-groups').removeClass('needmsg');
                }, 2000);
            } else {
                $('html').addClass('allpop-bn');
                $('.se-popup.cart').addClass('show');
                updatecheckout();
            }
        });


        $('body.page-5for50').on('click', '.nav__cart_car a', function (e) {

            e.preventDefault();
            $('html').addClass('allpop-bn');
            $('.se-popup.cart').addClass('show');


        });



        $('body').on('click', '.close-btn, .inner-pop .msg', function (e) {

            e.preventDefault();
            $('html').removeClass('allpop-bn');
            $('.se-popup').removeClass('show');

            $(window).scrollTop(getscrolpos);


        });




        function updateOffer() {
            itembox.html("");
            var itemcount = 0;
            var preorderitem = false;
            for (var s = 0; s < prdocuts.length; s++) {
                var vals = parseInt(prdocuts.eq(s).val());
                itemcount += vals;

                if (vals > 0) {
                    var name = prdocuts.eq(s).parents('.product').find('img.main').attr('data-name');
                    var preorder = prdocuts.eq(s).parents('.product').find('img.pr-or').length?true:false;
                    var pohtml="";
                    if(preorder)
                    {
                        preorderitem = true;
                        pohtml = "<span class='po-tag'>Pre Order</span>";
                    }
                    var price = (itemprice * vals).toFixed(2);
                    var sale = Math.ceil((price * 100) * ((100 - offerdiscount) / 100)) / 100;

                    itembox.append('<div class="lin-item"><span class="name">' + vals + ' x ' + name +pohtml+'</span><span class="price">$' + price + '</span><span class="sale">$' + sale + '</span></div>');
                }
            }

            if(preorderitem)
            {
                $('.msg-pre-order-cart').show();
            }
            else
            {
                $('.msg-pre-order-cart').hide();
            }
/*
             for (var k = 0; k < othercartitems.length ; k++) {
                 itembox.append('<div class="lin-item"><span class="name">' + othercartitems[k][0] + ' x ' +  othercartitems[k][1] + '</span><span class="price"></span><span class="sale">$' + (othercartitems[k][2]/100).toFixed(2)  + '</span></div>');

             }*/

            $('#preview-bar-iframe').remove();

            totalprice = itemprice * itemcount;
            totaldiscountprice = Math.ceil((totalprice * 100) * ((100 - offerdiscount) / 100)) / 100
            var itemtype = itemcount==1?'ITEM':'ITEMS';

            var icprice = "0 ITEMS - ($0.00)";
            if (itemcount > 0) {
                icprice = itemcount+' '+itemtype+ ' - (<strike>$' + totalprice.toFixed(2) + '</strike> $' + totaldiscountprice.toFixed(2) + ')';
            }

            $('.addtocart .items-details').html(icprice);
            $('.addtocart .msg').html('YOU NEED <span>' + (offerproductmax - itemcount) + '</span> MORE ITEM TO QUALIFY');

            if(freeshippingcount <= itemcount)
            {
                $('.frees-text').text("FREE SHIPPING ADDED");
                $('.ship-total').show();
                $('.ship-on').show();
                $('.ship-off').hide();
            }else
            {
                $('.frees-text').text("ADD "+(freeshippingcount-itemcount)+" MORE AND GET FREE SHIPPING");
                $('.ship-total').hide();
                $('.ship-on').hide();
                $('.ship-off').show();

            }


            if (itemcount >= offerproductmax) {
                $('.pl-groups').addClass('offeron');
                $('.sub-total .price').text('$' + totaldiscountprice.toFixed(2));
                $('.cart-total .price').text('$' + totaldiscountprice.toFixed(2));
            } else {
                $('.pl-groups').removeClass('offeron');
                $('.sub-total .price').text('$' + totalprice.toFixed(2));

                var oneitems = "";
                if (itemcount > 1) oneitems = "s";
                var oneitemsleft = "";
                if ((offerproductmax - itemcount) > 1) oneitemsleft = "s";

                $('.pop-head p.hide-on-offer').html('You have <span>' + itemcount + ' </span> book' + oneitems + ' in your bag. You need to add another <span>' + (offerproductmax - itemcount) + '</span> item' + oneitemsleft + ' to get ' + offerdiscount + '% off and free shipping');

            }

        }

        function updatecheckout() {

            $('.se-popup.cart').removeClass('checkon');
            var ids = "";

            $('[data-ids]').each(function () {
                ids += "updates[" + $(this).attr("data-ids") + "]=" + parseInt($(this).val()) + "&";
            });

            for (var k = 0; k < othercartitems.length ; k++) {
                ids += "updates[" + (othercartitems[k][3] + "]=0&");

            }

            var codel = "aa";

            var endurl = '/discount/' + codel + '?redirect=%2Fcheckout';


            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ids,
                dataType: 'json',
                success: function () {
                    $('.se-popup.cart').addClass('checkon');
                }
            });

        }

        $('.add-btn .chekout-wrap').click(function () {
            _this.VAR.giftwrap = true;
            $('.gotocheckout').trigger('click');
        });

        var wrapp = $('.gotogift').attr('data-giftid');

        $('.gotocheckout').click(function (e) {
            e.preventDefault();

            var ids = "";

            $('.product-list .count').each(function () {
                ids += "updates[" + $(this).attr("data-ids") + "]=" + parseInt($(this).val()) + "&";
            });

            if (_this.VAR.giftwrap) {
                ids += "updates[" + wrapp + "]=" + 1 + "&attributes[gift-wrapping]=true&attributes[gift-note]=" + encodeURIComponent($('#gift-note').val());
            }
            else {
                ids += "updates[" + wrapp + "]=" + 0 + "&attributes[gift-wrapping]=&attributes[gift-note]=";
            }


            var codel;
            var  endurl = '/discount/' + $('[data-code]').attr('data-code') + '?redirect=%2Fcheckout';

            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ids,
                dataType: 'json',
                success: function () {
                    location.href = endurl;
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                    console.log(ajaxOptions);
                }
            });


        });



        //image popup

        var ccitem;


        $('.gal-box .main-image').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.thumbs'
        });
        $('.gal-box .thumbs').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.main-image',
            dots: true,
            focusOnSelect: true
        });



        $('.product .main').click(function (e) {

            getscrolpos =  $(window).scrollTop();

            e.preventDefault();
            var thi = $(this);

            var img0 = thi.attr('data-im0');
            var img1 = thi.attr('data-im1');
            var img2 = thi.attr('data-im2');
            var img3 = thi.attr('data-im3');
            var hh = thi.attr('data-name');
            var pp = thi.attr('data-des');

            ccitem = thi.parents('.product').find('input');
            var icount = ccitem.val();


            $('.gal-box .galehead h2').html(hh);
            $('.gal-box .galehead p').html(pp);
            $('.gal-box  .img0').attr('src', img0);
            $('.gal-box .img1').attr('src', img1);
            $('.gal-box  .img2').attr('src', img2);
            $('.gal-box  .img3').attr('src', img3);

            $('.gal-bot input').val(icount);



            setTimeout(function(){
            $('.se-popup.imagegal').addClass('show');
            $('html').addClass('allpop-bn');
            },200);

        });

        // $('.gal-box').on('click', '.thumbs img', function (e) {
        //     e.preventDefault();
        //     $('.gal-box .main-image img').attr('src', $(this).attr('src'));
        //
        // });

        $('.gal-bot').on('click', '.add', function (e) {
            e.preventDefault();
            ccitem.val($('.gal-bot input').val());
            $('html').removeClass('allpop-bn');
            $('.se-popup').removeClass('show');
            $(window).scrollTop(getscrolpos);
            updateOffer();
        });

        $('body').on('click', '.pl-groups:not(.offeron) .checkout-btn', function (e) {

            e.preventDefault();
            $('html').removeClass('allpop-bn');
            $('.se-popup').removeClass('show');

        });


    }


};



/**
 *created By Nalinda - Home page hero banners
 */


"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.freebookoffer = {
    VAR: {
        $MainContent: $('#MainContent'),
        winwidth: 0,
        heroWidth: 1900,
        heroHeight: 930,
        maxWidth: 1500,
        sliderInterval: 'int',
        sliderCurrent: 0,
        sliderLength: 0
    },
    init: function () {
        var _this = this;

        var itemprice = offersaleprice.toFixed(2);
        var itemdiscountprice = (offersaleprice / 2).toFixed(2);

        var totalprice = 0;
        var totaldiscountprice = 0;
        var othercartitems = [];
        var getscrolpos = 0;


        var prdocuts = $('[data-ids]');
        var itembox = $('.se-popup.cart .cart-items');

        var selectedbookid;


        $('body').on('click', '.freebookcart', function (e) {
            e.preventDefault();
            selectedbookid = $(this).attr('data-ids');
            if($('.se-pop-gift').length)
            {
                $('body').addClass('allpop-bn gw-first');
            }
            else
            {
                updatecheckout(selectedbookid);
            }

        });



        $('body').on('click', '.update.chekout-wrap', function (e) {

            e.preventDefault();
            updatecheckoutwithwrap(selectedbookid);
        });

        $('body').on('click', '.close-btn.popgal', function (e) {

            e.preventDefault();
            $('.se-popup.imagegal').removeClass('show');
            $('body').removeClass('allpop-bn');
        });

        $('body').on('click', '.update.gotogift', function (e) {

            e.preventDefault();
            $('body').addClass('gw-sec');
        });

        $('body').on('click', '.cancel-wrap', function (e) {

            e.preventDefault();
            $('body').removeClass('gw-sec');
        });

        $('body').on('click', '.close-btn-fix.fgfirst,.close-btn-fix.fgsec', function (e) {

            e.preventDefault();
            $('body').removeClass('allpop-bn gw-first gw-sec');
            $(window).scrollTop(getscrolpos);
            $('.se-popup.imagegal').removeClass('show');
        });

        $('body').on('click', '.gotocheckout', function (e) {
            e.preventDefault();
            updatecheckout(selectedbookid);
        });

        $('#gift-note').on('keyup', function (e) {
            var count = $(this).val().length;
            var max = $(this).attr('maxlength');
            $('.left-text').text((max - count) + " Characters Remaining");

            var str = $('textarea#gift-note').val();
            str = str.replace(/[^a-zA-Z 0-9 .,\/#@!$%\^&\*;:{}=\-_`~()]+/g, '');
            $('textarea#gift-note').val(str);

        });
        $('#gift-note').trigger('keyup');

        jQuery.post('/cart/clear.js');

        function updatecheckout(bid) {

            var ids = "";
             if(bid == offerbook)
             {
                 ids += "updates[" + bid + "]=2";
             }
             else
             {
                 ids += "updates[" + bid + "]=1&updates["+offerbook+"]=1";
             }

            for (var k = 0; k < othercartitems.length ; k++) {
                ids += "updates[" + (othercartitems[k][3] + "]=0&");
            }

            var codel = "aa";

            //var endurl = '/discount/' + offerdiscountcode + '?redirect=%2Fcheckout';
            var endurl = '/checkout';


            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ids,
                dataType: 'json',
                success: function () {
                    location.href = endurl;
                }
            });
        }

        function updatecheckoutwithwrap(bid) {

            var ids = "";
             if(bid == offerbook)
             {
                 ids += "updates[" + bid + "]=2";
             }
             else
             {
                 ids += "updates[" + bid + "]=1&updates["+offerbook+"]=1";
             }

            for (var k = 0; k < othercartitems.length ; k++) {
                ids += "updates[" + (othercartitems[k][3] + "]=0&");
            }


            ids += "&updates["+$('[data-wrap-id]').attr('data-wrap-id')+"]=1"+ "&attributes[gift-wrapping]=true&attributes[gift-note]=" + encodeURIComponent($('#gift-note').val());

            var endurl = '/checkout';


            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ids,
                dataType: 'json',
                success: function () {
                    location.href = endurl;
                }
            });
        }


        //image popup

        var ccitem;


        $('.gal-box .main-image').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.thumbs'
        });
        $('.gal-box .thumbs').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.main-image',
            dots: true,
            focusOnSelect: true
        });



        $('.product .main').click(function (e) {

            getscrolpos =  $(window).scrollTop();

            e.preventDefault();
            var thi = $(this);

            var img0 = thi.attr('data-im0');
            var img1 = thi.attr('data-im1');
            var img2 = thi.attr('data-im2');
            var img3 = thi.attr('data-im3');
            var hh = thi.attr('data-name');
            var pp = thi.attr('data-des');

            ccitem = thi.parents('.product').find('input');
            var icount = ccitem.val();


            $('.gal-box .galehead h2').html(hh);
            $('.gal-box .galehead p').html(pp);
            $('.gal-box  .img0').attr('src', img0);
            $('.gal-box .img1').attr('src', img1);
            $('.gal-box  .img2').attr('src', img2);
            $('.gal-box  .img3').attr('src', img3);

            $('.gal-bot .freebookcart').attr('data-ids', $(this).parent().find('.freebookcart').attr('data-ids'));



            setTimeout(function(){
            $('.se-popup.imagegal').addClass('show');
            $('body').addClass('allpop-bn');
            },200);

        });

        // $('.gal-box').on('click', '.thumbs img', function (e) {
        //     e.preventDefault();
        //     $('.gal-box .main-image img').attr('src', $(this).attr('src'));
        //
        // });

        $('.gal-bot').on('click', '.add', function (e) {
            e.preventDefault();
            ccitem.val($('.gal-bot input').val());
            $('body').removeClass('allpop-bn');
            $('.se-popup').removeClass('show');
            $(window).scrollTop(getscrolpos);
            updateOffer();
        });

        $('body').on('click', '.pl-groups:not(.offeron) .checkout-btn', function (e) {

            e.preventDefault();
            $('body').removeClass('allpop-bn');
            $('.se-popup').removeClass('show');

        });


    }


};



/**
 *created By Nalinda - Home page hero banners
 */


"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.freebookoffermulti = {
    VAR: {
        $MainContent: $('#MainContent'),
        winwidth: 0,
        heroWidth: 1900,
        heroHeight: 930,
        maxWidth: 1500,
        sliderInterval: 'int',
        sliderCurrent: 0,
        sliderLength: 0
    },
    init: function () {
        var _this = this;

        var itemprice = offersaleprice.toFixed(2);
        var itemdiscountprice = (offersaleprice / 2).toFixed(2);

        var totalprice = 0;
        var totaldiscountprice = 0;
        var othercartitems = [];
        var getscrolpos = 0;


        var prdocuts = $('[data-ids]');
        var itembox = $('.se-popup.cart .cart-items');

        var selectedbookid;


        $('body').on('click', '.freebookcart', function (e) {
            e.preventDefault();
            selectedbookid = $(this).attr('data-ids');
            if($('.se-pop-gift').length)
            {
                $('body').addClass('allpop-bn gw-first');
            }
            else
            {
                updatecheckout(selectedbookid);
            }

        });

        $('body').on('click', '.stock-wrap .al-product-counts span', function (e) {
            setTimeout(function(){
                var count = 0;
                $('.stock-wrap .al-product-counts input').each(function(){
                    count += parseInt($(this).val());
                });

                var itemp = count>1?" BOOKS":" BOOK";
                if(count == 0)
                {
                    $('.addtocart .items-details').html('0 BOOK - ($0.00)<div>Choose a book to get the free book</div>');
                    $('.pl-groups').removeClass('offeron');
                }
                else
                {
                  var totals = 0;
                  $('.al-product-counts input[type="number"]').each(function() {
                    const count = parseFloat($(this).val());
                    const price = parseFloat($(this).data('price'));
                    totals += count * price;
                  });


                  var dtxt = "<div>Add 2 more book to get free shipping</div>";
                    if(count > 1) dtxt = "<div>Add 1 more book to get free shipping</div>";
                    if(count > 2) dtxt = "<div>Free shipping has been applied</div>";
                    $('.addtocart .items-details').html(count + itemp +" + FREE BOOK - ($"+(totals.toFixed(2))+")"+dtxt);
                    $('.pl-groups').addClass('offeron');
                }
            },100);

        });

        $('body').on('click', '.offeron .checkoutbtn', function (e) {

            var ids = "";
            var offerin = false;
            $('.stock-wrap .al-product-counts input').each(function(){
                var val = parseInt($(this).val());
                var tid = $(this).attr('data-ids');
                if(val > 0)
                {
                    ids += "updates[" + tid + "]="+val+"&";
                    if(tid == offerbook)offerin = true;
                }
            });

            if(offerin)
            {
                ids += "updates["+offerbook+"]=2";

            }else
            {
                ids += "updates["+offerbook+"]=1";
            }



            var endurl = '/discount/'+offerdiscountcode+'?redirect=%2Fcheckout';

            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ids,
                dataType: 'json',
                success: function () {
                    location.href = endurl;
                }
            });


        });



        $('body').on('click', '.update.chekout-wrap', function (e) {

            e.preventDefault();
            updatecheckoutwithwrap(selectedbookid);
        });

        $('body').on('click', '.close-btn.popgal', function (e) {

            e.preventDefault();
            $('.se-popup.imagegal').removeClass('show');
            $('body').removeClass('allpop-bn');
        });

        $('body').on('click', '.update.gotogift', function (e) {

            e.preventDefault();
            $('body').addClass('gw-sec');
        });

        $('body').on('click', '.cancel-wrap', function (e) {

            e.preventDefault();
            $('body').removeClass('gw-sec');
        });

        $('body').on('click', '.close-btn-fix.fgfirst,.close-btn-fix.fgsec', function (e) {

            e.preventDefault();
            $('body').removeClass('allpop-bn gw-first gw-sec');
            $(window).scrollTop(getscrolpos);
            $('.se-popup.imagegal').removeClass('show');
        });

        $('body').on('click', '.gotocheckout', function (e) {
            e.preventDefault();
            updatecheckout(selectedbookid);
        });

        $('#gift-note').on('keyup', function (e) {
            var count = $(this).val().length;
            var max = $(this).attr('maxlength');
            $('.left-text').text((max - count) + " Characters Remaining");

            var str = $('textarea#gift-note').val();
            str = str.replace(/[^a-zA-Z 0-9 .,\/#@!$%\^&\*;:{}=\-_`~()]+/g, '');
            $('textarea#gift-note').val(str);

        });
        $('#gift-note').trigger('keyup');

        jQuery.post('/cart/clear.js');

        function updatecheckout(bid) {

            var ids = "";
            if(bid == offerbook)
            {
                ids += "updates[" + bid + "]=2";
            }
            else
            {
                ids += "updates[" + bid + "]=1&updates["+offerbook+"]=1";
            }

            for (var k = 0; k < othercartitems.length ; k++) {
                ids += "updates[" + (othercartitems[k][3] + "]=0&");
            }

            var codel = "aa";

            //var endurl = '/discount/' + offerdiscountcode + '?redirect=%2Fcheckout';
            var endurl = '/checkout';


            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ids,
                dataType: 'json',
                success: function () {
                    location.href = endurl;
                }
            });
        }

        function updatecheckoutwithwrap(bid) {

            var ids = "";
            if(bid == offerbook)
            {
                ids += "updates[" + bid + "]=2";
            }
            else
            {
                ids += "updates[" + bid + "]=1&updates["+offerbook+"]=1";
            }

            for (var k = 0; k < othercartitems.length ; k++) {
                ids += "updates[" + (othercartitems[k][3] + "]=0&");
            }


            ids += "&updates["+$('[data-wrap-id]').attr('data-wrap-id')+"]=1"+ "&attributes[gift-wrapping]=true&attributes[gift-note]=" + encodeURIComponent($('#gift-note').val());

            var endurl = '/checkout';


            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ids,
                dataType: 'json',
                success: function () {
                    location.href = endurl;
                }
            });
        }


        //image popup

        var ccitem;


        $('.gal-box .main-image').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.thumbs'
        });
        $('.gal-box .thumbs').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.main-image',
            dots: true,
            focusOnSelect: true
        });



        $('.product .main').click(function (e) {

            getscrolpos =  $(window).scrollTop();

            e.preventDefault();
            var thi = $(this);

            var img0 = thi.attr('data-im0');
            var img1 = thi.attr('data-im1');
            var img2 = thi.attr('data-im2');
            var img3 = thi.attr('data-im3');
            var hh = thi.attr('data-name');
            var pp = thi.attr('data-des');

            ccitem = thi.parents('.product').find('input');
            var icount = ccitem.val();


            $('.gal-box .galehead h2').html(hh);
            $('.gal-box .galehead p').html(pp);
            $('.gal-box  .img0').attr('src', img0);
            $('.gal-box .img1').attr('src', img1);
            $('.gal-box  .img2').attr('src', img2);
            $('.gal-box  .img3').attr('src', img3);

            $('.gal-bot .freebookcart').attr('data-ids', $(this).parent().find('.freebookcart').attr('data-ids'));



            setTimeout(function(){
                $('.se-popup.imagegal').addClass('show');
                $('body').addClass('allpop-bn');
            },200);

        });

        // $('.gal-box').on('click', '.thumbs img', function (e) {
        //     e.preventDefault();
        //     $('.gal-box .main-image img').attr('src', $(this).attr('src'));
        //
        // });

        $('.gal-bot').on('click', '.add', function (e) {
            e.preventDefault();
            ccitem.val($('.gal-bot input').val());
            $('body').removeClass('allpop-bn');
            $('.se-popup').removeClass('show');
            $(window).scrollTop(getscrolpos);
            updateOffer();
        });

        $('body').on('click', '.pl-groups:not(.offeron) .checkout-btn', function (e) {

            e.preventDefault();
            $('body').removeClass('allpop-bn');
            $('.se-popup').removeClass('show');

        });


    }


};



/*// =require al-product-catalog/offers/keychain-upsell.js*/

/**

 *created By Nalinda - Home page hero banners

 */



"use strict"



var AL = (typeof AL === 'object') ? AL : {};



AL.bundleheader = {

    VAR: {

        $MainContent: $('#MainContent'),

        winwidth: 0,

        heroWidth: 1900,

        heroHeight: 930,

        maxWidth: 1500,

        sliderInterval: 'int',

        sliderCurrent: 0,

        sliderLength: 0

    },

    init: function () {

        var _this = this;



        // get me a copy







        $(window).on('al-device-changed', function () {



            var newmp4 = $('.hero-sou').attr('data-m');

            if (AL.isdesktop) {

                newmp4 = $('.hero-sou').attr('data-d');

            }



            var videocontainer = $('.hero-vid');

            var videosource = $('.hero-sou');

            //videocontainer = document.getElementById('hero-vid');

            //videosource = document.getElementById('hero-sou');

            //var newposter = 'images/video-cover.jpg';



           // var videobutton = document.getElementById("myVideo");





            videocontainer.get(0).pause();

            videosource.get(0).setAttribute('src', newmp4);

            videocontainer.get(0).load();

            //videocontainer.setAttribute('poster', newposter); //Changes video poster image

            videocontainer.get(0).play();

        });



        $(window).on('al-width-changed', function () {



            if (AL.isdesktop) {

                _this.changeHeroWidthDesk();

            }

            else {

                _this.changeHeroWidthMob();

            }

        });

        var hcall = AL.isdesktop ? _this.changeHeroWidthDesk() : _this.changeHeroWidthMob();



        var featuredText = $('.page-al-product-landing .feature-quote .f-text h5').text();







        // _this.simpleAnimation(true);

        //





        $('body').on('click','.hero-btn .tobundle',function(e){



            e.preventDefault();

            if(AL.isdesktop)

            {

                AL.common.scrollTo($(".bundle-offer-section"), 100, 300);

            }

            else

            {

                AL.common.scrollTo($(".bundle-offer-section"), 40, 300);

            }

        });



        $('.al-circle-btn').click(function () {

            if(AL.isdesktop)

            {

                AL.common.scrollTo($(".bundle-offer-section"), 100, 300);

            }

            else

            {

                AL.common.scrollTo($(".bundle-offer-section"), 40, 300);

            }



        });



        $('.product-landing.friday .videolink').click(function (e) {

            e.preventDefault();

            if(AL.isdesktop)

            {

                AL.common.scrollTo($(".bundle-offer-section"), 100, 300);

            }

            else

            {

                AL.common.scrollTo($(".bundle-offer-section"), 40, 300);

            }



        });

        //_this.simpleAnimation(true);

        _this.callevents();







    },



    changeHeroWidthDesk: function () {



        var _this = this;

        var hei = $(window).height() - 80 - 40;

        var wid = $('#MainContent').width();



        if (hei / wid > 618 / 1366) {

            hei = wid * (618 / 1366);

        }



        if($('.product-landing.friday').length)

        {

            if (hei / wid > 500 / 1920) {

                hei = wid * (500 / 1920);

            }

        }



        // setting up banner height



        $('.bundle-hero-wrap').height(hei);

        $('.al-pl-hero').height(hei);

        $('.al-pl-slide').height(hei);

        $('.bg-anim-wrap').height(hei);



        $('.sale-icon').css('top','');



        var imagewid = hei * (_this.VAR.heroWidth / _this.VAR.heroHeight);



        // set width for image

        $('.al-pl-slide').eq(_this.VAR.sliderCurrent).addClass('show');

        $('.al-pl-slide img').width(imagewid);



        var scales = hei / 780;

        scales = scales > 1 ? 1 : scales;



        $('.al-pl-inside').css('transform', 'scale(' + scales + ')');

    },



    changeHeroWidthMob: function () {





        var _this = this;

        var hei = $(window).height() - 42;

        var wid = $(window).width();



        $('.bundle-hero-wrap').css('minHeight',hei + "px");

        $('.bundle-hero-wrap').css('height',"auto");

        $('.al-pl-hero').height(wid);



        if($('.product-landing.friday').length) {

            $('.bundle-hero-wrap').css('minHeight', "");

            $('.al-pl-hero').height(wid *(476/450));

        }



        $('.al-pl-cart').css('min-height', (hei - wid) + "px");



        if (wid < 375) {

            $('.al-pl-inside').css('transform', 'scale(' + wid / 375 + ')');

        }

        else {

            $('.al-pl-inside').css('transform', 'none');

        }





        if( hei < ($('.bundle-hero-wrap').height()+ $('.al-pl-cart').height()) )

        {

            $('.al-pl-hero').height(hei - $('.al-pl-cart').height());

        }



    },





    simpleAnimation: function (start) {



        var _this = this;

        var _thisv = this.VAR;

        _this.VAR.sliderLength = $('.al-pl-slide').length;



        if (_this.VAR.sliderInterval !== "int") {

            clearInterval(_this.VAR.sliderInterval);

        }



        _this.VAR.sliderInterval = setInterval(function () {

            _this.VAR.sliderCurrent++;

            if (_this.VAR.sliderCurrent >= _this.VAR.sliderLength) {

                _this.VAR.sliderCurrent = 0;

            }

            $('.al-pl-slide').removeClass('show');

            $('.al-pl-slide').eq(_this.VAR.sliderCurrent).addClass('show');



        }, 5000);





    },



    callevents: function () {



    }





};






/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.bundleproduct = {
    VAR: {
        $MainContent: $('#MainContent'),
        winwidth: 0,
        heroWidth: 1900,
        heroHeight: 930,
        maxWidth: 1500,
        sliderInterval: 'int',
        sliderCurrent: 0,
        sliderLength: 0
    },
    init: function () {
        var _this = this;


        $('.b-slider').slick({
            infinite: false,
            speed: 300,
            arrows:true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover:false,
            fade: false,nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve"> <polygon id="XMLID_4_" style="fill:#000000;" points="27.5,3.5 18.1,12.9 47.1,42 18.1,71.1 27.5,80.5 65.9,42 "/> </svg></div>',
            prevArrow: '<div class="hero-prev hero-btn" ><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
                '\t viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve">\n' +
                '<polygon id="XMLID_4_" style="fill:#000000;" points="56.5,80.5 65.9,71.1 36.9,42 65.9,12.9 56.5,3.5 18.1,42 "/>\n' +
                '</svg></div>',
            // cssEase: 'linear',
            autoplay:false,autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        fade: false,dots: true,arrows:false

                    }
                }
            ]
        }).on('afterChange', function() {
            var cur = $(this).find('.slick-current');
            $(this).find('video').each(function(){
                $(this).get(0).pause();
            })

            if(cur.find('video').length)
            {
                cur.find('video').get(0).play();
            }

        });

        $('.b-product .items').click(function(){

            $('[data-handle='+$(this).attr('data-name')+']').trigger('click');
            AL.popups.loadpop('.products-all');
            $('body').addClass('product-view');

        });

        $(document).on('click', '.product-view .close-btn.pclose' , function (e) {
            e.preventDefault();
            AL.popups.hideall();
        });














        $(window).on('al-device-changed', function () {

            if (AL.isdesktop) {

            }
        });

        $(window).on('al-width-changed', function () {

            if (AL.isdesktop) {

            }
            else {

            }
        });




        $('.al-v2-hero-wrap .al-circle-btn').click(function () {
            AL.common.scrollTo($(".shopify-section .feature-quote"), 100, 300);
        });




    }




};




"use strict"



var AL = (typeof AL === 'object') ? AL : {};



AL.collection = {

    VAR: {},

    init: function () {

        var _this = this;



        // adding scroll

        $('.dbodywrap').mCustomScrollbar({

            mouseWheel: {preventDefault: true}

        });



        if($('.dropbody.sort li.active').length)

        {

            $('.droptitle.sort').text($('.dropbody.sort li.active').text());



        }



        $('.droptitle').click(function (e) {

            e.preventDefault();

            e.stopPropagation();



            var targ = $(this).parent().find(".dropbody." + $(this).data('target'));

            $(this).toggleClass("active");

            targ.toggleClass("active-target");



            if (!$(this).hasClass('active')) {

                targ.slideUp();

            }

            else {

                targ.slideDown();

            }



        });





    },



    navChange: function () {



    }

};


"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.product = {
    VAR: {},
    init: function () {
        var _this = this;
        $('.mobmenua>a').click(function (e) {
        });

        $('.b-product .items').click(function(){

            $('[data-handle='+$(this).attr('data-name')+']').trigger('click');
            AL.popups.loadpop('.products-all');
            $('body').addClass('product-view');

        });


        $('.product-top .gallery .image .al-gallery-big').slick({

            slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: false,
            asNavFor: '.thumbs .thumb-slick', arrows: false,

            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        dots: true
                    }
                }
            ]
        });


        $(window).on('al-device-changed', function () {
            if (AL.isdesktop) {
                var $easyzoom = $('.easyzoom').easyZoom();
                var api = $easyzoom.data('easyZoom');
            }
        });


        $('.thumbs .thumb-slick').slick({

            vertical: true, slidesToShow: 6, slidesToScroll: 1,
            appendArrows: $(".slick-arrow-wrap"),
            prevArrow: '<div class="pd_prev"></div>',
            nextArrow: '<div class="pd_next"></div>',
            asNavFor: '.product-top .gallery .image .al-gallery-big',
            focusOnSelect: true, infinite: true, responsive: [
                {
                    breakpoint: 750,
                    settings: "unslick"
                }
            ]
        });


        $('.product-top .droptitle').click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            var targ = $(this).parent().find(".dropbody");
            $(this).toggleClass("active");
            targ.toggleClass("active-target");

            if (!$(this).hasClass('active')) {
                targ.slideUp();
            }
            else {
                targ.slideDown();
            }

        });

        $('.product-top .dbodywrap').mCustomScrollbar({
            mouseWheel: {preventDefault: true}
        });

        $(window).on('al-width-changed', function () {
            $('.al-banner iframe').height($('.al-banner iframe').width() * (360/640));
            if (AL.isdesktop) {
               // _this.changeHeroWidthDesk();
            }
            else {
                _this.changeScreen();
            }
        });


        // descrption accordian
        $('.des-title.active').next().show();

        $('.des-title').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            if ($(this).hasClass('active')) {
                $(this).next().slideDown();
            }
            else
            {
                $(this).next().slideUp();
            }
        });

        //youtube next preview

        $('.youtubeplayer .nepr.next').click(function(){
            player.nextVideo();
        });
        $('.youtubeplayer .nepr.prev').click(function(){
            player.previousVideo();
        });

        //popup
        var cpop;

        $('.product.stock-wrap img.main').click(function (e) {

            e.preventDefault();
            var _this = $(this).parent().find('.main').eq(0);
            $('.se-popup.detail').addClass('active');

            cpop = _this.parents('.product').index();
            var imgset = "";
            if (_this.attr('data-im1') != "") {
                imgset += '<div><img src="' + _this.attr('data-im1') + '" /></div>';
            }
            if (_this.attr('data-im2') != "") {
                imgset += '<div><img src="' + _this.attr('data-im2') + '" /></div>';
            }
            if (_this.attr('data-im3') != "") {
                imgset += '<div><img src="' + _this.attr('data-im3') + '" /></div>';
            }


            $('.se-popup.detail .inner-pop h4').html(_this.attr('data-name'));
            $('.se-popup.detail .inner-pop .dis').html(_this.attr('data-des'));
            $('.se-popup.detail .pop-gal-wrap').html('<div class="pop-gal">' + imgset + '</div>');
            $('button.back').hide();

            $('.pop-gal').slick({
                nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve"><g id="arrows_overlay" transform="translate(-50 -393)"><path style="fill:#FFFFFF" id="if_basics-08_296826" class="st0" d="M71.5,473.8l37.7-38.8l-37.7-39l1.2-2l39.8,41l-39.8,41L71.5,473.8z"/></g></svg></div>',
                prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve"><g id="arrows_overlay" transform="translate(-50 -393)"><path  style="fill:#FFFFFF" id="if_basics-08_296826" class="st0" d="M112.5,396.2L74.8,435l37.7,39l-1.2,2l-39.8-41l39.8-41L112.5,396.2z"/></g></svg></div>',
                autoplay: true, cssEase: 'linear'
            });
            var cinput = _this.parent().find('.count');
            $('.count.selected').removeClass('selected');
            cinput.addClass('selected');
            $('.se-popup.detail .count-pop').val(cinput.val());
            $('.se-popup.detail .stock').text(_this.parent().find('.stokcs').text());

        });

        $(document).on('click', '.product-view .close-btn.pclose' , function (e) {
            e.preventDefault();
            AL.popups.hideall();
        });

    },

    changeScreen: function () {

        var _this = this;
        var hei = $(window).height() - 42;
        var wid = $(window).width();

       // $('.details form,.details .pdp-bb-form').css('min-height', (hei - wid) + "px");


    },


    cartUpdate: function (arr) {

    }
};


"use strict"



var disamount = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];

var discodes  = "20off-books";





var AL = (typeof AL === 'object') ? AL : {};



AL.cart = {

    VAR: {},

    init: function () {



        var _this = this;

        $('.al-product-counts span').on("click", function() {

            setTimeout(function(){

                $('.al-cart-btn .updatecart').trigger('click');

            },100);

        });



        _this.discountCart();





    },



    discountCart: function () {



        var totprice = 0;

        var disprice = 0;

        var bookprice =19.95;

        var firstbookprice = 24.95;

        var from2ndbookprice =  15.96;

        var fromLastCount =  15.96;

        var firstgone = false;





        var discountedprice =  15.96;



       $('.btn-wrap').append('<input type="button" class="btn checkout discount" value="Check Out" />');





       var discarray = $('[data-dis-ids]').attr('data-dis-ids').split(',');



       // alert(discarray.length);



        // disamount discodes

        var counts = 0;

        $('[data-pd-id]').each(function(){



            var _th = $(this);

             for (var f = 0; f < discarray.length-1 ; f++) {

                 if(discarray[f] == $(this).attr('data-pd-id'))

                 {

                     counts   += parseInt($(this).val());

                     _th.parents('.item-details-wrap').addClass('discounted-books');

                 }

              }

        });





        $('.discounted-books').each(function () {

            $(this).removeClass('added');

            var img = $(this).parents('.product').find('.main');

            var val = $(this).find('.count').val();

            var thisprice = $(this).attr("data-price");

            totprice += parseInt($(this).val()) * bookprice;

            var roundprice = 0;





            disprice += roundprice;



                if(counts > 1)

                {

                    $(this).find('.item-price.final .mon').text('$'+(discountedprice*val).toFixed(2));

                    $(this).find('.item-price.final').attr('data-pr-total',(discountedprice*val).toFixed(2));

                    $(this).find('.item-price.line').addClass('offer');

                }else

                {

                    $(this).find('.item-price.final .mon').text('$'+(bookprice*val).toFixed(2));

                    $(this).find('.item-price.final').attr('data-pr-total',(bookprice*val).toFixed(2));

                    $(this).find('.item-price.offer').text('');

                }







                $(this).addClass('added');

                firstgone = true;

        });



        //get total price

        var totalcart = 0;

        $('.item-price.final').each(function(){

            var pr = parseFloat($(this).attr('data-pr-total'),10);

            totalcart += pr;



        });





        $('.price .mo .tot').text('$'+totalcart.toFixed(2));



       $('.cart-items-wrap').addClass('show');



        $('.btn.checkout.discount').click(function(e){

            e.preventDefault();



            var codel;



            var endurl = '/checkout';



            if (counts >= 3) {

                endurl = '/discount/' + discodes + '?redirect=%2Fcheckout';

            }





            jQuery.ajax({

                type: 'POST',

                url: '/cart/update.js',

                data: endurl,

                dataType: 'json',

                success: function () {

                    location.href = endurl;

                }

            });



        });









    },





    navChange: function () {



    }

    //

};




/*cart-2019.js*/

"use strict"



var AL = (typeof AL === 'object') ? AL : {};



AL.giftwrap = {

    VAR: {},

    init: function () {









        //check the giftwraping count and if user click remove button it will trigger cehckbox for gift wrapping

        if(giftwrapsincart > 0)

        {

            $('.cart-item').each(function(){

                if($(this).find('.item-name').text() == "Gift Wrapping and Personalised Card")

                {

                    $(this).find('.close-ani-btn').click(function(e){

                        e.preventDefault();

                        Shopify.Cart.GiftWrap.remove();

                    });

                }

            });

        }



        // If we have nothing but gift-wrap items in the cart.

        /*

        if (cartitemsize == 1 && giftwrapsincart > 0) {

            Shopify.Cart.GiftWrap.remove();

        }

        else if(giftwrapsincart > 1)

        {

            Shopify.Cart.GiftWrap.set();

        }

        else if(giftwrapsincart > 0 && !giftwrapattr )

        {

            Shopify.Cart.GiftWrap.set();

        }

        else if(giftwrapsincart == 0 && giftwrapattr )

        {

            Shopify.Cart.GiftWrap.set();

        }

        */















        $('#gift-note').on('keyup', function (e) {

           var count = $(this).val().length;

           var max = $(this).attr('maxlength');

           $('.left-text').text((max-count) + " Characters Remaining");



            var str = $('textarea#gift-note').val();

            str = str.replace(/[^a-zA-Z 0-9 .,\/#!$%\^&\*;:{}=\-_`~()]+/g, '');

            $('textarea#gift-note').val(str);





        });

        $('#gift-note').trigger('keyup');

    }

};




"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.login = {
    VAR: {},
    init: function () {

        //validation
        $('.loginbtn').click(function (e) {

            var validation = true;
            if (!validateEmail($('#CustomerEmail').val()) || $('#CustomerEmail').val() == "") {
                validation = false;
                $('#CustomerEmail').addClass('errors');
            }
            if ($('#CustomerPassword').val() == "") {
                validation = false;
                $('#CustomerPassword').addClass('errors');
            }
            if (!validation) {
                e.preventDefault();
            }
        });

        $('.registerbtn').click(function (e) {
            $('#create_customer .vali').removeClass('errors');

            var validation = true;

            $('#create_customer .vali').each(function(){

                if($(this).val() == "")
                {
                    validation = false;
                    $(this).addClass('errors');
                }
            });

            if($('#CreatePassword').val() != $('#passCheck').val())
            {
                validation = false;
                $('#passCheck').addClass('errors');
            }


            if (!validateEmail($('#Email').val()) || $('#Email').val() == "") {
                validation = false;
                $('#Email').addClass('errors');
            }



            if (!validation) {
                e.preventDefault();
            }


        });





        function validateEmail($email) {
            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            return emailReg.test($email);
        }


    }
};


"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.faq = {
    VAR: {},
    init: function () {


        $('.faq-title').each(function (i, e) {

            $('.faq-links-in').append("<div class='faq-l'><a href='#faq" + i + "'>" + $(this).text() + "</a></div>");
            $('.faq-title').eq(i).attr('id', "faq" + i);

        });


        $('.faq-item-title').click(function () {

            $('.faq-item-wrap').slideUp();
            if ($(this).find('.plus-minus-round').hasClass('active')) {
                $('.faq-group-wrap').find('.plus-minus-round').removeClass('active');
            }
            else {
                $('.faq-group-wrap').find('.plus-minus-round').removeClass('active');
                $(this).next().stop().slideDown();
                $(this).find('.plus-minus-round').addClass('active');
            }
        });

        var faqitem;
        $('.faq-title').click(function () {
            faqitem = $(this);
            if(!AL.isdesktop)
            {
                $('.faq-group-wrap').slideUp();
                if ($(this).find('.up-down-arrow').hasClass('active')) {
                    $('.up-down-arrow').removeClass('active');
                }
                else {
                    $('.up-down-arrow').removeClass('active');
                    $(this).next().stop().slideDown();
                    $(this).find('.up-down-arrow').addClass('active');
                }
                setTimeout(function(){
                    AL.common.scrollTo(faqitem, 120, 300);
                },500);

            }


        });


        $('.faq-l a').click(function (e) {
            e.preventDefault();
            AL.common.scrollTo($($(this).attr('href')), 120, 300);
        });
        //change the title color

        $(window).on('alscroll', function (a, b) {

            checkPos(b);
        });
        checkPos(window.pageYOffset);

        function checkPos(scrolls) {
            var pos = 0;
            $('.faq-title').each(function () {
                if ($(this).offset().top < (scrolls + 130)) {
                    pos = $(this).index('.faq-title');
                }
            });

            $('.faq-l').removeClass('active');
            $('.faq-l').eq(pos).addClass('active');

        }


    },

    changeScreen: function () {


    },


    navChange: function () {

    }
};


"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.contact = {
    VAR: {},
    init: function () {



        $('.contact.btn').click(function (e) {
           $(this).parents('form').find('.vali').removeClass('errors');

            var validation = true;

            $(this).parents('form').find('.vali').each(function(){

                if($(this).val() == "" || !$(this).val())
                {
                    validation = false;
                    $(this).addClass('errors');
                }
            });

            if (!validateEmail($('.emailVali').val()) || $('.emailVali').val() == "") {
                validation = false;
                $('.emailVali').addClass('errors');
            }




            if (!validation) {
                e.preventDefault();
            }


        });





        function validateEmail($email) {
            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            return emailReg.test($email);
        }


    }
};


$(document).ready(function(){


    var $addToCartBtn = $('[data-ajax-add]');


    $('body').on('click','[data-ajax-add]:not(".pend")',(function(e) {

        e.preventDefault();
        var $btn = $(this);
        $btn.addClass('pend');
        var datas= 'id='+$btn.attr('data-ajax-add') + "&quantity=1";

        // Add to cart.
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: datas,
            success: function(itemData) {
                $btn.removeClass('pend');
                $('body').append('<div class="cart-added"><div class="box"><a class="close" href="#"></a><h2>IT\'S IN THE BAG</h2><a class="cont" href="#">Continue Shopping</a><a href="/cart" class="checkout"><span>CHECKOUT OUT NOW</span></a></div></div>');
                setTimeout(function(){
                    $('.cart-added').addClass('open');
                },100);

            },
            error: function(XMLHttpRequest) {
                //console.log(XMLHttpRequest);
                $btn.removeClass('pend');
            }
        });
        return false;


    }));




    $('body').on('click','.cart-added .close,.cart-added .cont',function(e){
        e.preventDefault();
        $('.cart-added').removeClass('open');
        setTimeout(function(){
            $('.cart-added').remove();
        },1000);

    });









});
"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.feedback = {
    VAR: {},
    init: function () {


    }
};




/**


 *created By Nalinda - Home page hero banners


 */





"use strict"





var AL = (typeof AL === 'object') ? AL : {};





AL.blackfriday = {


    VAR: {





    },


    init: function () {





        var minbooks = 1;


        var counts = 0;


        var cpop = 0;


        var giftwrap = false;


        var wrapp = $('.gotogift').attr('data-giftid');


        var dispre = 0.84;


        //full change


        dispre = 1;


        //full change-end


        var bookprice = 29.95;





        //load carts


        jQuery.getJSON('/cart.js', function (cart) {


            for (var m = 0; m < cart.items.length; m++) {


                $('[data-ids=' + cart.items[m].id + ']').val(cart.items[m].quantity);


            }


            updatePrice();


        });








        $('.se-info').html('<b>PLEASE CHOOSE YOUR BOOK BELOW</b>');





        $(document).on("click", ".se-popup.detail .al-product-counts span", function () {


            setTimeout(function () {


                $('.count.selected').val($('.se-popup.detail .al-product-counts .count-pop').val());


                updatePrice();


            }, 100);


            $('button.back').show();





        });








        $(document).on("change, mouseup, keyup", ".count", updatePrice);


        $(document).on("click", ".product .al-product-counts span", updatePrice);








        var inters = setTimeout(function () {


        }, 100);








        function updatePrice() {





            var prices = 0;


            counts = 0;





            var totprice = 0;


            var disprice = 0;


            var disforthis = dispre;





            var _this = this;





            var minbooks = 0;





            var bookprice = 19.95;


            var firstbookprice = 19.95;


            var from2ndbookprice = 12.95;


            var fromLastCount = 13.3;





            var disamount = [0,7,14,21,28,35,42,49,56,63,70,77,84,91,98,105,112,119,126,133,140];


            var firstgone = false;








            $('.count').each(function () {


                counts += parseInt($(this).val());


            });





            if(counts<2)


            {


                disforthis = 1;


            }





            $('.se-popup.cart .list').html("");





            $('.count').each(function () {





                $(this).removeClass('added');


                var img = $(this).parents('.product').find('.main');


                var val = $(this).val();


                var thisprice = $(this).attr("data-price");


                totprice += parseInt($(this).val()) * bookprice;


                var roundprice = 0;





                if (val > 0) {


                    if (counts <= disamount.length) {


                        if (!firstgone) {


                            roundprice = firstbookprice + (from2ndbookprice * (val - 1));


                        }


                        else {


                            roundprice = from2ndbookprice * val;


                        }


                    }


                    else {


                        roundprice = fromLastCount * val;


                    }


                }


                disprice += roundprice;

















                if (val > 0) {


                    $('.se-popup.cart .list').append('<div class="item"><div class="p-name">'+val+' x '+img.attr("data-name")+'</div><div class="n-price">$'+(bookprice*val).toFixed(2)+'</div><div class="s-price">$'+roundprice.toFixed(2)+'</div></div>');


                    $(this).addClass('added');





                    firstgone = true;





                }





            });














            if (counts == 0) {


                $('.se-info').html('<b>PLEASE CHOOSE YOUR BOOK BELOW</b>');


                $('.se-button button').removeClass('active');


                $('.total .total-price').text(0);


                $('.product .price-tag').attr('src',$('.product .price-tag').attr("data-first"));


            }


            else {


                $('.se-button button').addClass('active');


                $('.product .price-tag').attr('src',$('.product .price-tag').attr("data-second"));





                $('.se-info').html('<b>' + counts + ' x '+(counts===1?"BOOK":"BOOKS")+':  <strike>$' + totprice.toFixed(2) + '</strike> <span class="text-hilight">$' + disprice.toFixed(2) + '</span> (Save Over '+Math.floor((1-(disprice/totprice))*100)+'%)</b>');





                $('.total .total-price').text(disprice.toFixed(2));














                $('.animate.complete img').attr('src', '');


                $('.animate.complete img').attr('src', $('.animate.complete img').attr('data-src'));


                $('.animate.complete').show();


                clearTimeout(inters);


                inters = setTimeout(function () {


                    $('.animate.complete').hide();


                    $('.animate.complete img').attr('src', '');


                }, 6000);


            }


        }





        $('.click').click(function (e) {


            e.preventDefault();


            if($(this).hasClass('active'))


            {


                $('.se-popup.cart').addClass('show');


            }


        });





        $('.gotocheckout').click(function (e) {





            e.preventDefault();


            var discodes = ["1-book-$0discount","2-book-$7discount","3-book-$14discount","4-book-$21discount","5-book-$28discount","6-book-$35discount","7-book-$42discount","8-book-$49discount","9-book-$56discount","10-book-$63discount","11-book-$70discount","12-book-$77discount","13-book-$84discount","14-book-$91discount","15-book-$98discount","16-book-$105discount","17-book-$112discount","18-book-$119discount","19-book-$126discount","20-book-$133discount","21-book-all-discount"];








            if($('.se-popup.detail').hasClass('show'))


            {


                $('.se-popup.detail').removeClass('show');


                return;


            }


            else if (counts < minbooks) {


                return;


            }





            var ids = "";





            $('.count').each(function () {


                ids += "updates[" + $(this).attr("data-ids") + "]=" + parseInt($(this).val()) + "&";


            });





            if(giftwrap)


            {


                ids += "updates[" + wrapp + "]=" + 1 + "&attributes[gift-wrapping]=true&attributes[gift-note]="+$('#gift-note').val();


            }


            else


            {


                ids += "updates[" + wrapp + "]=" + 0 + "&attributes[gift-wrapping]=&attributes[gift-note]=";


            }





            var codel;


            if(counts >= discodes.length)


            {


                codel = discodes[discodes.length-1];


            }


            else


            {


                codel = discodes[counts-1];


            }





            var endurl = '/discount/' + codel + '?redirect=%2Fcheckout';





            jQuery.ajax({


                type: 'POST',


                url: '/cart/update.js',


                data: ids,


                dataType: 'json',


                success: function () {


                    location.href = endurl;


                }


            });








        });








        $(document).on('click', '.close-btn.desk', function () {


            $('.se-popup.detail').removeClass('show');


            $('.se-popup.cart').removeClass('show');


        });


        $(document).on('click', '.close-btn.back', function () {


            $('.se-popup.gift').removeClass('show');


            $('.se-popup.cart').addClass('show');


        });


        $('.add-btn .gotogift').click(function(){


            $('.se-popup.gift').addClass('show');


        });


        $('.add-btn .chekout-wrap').click(function(){


            giftwrap = true;


            $('.gotocheckout').trigger('click');


        });


        $('.add-btn .cancel-wrap ').click(function(){


            $('.se-popup.gift').removeClass('show');


            $('.se-popup.cart').addClass('show');


        });





        $('.se-popup').mCustomScrollbar();





        $('#gift-note').on('keyup', function (e) {


            var count = $(this).val().length;


            var max = $(this).attr('maxlength');


            $('.left-text').text((max-count) + " Characters Remaining");


        });


        $('#gift-note').trigger('keyup');





        $(document).on('click', '.se-pop-head .next', function () {


            cpop++;


            if(cpop >= $('.product-list .product').length)


            {


                cpop = 0;


            }


            $('.product-list .product').eq(cpop).find('img.main').trigger('click');


        });


        $(document).on('click', '.se-pop-head .prev', function () {


            cpop--;


            if(cpop < 0)


            {


                cpop = $('.product-list .product').length-1;


            }


            $('.product-list .product').eq(cpop).find('img.main').trigger('click');


        });





        $(document).on('click', 'button.back', function () {


            $('.se-popup.detail').removeClass('show');


        })











        $('.product.stock-wrap img.main').click(function (e) {





            e.preventDefault();


            var _this = $(this).parent().find('.main').eq(0);


            $('.se-popup.detail').addClass('show');





            cpop = _this.parents('.product').index();


            var imgset = "";


            if (_this.attr('data-im1') != "") {


                imgset += '<div><img src="' + _this.attr('data-im1') + '" /></div>'


            }


            if (_this.attr('data-im2') != "") {


                imgset += '<div><img src="' + _this.attr('data-im2') + '" /></div>'


            }


            if (_this.attr('data-im3') != "") {


                imgset += '<div><img src="' + _this.attr('data-im3') + '" /></div>'


            }





            //  $('.se-popup.detail .inner-pop').html('<div class="se-pop-head"><span class="next"><img class="country_arrow" src="{{ 'icon - arrow.svg' | asset_url }}"></span></span><h4>' + _this.attr('data-name') + '</h4><span class="prev"></span></div>' + _this.attr('data-des') + '<div class="pop-gal">' + imgset + '</div>');





            $('.se-popup.detail .inner-pop h4').html(_this.attr('data-name'));


            $('.se-popup.detail .inner-pop .dis').html(_this.attr('data-des'));


            $('.se-popup.detail .pop-gal-wrap').html('<div class="pop-gal">'+imgset+'</div>');


            $('button.back').hide();





            $('.pop-gal').slick({


                nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve"><g id="arrows_overlay" transform="translate(-50 -393)"><path style="fill:#FFFFFF" id="if_basics-08_296826" class="st0" d="M71.5,473.8l37.7-38.8l-37.7-39l1.2-2l39.8,41l-39.8,41L71.5,473.8z"/></g></svg></div>',


                prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 84 84" style="enable-background:new 0 0 84 84;" xml:space="preserve"><g id="arrows_overlay" transform="translate(-50 -393)"><path  style="fill:#FFFFFF" id="if_basics-08_296826" class="st0" d="M112.5,396.2L74.8,435l37.7,39l-1.2,2l-39.8-41l39.8-41L112.5,396.2z"/></g></svg></div>',


                autoplay: true, cssEase: 'linear'


            });


            var cinput = _this.parent().find('.count');


            $('.count.selected').removeClass('selected');


            cinput.addClass('selected');


            $('.se-popup.detail .count-pop').val(cinput.val());


            $('.se-popup.detail .stock').text(_this.parent().find('.stokcs').text());








        });


        //$(window).on('alscroll', function (a, b, c) {


        $(window).on('scroll', function () {





            if(window.pageYOffset >  ($('.fix-top').height()-$('.se-info').outerHeight()))


            {


                $('.fix-top').addClass('fixs');


            }


            else


            {


                $('.fix-top').removeClass('fixs');





            }


            if(window.pageYOffset > 0)


            {


                $('.fix-top').addClass('scrolled');


            }


            else


            {


                $('.fix-top').removeClass('scrolled');


            }








        });





    }








};

















$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  //adding call


//return




});
